var $jscomp = $jscomp || {};
$jscomp.scope = {};
/** @type {boolean} */
$jscomp.ASSUME_ES5 = false;
/** @type {boolean} */
$jscomp.ASSUME_NO_NATIVE_MAP = false;
/** @type {boolean} */
$jscomp.ASSUME_NO_NATIVE_SET = false;
/** @type {Function} */
$jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function (ctx, name, opt_attributes) {
    if (ctx != Array.prototype) {
        if (ctx != Object.prototype) {
            ctx[name] = opt_attributes.value;
        }
    }
};
/**
 * @param {Object} dataAndEvents
 * @return {?}
 */
$jscomp.getGlobal = function (dataAndEvents) {
    return "undefined" != typeof window && window === dataAndEvents ? dataAndEvents : "undefined" != typeof global && null != global ? global : dataAndEvents;
};
$jscomp.global = $jscomp.getGlobal(this);
/** @type {string} */
$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
/**
 * @return {undefined}
 */
$jscomp.initSymbol = function () {
    /**
     * @return {undefined}
     */
    $jscomp.initSymbol = function () {
    };
    if (!$jscomp.global.Symbol) {
        $jscomp.global.Symbol = $jscomp.Symbol;
    }
};
$jscomp.Symbol = function () {
    /** @type {number} */
    var k = 0;
    return function (classNames) {
        return $jscomp.SYMBOL_PREFIX + (classNames || "") + k++;
    };
}();
/**
 * @return {undefined}
 */
$jscomp.initSymbolIterator = function () {
    $jscomp.initSymbol();
    var methodName = $jscomp.global.Symbol.iterator;
    if (!methodName) {
        methodName = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator");
    }
    if ("function" != typeof Array.prototype[methodName]) {
        $jscomp.defineProperty(Array.prototype, methodName, {
            configurable: true,
            writable: true,
            /**
             * @return {?}
             */
            value: function () {
                return $jscomp.arrayIterator(this);
            }
        });
    }
    /**
     * @return {undefined}
     */
    $jscomp.initSymbolIterator = function () {
    };
};
/**
 * @param {Array} items
 * @return {?}
 */
$jscomp.arrayIterator = function (items) {
    /** @type {number} */
    var index = 0;
    return $jscomp.iteratorPrototype(function () {
        return index < items.length ? {
            done: false,
            value: items[index++]
        } : {
            done: true
        };
    });
};
/**
 * @param {Object} nextState
 * @return {?}
 */
$jscomp.iteratorPrototype = function (nextState) {
    $jscomp.initSymbolIterator();
    nextState = {
        next: nextState
    };
    /**
     * @return {?}
     */
    nextState[$jscomp.global.Symbol.iterator] = function () {
        return this;
    };
    return nextState;
};
/**
 * @param {?} context
 * @return {?}
 */
$jscomp.makeIterator = function (context) {
    $jscomp.initSymbolIterator();
    var iterator = context[Symbol.iterator];
    return iterator ? iterator.call(context) : $jscomp.arrayIterator(context);
};
/**
 * @param {Node} stream
 * @return {?}
 */
$jscomp.arrayFromIterator = function (stream) {
    var param;
    /** @type {Array} */
    var passedParams = [];
    for (; !(param = stream.next()).done;) {
        passedParams.push(param.value);
    }
    return passedParams;
};
/**
 * @param {?} val
 * @return {?}
 */
$jscomp.arrayFromIterable = function (val) {
    return val instanceof Array ? val : $jscomp.arrayFromIterator($jscomp.makeIterator(val));
};
/**
 * @param {Array} obj
 * @param {Function} f
 * @param {?} opt_this
 * @return {?}
 */
$jscomp.findInternal = function (obj, f, opt_this) {
    if (obj instanceof String) {
        /** @type {string} */
        obj = String(obj);
    }
    var l = obj.length;
    /** @type {number} */
    var i = 0;
    for (; i < l; i++) {
        var val = obj[i];
        if (f.call(opt_this, val, i, obj)) {
            return {
                i: i,
                v: val
            };
        }
    }
    return {
        i: -1,
        v: void 0
    };
};
/**
 * @param {string} name
 * @param {Object} func
 * @param {Object} ctx
 * @param {Object} key
 * @return {undefined}
 */
$jscomp.polyfill = function (name, func, ctx, key) {
    if (func) {
        ctx = $jscomp.global;
        name = name.split(".");
        /** @type {number} */
        key = 0;
        for (; key < name.length - 1; key++) {
            var k = name[key];
            if (!(k in ctx)) {
                ctx[k] = {};
            }
            ctx = ctx[k];
        }
        name = name[name.length - 1];
        key = ctx[name];
        func = func(key);
        if (func != key) {
            if (null != func) {
                $jscomp.defineProperty(ctx, name, {
                    configurable: true,
                    writable: true,
                    value: func
                });
            }
        }
    }
};
$jscomp.polyfill("Array.prototype.find", function (dataAndEvents) {
    return dataAndEvents ? dataAndEvents : function (opt_obj2, opt_this) {
        return $jscomp.findInternal(this, opt_obj2, opt_this).v;
    };
}, "es6", "es3");
/**
 * @param {string} b
 * @param {Function} deepEqual
 * @return {?}
 */
$jscomp.iteratorFromArray = function (b, deepEqual) {
    $jscomp.initSymbolIterator();
    if (b instanceof String) {
        b += "";
    }
    /** @type {number} */
    var j = 0;
    var iter = {
        /**
         * @return {?}
         */
        next: function () {
            if (j < b.length) {
                /** @type {number} */
                var i = j++;
                return {
                    value: deepEqual(i, b[i]),
                    done: false
                };
            }
            /**
             * @return {?}
             */
            iter.next = function () {
                return {
                    done: true,
                    value: void 0
                };
            };
            return iter.next();
        }
    };
    /**
     * @return {?}
     */
    iter[Symbol.iterator] = function () {
        return iter;
    };
    return iter;
};
$jscomp.polyfill("Array.prototype.keys", function (dataAndEvents) {
    return dataAndEvents ? dataAndEvents : function () {
        return $jscomp.iteratorFromArray(this, function (dataAndEvents) {
            return dataAndEvents;
        });
    };
}, "es6", "es3");
$jscomp.polyfill("Array.prototype.findIndex", function (dataAndEvents) {
    return dataAndEvents ? dataAndEvents : function (opt_obj2, opt_this) {
        return $jscomp.findInternal(this, opt_obj2, opt_this).i;
    };
}, "es6", "es3");
$jscomp.polyfill("Array.prototype.values", function (dataAndEvents) {
    return dataAndEvents ? dataAndEvents : function () {
        return $jscomp.iteratorFromArray(this, function (dataAndEvents, deepDataAndEvents) {
            return deepDataAndEvents;
        });
    };
}, "es8", "es3");
$jscomp.polyfill("Object.is", function (dataAndEvents) {
    return dataAndEvents ? dataAndEvents : function (a, b) {
        return a === b ? 0 !== a || 1 / a === 1 / b : a !== a && b !== b;
    };
}, "es6", "es3");
$jscomp.polyfill("Array.prototype.includes", function (dataAndEvents) {
    return dataAndEvents ? dataAndEvents : function (f, index) {
        var code = this;
        if (code instanceof String) {
            /** @type {string} */
            code = String(code);
        }
        var len = code.length;
        index = index || 0;
        if (0 > index) {
            /** @type {number} */
            index = Math.max(index + len, 0);
        }
        for (; index < len; index++) {
            var el = code[index];
            if (el === f || Object.is(el, f)) {
                return true;
            }
        }
        return false;
    };
}, "es7", "es3");
/**
 * @param {(number|string)} dataAndEvents
 * @param {?} path
 * @param {string} includes
 * @return {?}
 */
$jscomp.checkStringArgs = function (dataAndEvents, path, includes) {
    if (null == dataAndEvents) {
        throw new TypeError("The 'this' value for String.prototype." + includes + " must not be null or undefined");
    }
    if (path instanceof RegExp) {
        throw new TypeError("First argument to String.prototype." + includes + " must not be a regular expression");
    }
    return dataAndEvents + "";
};
$jscomp.polyfill("String.prototype.includes", function (dataAndEvents) {
    return dataAndEvents ? dataAndEvents : function (selector, index) {
        return -1 !== $jscomp.checkStringArgs(this, selector, "includes").indexOf(selector, index || 0);
    };
}, "es6", "es3");
/** @type {boolean} */
$jscomp.FORCE_POLYFILL_PROMISE = false;
$jscomp.polyfill("Promise", function (dataAndEvents) {
    /**
     * @return {undefined}
     */
    function Type() {
        /** @type {null} */
        this.batch_ = null;
    }
    /**
     * @param {?} x
     * @return {?}
     */
    function resolve(x) {
        return x instanceof Promise ? x : new Promise(function (yes, dataAndEvents) {
            yes(x);
        });
    }
    if (dataAndEvents && !$jscomp.FORCE_POLYFILL_PROMISE) {
        return dataAndEvents;
    }
    /**
     * @param {(Error|string)} wrapped
     * @return {?}
     */
    Type.prototype.asyncExecute = function (wrapped) {
        if (null == this.batch_) {
            /** @type {Array} */
            this.batch_ = [];
            this.asyncExecuteBatch_();
        }
        this.batch_.push(wrapped);
        return this;
    };
    /**
     * @return {undefined}
     */
    Type.prototype.asyncExecuteBatch_ = function () {
        var executeBatch_ = this;
        this.asyncExecuteFunction(function () {
            executeBatch_.executeBatch_();
        });
    };
    var HOP = $jscomp.global.setTimeout;
    /**
     * @param {Function} walkers
     * @return {undefined}
     */
    Type.prototype.asyncExecuteFunction = function (walkers) {
        HOP(walkers, 0);
    };
    /**
     * @return {undefined}
     */
    Type.prototype.executeBatch_ = function () {
        for (; this.batch_ && this.batch_.length;) {
            var resultItems = this.batch_;
            /** @type {Array} */
            this.batch_ = [];
            /** @type {number} */
            var i = 0;
            for (; i < resultItems.length; ++i) {
                var result = resultItems[i];
                /** @type {null} */
                resultItems[i] = null;
                try {
                    result();
                } catch (udataCur) {
                    this.asyncThrow_(udataCur);
                }
            }
        }
        /** @type {null} */
        this.batch_ = null;
    };
    /**
     * @param {?} value
     * @return {undefined}
     */
    Type.prototype.asyncThrow_ = function (value) {
        this.asyncExecuteFunction(function () {
            throw value;
        });
    };
    /**
     * @param {?} resolver
     * @return {undefined}
     */
    var Promise = function (resolver) {
        /** @type {number} */
        this.state_ = 0;
        this.result_ = void 0;
        /** @type {Array} */
        this.onSettledCallbacks_ = [];
        var deferred = this.createResolveAndReject_();
        try {
            resolver(deferred.resolve, deferred.reject);
        } catch (suiteView) {
            deferred.reject(suiteView);
        }
    };
    /**
     * @return {?}
     */
    Promise.prototype.createResolveAndReject_ = function () {
        /**
         * @param {Function} callback
         * @return {?}
         */
        function require(callback) {
            return function (operation) {
                if (!c) {
                    /** @type {boolean} */
                    c = true;
                    callback.call(T, operation);
                }
            };
        }
        var T = this;
        /** @type {boolean} */
        var c = false;
        return {
            resolve: require(this.resolveTo_),
            reject: require(this.reject_)
        };
    };
    /**
     * @param {?} value
     * @return {undefined}
     */
    Promise.prototype.resolveTo_ = function (value) {
        if (value === this) {
            this.reject_(new TypeError("A Promise cannot resolve to itself"));
        } else {
            if (value instanceof Promise) {
                this.settleSameAsPromise_(value);
            } else {
                a: {
                    switch (typeof value) {
                        case "object":
                            /** @type {boolean} */
                            var changed = null != value;
                            break a;
                        case "function":
                            /** @type {boolean} */
                            changed = true;
                            break a;
                        default:
                            /** @type {boolean} */
                            changed = false;
                    }
                }
                if (changed) {
                    this.resolveToNonPromiseObj_(value);
                } else {
                    this.fulfill_(value);
                }
            }
        }
    };
    /**
     * @param {?} xs
     * @return {undefined}
     */
    Promise.prototype.resolveToNonPromiseObj_ = function (xs) {
        var udataCur = void 0;
        try {
            udataCur = xs.then;
        } catch (pdataOld) {
            this.reject_(pdataOld);
            return;
        }
        if ("function" == typeof udataCur) {
            this.settleSameAsThenable_(udataCur, xs);
        } else {
            this.fulfill_(xs);
        }
    };
    /**
     * @param {?} value
     * @return {undefined}
     */
    Promise.prototype.reject_ = function (value) {
        this.settle_(2, value);
    };
    /**
     * @param {?} xs
     * @return {undefined}
     */
    Promise.prototype.fulfill_ = function (xs) {
        this.settle_(1, xs);
    };
    /**
     * @param {number} expectedNumberOfNonCommentArgs
     * @param {?} xs
     * @return {undefined}
     */
    Promise.prototype.settle_ = function (expectedNumberOfNonCommentArgs, xs) {
        if (0 != this.state_) {
            throw Error("Cannot settle(" + expectedNumberOfNonCommentArgs + ", " + xs + "): Promise already settled in state" + this.state_);
        }
        /** @type {number} */
        this.state_ = expectedNumberOfNonCommentArgs;
        this.result_ = xs;
        this.executeOnSettledCallbacks_();
    };
    /**
     * @return {undefined}
     */
    Promise.prototype.executeOnSettledCallbacks_ = function () {
        if (null != this.onSettledCallbacks_) {
            /** @type {number} */
            var i = 0;
            for (; i < this.onSettledCallbacks_.length; ++i) {
                jQuery.asyncExecute(this.onSettledCallbacks_[i]);
            }
            /** @type {null} */
            this.onSettledCallbacks_ = null;
        }
    };
    var jQuery = new Type;
    /**
     * @param {?} object
     * @return {undefined}
     */
    Promise.prototype.settleSameAsPromise_ = function (object) {
        var result = this.createResolveAndReject_();
        object.callWhenSettled_(result.resolve, result.reject);
    };
    /**
     * @param {Function} value
     * @param {?} xs
     * @return {undefined}
     */
    Promise.prototype.settleSameAsThenable_ = function (value, xs) {
        var d = this.createResolveAndReject_();
        try {
            value.call(xs, d.resolve, d.reject);
        } catch (suiteView) {
            d.reject(suiteView);
        }
    };
    /**
     * @param {?} type
     * @param {?} onReject
     * @return {?}
     */
    Promise.prototype.then = function (type, onReject) {
        /**
         * @param {?} fn
         * @param {Object} callback
         * @return {?}
         */
        function handler(fn, callback) {
            return "function" == typeof fn ? function (context) {
                try {
                    resolve(fn(context));
                } catch (responseObject) {
                    next(responseObject);
                }
            } : callback;
        }
        var resolve;
        var next;
        var p = new Promise(function (res, ng) {
            resolve = res;
            next = ng;
        });
        this.callWhenSettled_(handler(type, resolve), handler(onReject, next));
        return p;
    };
    /**
     * @param {?} callback
     * @return {?}
     */
    Promise.prototype.catch = function (callback) {
        return this.then(void 0, callback);
    };
    /**
     * @param {?} reject
     * @param {?} resolve
     * @return {undefined}
     */
    Promise.prototype.callWhenSettled_ = function (reject, resolve) {
        /**
         * @return {undefined}
         */
        function wrapped() {
            switch (ajax.state_) {
                case 1:
                    reject(ajax.result_);
                    break;
                case 2:
                    resolve(ajax.result_);
                    break;
                default:
                    throw Error("Unexpected state: " + ajax.state_);;
            }
        }
        var ajax = this;
        if (null == this.onSettledCallbacks_) {
            jQuery.asyncExecute(wrapped);
        } else {
            this.onSettledCallbacks_.push(wrapped);
        }
    };
    /** @type {function (?): ?} */
    Promise.resolve = resolve;
    /**
     * @param {?} obj
     * @return {?}
     */
    Promise.reject = function (obj) {
        return new Promise(function (dataAndEvents, forOwn) {
            forOwn(obj);
        });
    };
    /**
     * @param {?} env
     * @return {?}
     */
    Promise.race = function (env) {
        return new Promise(function (reject, append) {
            var b = $jscomp.makeIterator(env);
            var builder = b.next();
            for (; !builder.done; builder = b.next()) {
                resolve(builder.value).callWhenSettled_(reject, append);
            }
        });
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    Promise.all = function (obj) {
        var stream = $jscomp.makeIterator(obj);
        var builder = stream.next();
        return builder.done ? resolve([]) : new Promise(function (jQuery, append) {
            /**
             * @param {number} index
             * @return {?}
             */
            function fulfillmentAt(index) {
                return function (text) {
                    scripts[index] = text;
                    r--;
                    if (0 == r) {
                        jQuery(scripts);
                    }
                };
            }
            /** @type {Array} */
            var scripts = [];
            /** @type {number} */
            var r = 0;
            do {
                scripts.push(void 0);
                r++;
                resolve(builder.value).callWhenSettled_(fulfillmentAt(scripts.length - 1), append);
                builder = stream.next();
            } while (!builder.done);
        });
    };
    return Promise;
}, "es6", "es3");
(function (self) {
    var jQuery;
    (function (element, proceed) {
        if ("function" === typeof define && define.amd) {
            define(function () {
                return proceed(element);
            });
        } else {
            proceed(element);
        }
    })(this, function (win) {
        jQuery = function () {
            /**
             * @param {Object} obj
             * @return {?}
             */
            function type(obj) {
                return null == obj ? String(obj) : class2type[core_toString.call(obj)] || "object";
            }
            /**
             * @param {Function} value
             * @return {?}
             */
            function isFunction(value) {
                return "function" == type(value);
            }
            /**
             * @param {Object} obj
             * @return {?}
             */
            function isWindow(obj) {
                return null != obj && obj == obj.window;
            }
            /**
             * @param {Object} obj
             * @return {?}
             */
            function isObject(obj) {
                return "object" == type(obj);
            }
            /**
             * @param {?} obj
             * @return {?}
             */
            function isPlainObject(obj) {
                return isObject(obj) && (!isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype);
            }
            /**
             * @param {Object} obj
             * @return {?}
             */
            function isArray(obj) {
                var length = !!obj && ("length" in obj && obj.length);
                var type = $.type(obj);
                return "function" != type && (!isWindow(obj) && ("array" == type || (0 === length || "number" == typeof length && (0 < length && length - 1 in obj))));
            }
            /**
             * @param {Object} array
             * @return {?}
             */
            function makeArray(array) {
                return filter.call(array, function (dataAndEvents) {
                    return null != dataAndEvents;
                });
            }
            /**
             * @param {string} str
             * @return {?}
             */
            function dasherize(str) {
                return str.replace(/::/g, "/").replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/_/g, "-").toLowerCase();
            }
            /**
             * @param {string} name
             * @return {?}
             */
            function classRE(name) {
                return name in classCache ? classCache[name] : classCache[name] = new RegExp("(^|\\s)" + name + "(\\s|$)");
            }
            /**
             * @param {string} name
             * @param {number} value
             * @return {?}
             */
            function maybeAddPx(name, value) {
                return "number" != typeof value || cssNumber[dasherize(name)] ? value : value + "px";
            }
            /**
             * @param {Element} element
             * @return {?}
             */
            function children(element) {
                return "children" in element ? slice.call(element.children) : $.map(element.childNodes, function (node) {
                    if (1 == node.nodeType) {
                        return node;
                    }
                });
            }
            /**
             * @param {(Object|string)} array
             * @param {string} selector
             * @return {undefined}
             */
            function Z(array, selector) {
                var i;
                var length = array ? array.length : 0;
                /** @type {number} */
                i = 0;
                for (; i < length; i++) {
                    this[i] = array[i];
                }
                this.length = length;
                this.selector = selector || "";
            }
            /**
             * @param {Object} a
             * @param {Object} b
             * @param {boolean} xs
             * @return {undefined}
             */
            function fn(a, b, xs) {
                for (key in b) {
                    if (xs && (isPlainObject(b[key]) || isString(b[key]))) {
                        if (isPlainObject(b[key])) {
                            if (!isPlainObject(a[key])) {
                                a[key] = {};
                            }
                        }
                        if (isString(b[key])) {
                            if (!isString(a[key])) {
                                /** @type {Array} */
                                a[key] = [];
                            }
                        }
                        fn(a[key], b[key], xs);
                    } else {
                        if (b[key] !== undef) {
                            a[key] = b[key];
                        }
                    }
                }
            }
            /**
             * @param {?} nodes
             * @param {Object} selector
             * @return {?}
             */
            function filtered(nodes, selector) {
                return null == selector ? $(nodes) : $(nodes).filter(selector);
            }
            /**
             * @param {?} context
             * @param {Function} arg
             * @param {?} idx
             * @param {?} payload
             * @return {?}
             */
            function funcArg(context, arg, idx, payload) {
                return isFunction(arg) ? arg.call(context, idx, payload) : arg;
            }
            /**
             * @param {Element} element
             * @param {string} value
             * @return {?}
             */
            function className(element, value) {
                var klass = element.className || "";
                var svg = klass && klass.baseVal !== undef;
                if (value === undef) {
                    return svg ? klass.baseVal : klass;
                }
                if (svg) {
                    /** @type {string} */
                    klass.baseVal = value;
                } else {
                    /** @type {string} */
                    element.className = value;
                }
            }
            /**
             * @param {Object} data
             * @return {?}
             */
            function deserializeValue(data) {
                try {
                    return data ? "true" == data || ("false" == data ? false : "null" == data ? null : +data + "" == data ? +data : /^[\[\{]/.test(data) ? $.parseJSON(data) : data) : data;
                } catch (ka) {
                    return data;
                }
            }
            /**
             * @param {Node} node
             * @param {Function} fun
             * @return {undefined}
             */
            function traverseNode(node, fun) {
                fun(node);
                /** @type {number} */
                var i = 0;
                var valuesLen = node.childNodes.length;
                for (; i < valuesLen; i++) {
                    traverseNode(node.childNodes[i], fun);
                }
            }
            var undef;
            var key;
            var classList;
            /** @type {Array} */
            var emptyArray = [];
            /** @type {function (this:*, ...[*]): Array} */
            var core_concat = emptyArray.concat;
            /** @type {function (this:(Array.<T>|string|{length: number}), (function (this:S, T, number, Array.<T>): ?|null), S=): Array.<T>} */
            var filter = emptyArray.filter;
            /** @type {function (this:(Array.<T>|string|{length: number}), *=, *=): Array.<T>} */
            var slice = emptyArray.slice;
            var doc = win.document;
            var elementDisplay = {};
            var classCache = {};
            var cssNumber = {
                "column-count": 1,
                columns: 1,
                "font-weight": 1,
                "line-height": 1,
                opacity: 1,
                "z-index": 1,
                zoom: 1
            };
            /** @type {RegExp} */
            var fragmentRE = /^\s*<(\w+|!)[^>]*>/;
            /** @type {RegExp} */
            var BEGIN_TAG_REGEXP = /^<(\w+)\s*\/?>(?:<\/\1>|)$/;
            /** @type {RegExp} */
            var regExclamation = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig;
            /** @type {RegExp} */
            var rootNodeRE = /^(?:body|html)$/i;
            /** @type {RegExp} */
            var r20 = /([A-Z])/g;
            /** @type {Array.<string>} */
            var excludes = "val css html text data width height offset".split(" ");
            var table = doc.createElement("table");
            var tableRow = doc.createElement("tr");
            var containers = {
                tr: doc.createElement("tbody"),
                tbody: table,
                thead: table,
                tfoot: table,
                td: tableRow,
                th: tableRow,
                "*": doc.createElement("div")
            };
            /** @type {RegExp} */
            var rxReady = /complete|loaded|interactive/;
            /** @type {RegExp} */
            var simpleSelectorRE = /^[\w-]*$/;
            var class2type = {};
            /** @type {function (this:*): string} */
            var core_toString = class2type.toString;
            var zepto = {};
            var tempParent = doc.createElement("div");
            var propMap = {
                tabindex: "tabIndex",
                readonly: "readOnly",
                "for": "htmlFor",
                "class": "className",
                maxlength: "maxLength",
                cellspacing: "cellSpacing",
                cellpadding: "cellPadding",
                rowspan: "rowSpan",
                colspan: "colSpan",
                usemap: "useMap",
                frameborder: "frameBorder",
                contenteditable: "contentEditable"
            };
            /** @type {function (*): boolean} */
            var isString = Array.isArray || function (obj) {
                return obj instanceof Array;
            };
            /**
             * @param {Object} element
             * @param {?} selector
             * @return {?}
             */
            zepto.matches = function (element, selector) {
                if (!selector || (!element || 1 !== element.nodeType)) {
                    return false;
                }
                var matchesSelector = element.matches || (element.webkitMatchesSelector || (element.mozMatchesSelector || (element.oMatchesSelector || element.matchesSelector)));
                if (matchesSelector) {
                    return matchesSelector.call(element, selector);
                }
                var parent = element.parentNode;
                if (matchesSelector = !parent) {
                    (parent = tempParent).appendChild(element);
                }
                /** @type {number} */
                selector = ~zepto.qsa(parent, selector).indexOf(element);
                if (matchesSelector) {
                    tempParent.removeChild(element);
                }
                return selector;
            };
            /**
             * @param {string} str
             * @return {?}
             */
            var camelize = function (str) {
                return str.replace(/-+(.)?/g, function (dataAndEvents, chr) {
                    return chr ? chr.toUpperCase() : "";
                });
            };
            /**
             * @param {string} array
             * @return {?}
             */
            var uniq = function (array) {
                return filter.call(array, function (item, index) {
                    return array.indexOf(item) == index;
                });
            };
            /**
             * @param {string} html
             * @param {string} name
             * @param {?} properties
             * @return {?}
             */
            zepto.fragment = function (html, name, properties) {
                var result;
                if (BEGIN_TAG_REGEXP.test(html)) {
                    result = $(doc.createElement(RegExp.$1));
                }
                if (!result) {
                    if (html.replace) {
                        html = html.replace(regExclamation, "<$1></$2>");
                    }
                    if (name === undef) {
                        /** @type {(boolean|string)} */
                        name = fragmentRE.test(html) && RegExp.$1;
                    }
                    if (!(name in containers)) {
                        /** @type {string} */
                        name = "*";
                    }
                    var container = containers[name];
                    /** @type {string} */
                    container.innerHTML = "" + html;
                    result = $.each(slice.call(container.childNodes), function () {
                        container.removeChild(this);
                    });
                }
                if (isPlainObject(properties)) {
                    var nodes = $(result);
                    $.each(properties, function (key, value) {
                        if (-1 < excludes.indexOf(key)) {
                            nodes[key](value);
                        } else {
                            nodes.attr(key, value);
                        }
                    });
                }
                return result;
            };
            /**
             * @param {?} object
             * @param {string} expr
             * @return {?}
             */
            zepto.Z = function (object, expr) {
                return new Z(object, expr);
            };
            /**
             * @param {Function} object
             * @return {?}
             */
            zepto.isZ = function (object) {
                return object instanceof zepto.Z;
            };
            /**
             * @param {Object} selector
             * @param {?} result
             * @return {?}
             */
            zepto.init = function (selector, result) {
                if (selector) {
                    if ("string" == typeof selector) {
                        if (selector = selector.trim(), "<" == selector[0] && fragmentRE.test(selector)) {
                            result = zepto.fragment(selector, RegExp.$1, result);
                            /** @type {null} */
                            selector = null;
                        } else {
                            if (result !== undef) {
                                return $(result).find(selector);
                            }
                            result = zepto.qsa(doc, selector);
                        }
                    } else {
                        if (isFunction(selector)) {
                            return $(doc).ready(selector);
                        }
                        if (zepto.isZ(selector)) {
                            return selector;
                        }
                        if (isString(selector)) {
                            result = makeArray(selector);
                        } else {
                            if (isObject(selector)) {
                                /** @type {Array} */
                                result = [selector];
                                /** @type {null} */
                                selector = null;
                            } else {
                                if (fragmentRE.test(selector)) {
                                    result = zepto.fragment(selector.trim(), RegExp.$1, result);
                                    /** @type {null} */
                                    selector = null;
                                } else {
                                    if (result !== undef) {
                                        return $(result).find(selector);
                                    }
                                    result = zepto.qsa(doc, selector);
                                }
                            }
                        }
                    }
                } else {
                    return zepto.Z();
                }
                return zepto.Z(result, selector);
            };
            /**
             * @param {Array} node
             * @param {?} selector
             * @return {?}
             */
            var $ = function (node, selector) {
                return zepto.init(node, selector);
            };
            /**
             * @param {?} opt_attributes
             * @return {?}
             */
            $.extend = function (opt_attributes) {
                /** @type {Array.<?>} */
                var fns = slice.call(arguments, 1);
                if ("boolean" == typeof opt_attributes) {
                    /** @type {boolean} */
                    var xs = opt_attributes;
                    opt_attributes = fns.shift();
                }
                fns.forEach(function (key) {
                    fn(opt_attributes, key, xs);
                });
                return opt_attributes;
            };
            /**
             * @param {Object} element
             * @param {string} selector
             * @return {?}
             */
            zepto.qsa = function (element, selector) {
                var found;
                /** @type {boolean} */
                var maybeID = "#" == selector[0];
                /** @type {boolean} */
                var maybeClass = !maybeID && "." == selector[0];
                var nameOnly = maybeID || maybeClass ? selector.slice(1) : selector;
                /** @type {boolean} */
                var isSimple = simpleSelectorRE.test(nameOnly);
                return element.getElementById && (isSimple && maybeID) ? (found = element.getElementById(nameOnly)) ? [found] : [] : 1 !== element.nodeType && (9 !== element.nodeType && 11 !== element.nodeType) ? [] : slice.call(isSimple && (!maybeID && element.getElementsByClassName) ? maybeClass ? element.getElementsByClassName(nameOnly) : element.getElementsByTagName(selector) : element.querySelectorAll(selector));
            };
            /** @type {function (Object, Object): ?} */
            $.contains = doc.documentElement.contains ? function (key, parent) {
                return key !== parent && key.contains(parent);
            } : function (arr, parent) {
                for (; parent && (parent = parent.parentNode);) {
                    if (parent === arr) {
                        return true;
                    }
                }
                return false;
            };
            /** @type {function (Object): ?} */
            $.type = type;
            /** @type {function (Function): ?} */
            $.isFunction = isFunction;
            /** @type {function (Object): ?} */
            $.isWindow = isWindow;
            /** @type {function (*): boolean} */
            $.isArray = isString;
            /** @type {function (?): ?} */
            $.isPlainObject = isPlainObject;
            /**
             * @param {?} obj
             * @return {?}
             */
            $.isEmptyObject = function (obj) {
                var prop;
                for (prop in obj) {
                    return false;
                }
                return true;
            };
            /**
             * @param {string} str
             * @return {?}
             */
            $.isNumeric = function (str) {
                /** @type {number} */
                var h = Number(str);
                /** @type {string} */
                var type = typeof str;
                return null != str && ("boolean" != type && (("string" != type || str.length) && (!isNaN(h) && isFinite(h)))) || false;
            };
            /**
             * @param {?} i
             * @param {?} array
             * @param {?} elem
             * @return {?}
             */
            $.inArray = function (i, array, elem) {
                return emptyArray.indexOf.call(array, i, elem);
            };
            /** @type {function (string): ?} */
            $.camelCase = camelize;
            /**
             * @param {number} s
             * @return {?}
             */
            $.trim = function (s) {
                return null == s ? "" : String.prototype.trim.call(s);
            };
            /** @type {number} */
            $.uuid = 0;
            $.support = {};
            $.expr = {};
            /**
             * @return {undefined}
             */
            $.noop = function () {
            };
            /**
             * @param {Object} src
             * @param {Function} f
             * @return {?}
             */
            $.map = function (src, f) {
                /** @type {Array} */
                var changes = [];
                var i;
                if (isArray(src)) {
                    /** @type {number} */
                    i = 0;
                    for (; i < src.length; i++) {
                        var val = f(src[i], i);
                        if (null != val) {
                            changes.push(val);
                        }
                    }
                } else {
                    for (i in src) {
                        val = f(src[i], i);
                        if (null != val) {
                            changes.push(val);
                        }
                    }
                }
                return 0 < changes.length ? $.fn.concat.apply([], changes) : changes;
            };
            /**
             * @param {Function} object
             * @param {Function} callback
             * @return {?}
             */
            $.each = function (object, callback) {
                var key;
                if (isArray(object)) {
                    /** @type {number} */
                    key = 0;
                    for (; key < object.length && false !== callback.call(object[key], key, object[key]); key++) {
                    }
                } else {
                    for (key in object) {
                        if (false === callback.call(object[key], key, object[key])) {
                            break;
                        }
                    }
                }
                return object;
            };
            /**
             * @param {?} str
             * @param {?} callback
             * @return {?}
             */
            $.grep = function (str, callback) {
                return filter.call(str, callback);
            };
            if (win.JSON) {
                /** @type {function (this:JSONType, string, function (string, *): *=): *} */
                $.parseJSON = JSON.parse;
            }
            $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (dataAndEvents, m3) {
                class2type["[object " + m3 + "]"] = m3.toLowerCase();
            });
            $.fn = {
                /** @type {function (?, string): ?} */
                constructor: zepto.Z,
                length: 0,
                /** @type {function (this:(Array.<T>|string|{length: number}), (function (this:S, T, number, Array.<T>): ?|null), S=): ?} */
                forEach: emptyArray.forEach,
                /** @type {function (this:(Array.<T>|string|{length: number}), (function (?, T, number, Array.<T>): R|null), *=): R} */
                reduce: emptyArray.reduce,
                /** @type {function (this:(Array.<T>|{length: number}), ...[T]): number} */
                push: emptyArray.push,
                /** @type {function (this:(Array.<T>|{length: number}), function (T, T): number=): ?} */
                sort: emptyArray.sort,
                /** @type {function (this:(Array.<T>|{length: number}), *=, *=, ...[T]): Array.<T>} */
                splice: emptyArray.splice,
                /** @type {function (this:(Array.<T>|string|{length: number}), T, number=): number} */
                indexOf: emptyArray.indexOf,
                /**
                 * @return {?}
                 */
                concat: function () {
                    var i;
                    /** @type {Array} */
                    var args = [];
                    /** @type {number} */
                    i = 0;
                    for (; i < arguments.length; i++) {
                        var arg = arguments[i];
                        args[i] = zepto.isZ(arg) ? arg.toArray() : arg;
                    }
                    return core_concat.apply(zepto.isZ(this) ? this.toArray() : this, args);
                },
                /**
                 * @param {Function} callback
                 * @return {?}
                 */
                map: function (callback) {
                    return $($.map(this, function (el, operation) {
                        return callback.call(el, operation, el);
                    }));
                },
                /**
                 * @return {?}
                 */
                slice: function () {
                    return $(slice.apply(this, arguments));
                },
                /**
                 * @param {Function} callback
                 * @return {?}
                 */
                ready: function (callback) {
                    if (rxReady.test(doc.readyState) && doc.body) {
                        callback($);
                    } else {
                        doc.addEventListener("DOMContentLoaded", function () {
                            callback($);
                        }, false);
                    }
                    return this;
                },
                /**
                 * @param {string} name
                 * @return {?}
                 */
                get: function (name) {
                    return name === undef ? slice.call(this) : this[0 <= name ? name : name + this.length];
                },
                /**
                 * @return {?}
                 */
                toArray: function () {
                    return this.get();
                },
                /**
                 * @return {?}
                 */
                size: function () {
                    return this.length;
                },
                /**
                 * @return {?}
                 */
                remove: function () {
                    return this.each(function () {
                        if (null != this.parentNode) {
                            this.parentNode.removeChild(this);
                        }
                    });
                },
                /**
                 * @param {Function} object
                 * @return {?}
                 */
                each: function (object) {
                    emptyArray.every.call(this, function (deep, handler) {
                        return false !== object.call(deep, handler, deep);
                    });
                    return this;
                },
                /**
                 * @param {Function} selector
                 * @return {?}
                 */
                filter: function (selector) {
                    return isFunction(selector) ? this.not(this.not(selector)) : $(filter.call(this, function (node) {
                        return zepto.matches(node, selector);
                    }));
                },
                /**
                 * @param {?} object
                 * @param {string} expr
                 * @return {?}
                 */
                add: function (object, expr) {
                    return $(uniq(this.concat($(object, expr))));
                },
                /**
                 * @param {?} selector
                 * @return {?}
                 */
                is: function (selector) {
                    return 0 < this.length && zepto.matches(this[0], selector);
                },
                /**
                 * @param {Function} selector
                 * @return {?}
                 */
                not: function (selector) {
                    /** @type {Array} */
                    var exp = [];
                    if (isFunction(selector) && selector.call !== undef) {
                        this.each(function ($1) {
                            if (!selector.call(this, $1)) {
                                exp.push(this);
                            }
                        });
                    } else {
                        var arr = "string" == typeof selector ? this.filter(selector) : isArray(selector) && isFunction(selector.item) ? slice.call(selector) : $(selector);
                        this.forEach(function (o) {
                            if (0 > arr.indexOf(o)) {
                                exp.push(o);
                            }
                        });
                    }
                    return $(exp);
                },
                /**
                 * @param {Object} obj
                 * @return {?}
                 */
                has: function (obj) {
                    return this.filter(function () {
                        return isObject(obj) ? $.contains(this, obj) : $(this).find(obj).size();
                    });
                },
                /**
                 * @param {number} recurring
                 * @return {?}
                 */
                eq: function (recurring) {
                    return -1 === recurring ? this.slice(recurring) : this.slice(recurring, +recurring + 1);
                },
                /**
                 * @return {?}
                 */
                first: function () {
                    var el = this[0];
                    return el && !isObject(el) ? el : $(el);
                },
                /**
                 * @return {?}
                 */
                last: function () {
                    var el = this[this.length - 1];
                    return el && !isObject(el) ? el : $(el);
                },
                /**
                 * @param {string} selector
                 * @return {?}
                 */
                find: function (selector) {
                    var uniqs = this;
                    return selector ? "object" == typeof selector ? $(selector).filter(function () {
                        var child = this;
                        return emptyArray.some.call(uniqs, function (keys) {
                            return $.contains(keys, child);
                        });
                    }) : 1 == this.length ? $(zepto.qsa(this[0], selector)) : this.map(function () {
                        return zepto.qsa(this, selector);
                    }) : $();
                },
                /**
                 * @param {Object} selector
                 * @param {Object} context
                 * @return {?}
                 */
                closest: function (selector, context) {
                    /** @type {Array} */
                    var block = [];
                    var collection = "object" == typeof selector && $(selector);
                    this.each(function (dataAndEvents, node) {
                        for (; node && !(collection ? 0 <= collection.indexOf(node) : zepto.matches(node, selector));) {
                            node = node !== context && (!(null != node && node.nodeType == node.DOCUMENT_NODE) && node.parentNode);
                        }
                        if (node) {
                            if (0 > block.indexOf(node)) {
                                block.push(node);
                            }
                        }
                    });
                    return $(block);
                },
                /**
                 * @param {Object} selector
                 * @return {?}
                 */
                parents: function (selector) {
                    /** @type {Array} */
                    var ancestors = [];
                    var scripts = this;
                    for (; 0 < scripts.length;) {
                        scripts = $.map(scripts, function (node) {
                            if ((node = node.parentNode) && ((null == node || node.nodeType != node.DOCUMENT_NODE) && 0 > ancestors.indexOf(node))) {
                                return ancestors.push(node), node;
                            }
                        });
                    }
                    return filtered(ancestors, selector);
                },
                /**
                 * @param {Object} selector
                 * @return {?}
                 */
                parent: function (selector) {
                    return filtered(uniq(this.pluck("parentNode")), selector);
                },
                /**
                 * @param {Object} selector
                 * @return {?}
                 */
                children: function (selector) {
                    return filtered(this.map(function () {
                        return children(this);
                    }), selector);
                },
                /**
                 * @return {?}
                 */
                contents: function () {
                    return this.map(function () {
                        return this.contentDocument || slice.call(this.childNodes);
                    });
                },
                /**
                 * @param {Object} selector
                 * @return {?}
                 */
                siblings: function (selector) {
                    return filtered(this.map(function (dataAndEvents, el) {
                        return filter.call(children(el.parentNode), function (child) {
                            return child !== el;
                        });
                    }), selector);
                },
                /**
                 * @return {?}
                 */
                empty: function () {
                    return this.each(function () {
                        /** @type {string} */
                        this.innerHTML = "";
                    });
                },
                /**
                 * @param {string} property
                 * @return {?}
                 */
                pluck: function (property) {
                    return $.map(this, function (to_instance) {
                        return to_instance[property];
                    });
                },
                /**
                 * @return {?}
                 */
                show: function () {
                    return this.each(function () {
                        if ("none" == this.style.display) {
                            /** @type {string} */
                            this.style.display = "";
                        }
                        if ("none" == getComputedStyle(this, "").getPropertyValue("display")) {
                            var style = this.style;
                            var nodeName = this.nodeName;
                            if (!elementDisplay[nodeName]) {
                                var elem = doc.createElement(nodeName);
                                doc.body.appendChild(elem);
                                var display = getComputedStyle(elem, "").getPropertyValue("display");
                                elem.parentNode.removeChild(elem);
                                if ("none" == display) {
                                    /** @type {string} */
                                    display = "block";
                                }
                                elementDisplay[nodeName] = display;
                            }
                            style.display = elementDisplay[nodeName];
                        }
                    });
                },
                /**
                 * @param {?} newContent
                 * @return {?}
                 */
                replaceWith: function (newContent) {
                    return this.before(newContent).remove();
                },
                /**
                 * @param {Function} structure
                 * @return {?}
                 */
                wrap: function (structure) {
                    var func = isFunction(structure);
                    if (this[0] && !func) {
                        var dom = $(structure).get(0);
                        var clone = dom.parentNode || 1 < this.length;
                    }
                    return this.each(function (index) {
                        $(this).wrapAll(func ? structure.call(this, index) : clone ? dom.cloneNode(true) : dom);
                    });
                },
                /**
                 * @param {Object} structure
                 * @return {?}
                 */
                wrapAll: function (structure) {
                    if (this[0]) {
                        $(this[0]).before(structure = $(structure));
                        var children;
                        for (; (children = structure.children()).length;) {
                            structure = children.first();
                        }
                        $(structure).append(this);
                    }
                    return this;
                },
                /**
                 * @param {Function} structure
                 * @return {?}
                 */
                wrapInner: function (structure) {
                    var func = isFunction(structure);
                    return this.each(function (html) {
                        var token = $(this);
                        var contents = token.contents();
                        html = func ? structure.call(this, html) : structure;
                        if (contents.length) {
                            contents.wrapAll(html);
                        } else {
                            token.append(html);
                        }
                    });
                },
                /**
                 * @return {?}
                 */
                unwrap: function () {
                    this.parent().each(function () {
                        $(this).replaceWith($(this).children());
                    });
                    return this;
                },
                /**
                 * @return {?}
                 */
                clone: function () {
                    return this.map(function () {
                        return this.cloneNode(true);
                    });
                },
                /**
                 * @return {?}
                 */
                hide: function () {
                    return this.css("display", "none");
                },
                /**
                 * @param {boolean} element
                 * @return {?}
                 */
                toggle: function (element) {
                    return this.each(function () {
                        var removeButton = $(this);
                        if (element === undef ? "none" == removeButton.css("display") : element) {
                            removeButton.show();
                        } else {
                            removeButton.hide();
                        }
                    });
                },
                /**
                 * @param {string} selector
                 * @return {?}
                 */
                prev: function (selector) {
                    return $(this.pluck("previousElementSibling")).filter(selector || "*");
                },
                /**
                 * @param {string} selector
                 * @return {?}
                 */
                next: function (selector) {
                    return $(this.pluck("nextElementSibling")).filter(selector || "*");
                },
                /**
                 * @param {Function} html
                 * @return {?}
                 */
                html: function (html) {
                    return 0 in arguments ? this.each(function (idx) {
                        var originHtml = this.innerHTML;
                        $(this).empty().append(funcArg(this, html, idx, originHtml));
                    }) : 0 in this ? this[0].innerHTML : null;
                },
                /**
                 * @param {Function} value
                 * @return {?}
                 */
                text: function (value) {
                    return 0 in arguments ? this.each(function (idx) {
                        idx = funcArg(this, value, idx, this.textContent);
                        /** @type {string} */
                        this.textContent = null == idx ? "" : "" + idx;
                    }) : 0 in this ? this.pluck("textContent").join("") : null;
                },
                /**
                 * @param {string} name
                 * @param {?} value
                 * @return {?}
                 */
                attr: function (name, value) {
                    var isLengthProperty;
                    return "string" != typeof name || 1 in arguments ? this.each(function (val) {
                        if (1 === this.nodeType) {
                            if (isObject(name)) {
                                for (key in name) {
                                    /** @type {string} */
                                    var property = key;
                                    val = name[key];
                                    if (null == val) {
                                        this.removeAttribute(property);
                                    } else {
                                        this.setAttribute(property, val);
                                    }
                                }
                            } else {
                                /** @type {string} */
                                property = name;
                                val = funcArg(this, value, val, this.getAttribute(name));
                                if (null == val) {
                                    this.removeAttribute(property);
                                } else {
                                    this.setAttribute(property, val);
                                }
                            }
                        }
                    }) : 0 in this && (1 == this[0].nodeType && null != (isLengthProperty = this[0].getAttribute(name))) ? isLengthProperty : undef;
                },
                /**
                 * @param {string} value
                 * @return {?}
                 */
                removeAttr: function (value) {
                    return this.each(function () {
                        if (1 === this.nodeType) {
                            value.split(" ").forEach(function (a) {
                                this.removeAttribute(a);
                            }, this);
                        }
                    });
                },
                /**
                 * @param {(Node|string)} name
                 * @param {Object} value
                 * @return {?}
                 */
                prop: function (name, value) {
                    name = propMap[name] || name;
                    return 1 in arguments ? this.each(function (idx) {
                        this[name] = funcArg(this, value, idx, this[name]);
                    }) : this[0] && this[0][name];
                },
                /**
                 * @param {Text} name
                 * @return {?}
                 */
                removeProp: function (name) {
                    name = propMap[name] || name;
                    return this.each(function () {
                        delete this[name];
                    });
                },
                /**
                 * @param {string} key
                 * @param {?} value
                 * @return {?}
                 */
                data: function (key, value) {
                    var match = "data-" + key.replace(r20, "-$1").toLowerCase();
                    match = 1 in arguments ? this.attr(match, value) : this.attr(match);
                    return null !== match ? deserializeValue(match) : undef;
                },
                /**
                 * @param {Object} value
                 * @return {?}
                 */
                val: function (value) {
                    return 0 in arguments ? (null == value && (value = ""), this.each(function (idx) {
                        this.value = funcArg(this, value, idx, this.value);
                    })) : this[0] && (this[0].multiple ? $(this[0]).find("option").filter(function () {
                        return this.selected;
                    }).pluck("value") : this[0].value);
                },
                /**
                 * @param {Function} coordinates
                 * @return {?}
                 */
                offset: function (coordinates) {
                    if (coordinates) {
                        return this.each(function (position) {
                            var object = $(this);
                            position = funcArg(this, coordinates, position, object.offset());
                            var bgOffset = object.offsetParent().offset();
                            position = {
                                top: position.top - bgOffset.top,
                                left: position.left - bgOffset.left
                            };
                            if ("static" == object.css("position")) {
                                /** @type {string} */
                                position.position = "relative";
                            }
                            object.css(position);
                        });
                    }
                    if (!this.length) {
                        return null;
                    }
                    if (doc.documentElement !== this[0] && !$.contains(doc.documentElement, this[0])) {
                        return {
                            top: 0,
                            left: 0
                        };
                    }
                    var box = this[0].getBoundingClientRect();
                    return {
                        left: box.left + win.pageXOffset,
                        top: box.top + win.pageYOffset,
                        width: Math.round(box.width),
                        height: Math.round(box.height)
                    };
                },
                /**
                 * @param {?} prop
                 * @param {boolean} value
                 * @return {?}
                 */
                css: function (prop, value) {
                    if (2 > arguments.length) {
                        var element = this[0];
                        if ("string" == typeof prop) {
                            return element ? element.style[camelize(prop)] || getComputedStyle(element, "").getPropertyValue(prop) : void 0;
                        }
                        if (isString(prop)) {
                            if (!element) {
                                return;
                            }
                            var el = {};
                            var computedStyle = getComputedStyle(element, "");
                            $.each(prop, function (dataAndEvents, property) {
                                el[property] = element.style[camelize(property)] || computedStyle.getPropertyValue(property);
                            });
                            return el;
                        }
                    }
                    /** @type {string} */
                    var css = "";
                    if ("string" == type(prop)) {
                        if (value || 0 === value) {
                            /** @type {string} */
                            css = dasherize(prop) + ":" + maybeAddPx(prop, value);
                        } else {
                            this.each(function () {
                                this.style.removeProperty(dasherize(prop));
                            });
                        }
                    } else {
                        for (key in prop) {
                            if (prop[key] || 0 === prop[key]) {
                                css += dasherize(key) + ":" + maybeAddPx(key, prop[key]) + ";";
                            } else {
                                this.each(function () {
                                    this.style.removeProperty(dasherize(key));
                                });
                            }
                        }
                    }
                    return this.each(function () {
                        this.style.cssText += ";" + css;
                    });
                },
                /**
                 * @param {Object} element
                 * @return {?}
                 */
                index: function (element) {
                    return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0]);
                },
                /**
                 * @param {string} name
                 * @return {?}
                 */
                hasClass: function (name) {
                    return name ? emptyArray.some.call(this, function (el) {
                        return this.test(className(el));
                    }, classRE(name)) : false;
                },
                /**
                 * @param {string} name
                 * @return {?}
                 */
                addClass: function (name) {
                    return name ? this.each(function (idx) {
                        if ("className" in this) {
                            /** @type {Array} */
                            classList = [];
                            var cls = className(this);
                            funcArg(this, name, idx, cls).split(/\s+/g).forEach(function (klass) {
                                if (!$(this).hasClass(klass)) {
                                    classList.push(klass);
                                }
                            }, this);
                            if (classList.length) {
                                className(this, cls + (cls ? " " : "") + classList.join(" "));
                            }
                        }
                    }) : this;
                },
                /**
                 * @param {?} name
                 * @return {?}
                 */
                removeClass: function (name) {
                    return this.each(function (idx) {
                        if ("className" in this) {
                            if (name === undef) {
                                return className(this, "");
                            }
                            classList = className(this);
                            funcArg(this, name, idx, classList).split(/\s+/g).forEach(function (klass) {
                                classList = classList.replace(classRE(klass), " ");
                            });
                            className(this, classList.trim());
                        }
                    });
                },
                /**
                 * @param {(Function|string)} name
                 * @param {boolean} element
                 * @return {?}
                 */
                toggleClass: function (name, element) {
                    return name ? this.each(function (idx) {
                        var $this = $(this);
                        funcArg(this, name, idx, className(this)).split(/\s+/g).forEach(function (klass) {
                            if (element === undef ? !$this.hasClass(klass) : element) {
                                $this.addClass(klass);
                            } else {
                                $this.removeClass(klass);
                            }
                        });
                    }) : this;
                },
                /**
                 * @param {string} value
                 * @return {?}
                 */
                scrollTop: function (value) {
                    if (this.length) {
                        /** @type {boolean} */
                        var hasScrollTop = "scrollTop" in this[0];
                        return value === undef ? hasScrollTop ? this[0].scrollTop : this[0].pageYOffset : this.each(hasScrollTop ? function () {
                            /** @type {string} */
                            this.scrollTop = value;
                        } : function () {
                            this.scrollTo(this.scrollX, value);
                        });
                    }
                },
                /**
                 * @param {number} value
                 * @return {?}
                 */
                scrollLeft: function (value) {
                    if (this.length) {
                        /** @type {boolean} */
                        var hasScrollLeft = "scrollLeft" in this[0];
                        return value === undef ? hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset : this.each(hasScrollLeft ? function () {
                            /** @type {number} */
                            this.scrollLeft = value;
                        } : function () {
                            this.scrollTo(value, this.scrollY);
                        });
                    }
                },
                /**
                 * @return {?}
                 */
                position: function () {
                    if (this.length) {
                        var ctx = this[0];
                        var offsetParent = this.offsetParent();
                        var offset = this.offset();
                        var parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? {
                            top: 0,
                            left: 0
                        } : offsetParent.offset();
                        offset.top -= parseFloat($(ctx).css("margin-top")) || 0;
                        offset.left -= parseFloat($(ctx).css("margin-left")) || 0;
                        parentOffset.top += parseFloat($(offsetParent[0]).css("border-top-width")) || 0;
                        parentOffset.left += parseFloat($(offsetParent[0]).css("border-left-width")) || 0;
                        return {
                            top: offset.top - parentOffset.top,
                            left: offset.left - parentOffset.left
                        };
                    }
                },
                /**
                 * @return {?}
                 */
                offsetParent: function () {
                    return this.map(function () {
                        var parent = this.offsetParent || doc.body;
                        for (; parent && (!rootNodeRE.test(parent.nodeName) && "static" == $(parent).css("position"));) {
                            parent = parent.offsetParent;
                        }
                        return parent;
                    });
                }
            };
            /** @type {function (): ?} */
            $.fn.detach = $.fn.remove;
            ["width", "height"].forEach(function (dimension) {
                var dimensionProperty = dimension.replace(/./, function (m) {
                    return m[0].toUpperCase();
                });
                /**
                 * @param {Function} value
                 * @return {?}
                 */
                $.fn[dimension] = function (value) {
                    var offset;
                    var el = this[0];
                    return value === undef ? isWindow(el) ? el["inner" + dimensionProperty] : null != el && el.nodeType == el.DOCUMENT_NODE ? el.documentElement["scroll" + dimensionProperty] : (offset = this.offset()) && offset[dimension] : this.each(function (idx) {
                        el = $(this);
                        el.css(dimension, funcArg(this, value, idx, el[dimension]()));
                    });
                };
            });
            ["after", "prepend", "before", "append"].forEach(function (operator, operatorIndex) {
                /** @type {number} */
                var inside = operatorIndex % 2;
                /**
                 * @return {?}
                 */
                $.fn[operator] = function () {
                    var $clone_type;
                    var resolveValues = $.map(arguments, function (selector) {
                        /** @type {Array} */
                        var flattened = [];
                        $clone_type = type(selector);
                        return "array" == $clone_type ? (selector.forEach(function (element) {
                            if (element.nodeType !== undef) {
                                return flattened.push(element);
                            }
                            if ($.zepto.isZ(element)) {
                                return flattened = flattened.concat(element.get());
                            }
                            flattened = flattened.concat(zepto.fragment(element));
                        }), flattened) : "object" == $clone_type || null == selector ? selector : zepto.fragment(selector);
                    });
                    var parent;
                    /** @type {boolean} */
                    var d = 1 < this.length;
                    return 1 > resolveValues.length ? this : this.each(function (dataAndEvents, target) {
                        parent = inside ? target : target.parentNode;
                        target = 0 == operatorIndex ? target.nextSibling : 1 == operatorIndex ? target.firstChild : 2 == operatorIndex ? target : null;
                        var findNode = $.contains(doc.documentElement, parent);
                        resolveValues.forEach(function (node) {
                            if (d) {
                                node = node.cloneNode(true);
                            } else {
                                if (!parent) {
                                    return $(node).remove();
                                }
                            }
                            parent.insertBefore(node, target);
                            if (findNode) {
                                traverseNode(node, function (node) {
                                    if (!(null == node.nodeName || ("SCRIPT" !== node.nodeName.toUpperCase() || (node.type && "text/javascript" !== node.type || node.src)))) {
                                        var s = node.ownerDocument ? node.ownerDocument.defaultView : win;
                                        s.eval.call(s, node.innerHTML);
                                    }
                                });
                            }
                        });
                    });
                };
                /**
                 * @param {Object} html
                 * @return {?}
                 */
                $.fn[inside ? operator + "To" : "insert" + (operatorIndex ? "Before" : "After")] = function (html) {
                    $(html)[operator](this);
                    return this;
                };
            });
            zepto.Z.prototype = Z.prototype = $.fn;
            /** @type {function (string): ?} */
            zepto.uniq = uniq;
            /** @type {function (Object): ?} */
            zepto.deserializeValue = deserializeValue;
            $.zepto = zepto;
            return $;
        }();
        (function ($) {
            /**
             * @param {Function} element
             * @return {?}
             */
            function zid(element) {
                return element._zid || (element._zid = _zid++);
            }
            /**
             * @param {Object} element
             * @param {string} event
             * @param {Function} fn
             * @param {Function} selector
             * @return {?}
             */
            function findHandlers(element, event, fn, selector) {
                event = parse(event);
                if (event.ns) {
                    /** @type {RegExp} */
                    var matcher = new RegExp("(?:^| )" + event.ns.replace(" ", " .* ?") + "(?: |$)")
                }
                return (handlers[zid(element)] || []).filter(function (handler) {
                    return handler && ((!event.e || handler.e == event.e) && ((!event.ns || matcher.test(handler.ns)) && ((!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector))));
                });
            }
            /**
             * @param {string} event
             * @return {?}
             */
            function parse(event) {
                /** @type {Array.<string>} */
                event = ("" + event).split(".");
                return {
                    e: event[0],
                    ns: event.slice(1).sort().join(" ")
                };
            }
            /**
             * @param {(Array|string)} type
             * @return {?}
             */
            function realEvent(type) {
                return hover[type] || (focusinSupported && focus[type] || type);
            }
            /**
             * @param {Object} element
             * @param {string} expr
             * @param {Function} fn
             * @param {string} node
             * @param {string} selector
             * @param {boolean} delegator
             * @param {?} vec0
             * @return {undefined}
             */
            function add(element, expr, fn, node, selector, delegator, vec0) {
                var id = zid(element);
                var set = handlers[id] || (handlers[id] = []);
                expr.split(/\s/).forEach(function (event) {
                    if ("ready" == event) {
                        return $(document).ready(fn);
                    }
                    var handler = parse(event);
                    handler.fn = fn;
                    /** @type {string} */
                    handler.sel = selector;
                    if (handler.e in hover) {
                        /**
                         * @param {Object} attr
                         * @return {?}
                         */
                        fn = function (attr) {
                            var target = attr.relatedTarget;
                            if (!target || target !== this && !$.contains(this, target)) {
                                return handler.fn.apply(this, arguments);
                            }
                        };
                    }
                    var callback = (handler.del = delegator) || fn;
                    /**
                     * @param {Object} e
                     * @return {?}
                     */
                    handler.proxy = function (e) {
                        e = compatible(e);
                        if (!e.isImmediatePropagationStopped()) {
                            /** @type {string} */
                            e.data = node;
                            var result = callback.apply(element, e._args == value ? [e] : [e].concat(e._args));
                            if (false === result) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            return result;
                        }
                    };
                    handler.i = set.length;
                    set.push(handler);
                    if ("addEventListener" in element) {
                        element.addEventListener(realEvent(handler.e), handler.proxy, handler.del && (!focusinSupported && handler.e in focus) || !!vec0);
                    }
                });
            }
            /**
             * @param {Object} element
             * @param {string} expr
             * @param {Function} fn
             * @param {Function} selector
             * @param {Function} owner
             * @return {undefined}
             */
            function remove(element, expr, fn, selector, owner) {
                var id = zid(element);
                (expr || "").split(/\s/).forEach(function (event) {
                    findHandlers(element, event, fn, selector).forEach(function (handler) {
                        delete handlers[id][handler.i];
                        if ("removeEventListener" in element) {
                            element.removeEventListener(realEvent(handler.e), handler.proxy, handler.del && (!focusinSupported && handler.e in focus) || !!owner);
                        }
                    });
                });
            }
            /**
             * @param {Object} event
             * @param {Object} source
             * @return {?}
             */
            function compatible(event, source) {
                if (source || !event.isDefaultPrevented) {
                    if (source || (source = event), $.each(which, function (name, predicate) {
                        var sourceMethod = source[name];
                        /**
                         * @return {?}
                         */
                        event[name] = function () {
                            /** @type {function (): ?} */
                            this[predicate] = returnTrue;
                            return sourceMethod && sourceMethod.apply(source, arguments);
                        };
                        /** @type {function (): ?} */
                        event[predicate] = returnFalse;
                    }), event.timeStamp || (event.timeStamp = Date.now()), source.defaultPrevented !== value ? source.defaultPrevented : "returnValue" in source ? false === source.returnValue : source.getPreventDefault && source.getPreventDefault()) {
                        /** @type {function (): ?} */
                        event.isDefaultPrevented = returnTrue;
                    }
                }
                return event;
            }
            /**
             * @param {Object} event
             * @return {?}
             */
            function createProxy(event) {
                var key;
                var proxy = {
                    originalEvent: event
                };
                for (key in event) {
                    if (!isint.test(key)) {
                        if (!(event[key] === value)) {
                            proxy[key] = event[key];
                        }
                    }
                }
                return compatible(proxy, event);
            }
            /** @type {number} */
            var _zid = 1;
            var value;
            /** @type {function (this:(Array.<T>|string|{length: number}), *=, *=): Array.<T>} */
            var __slice = Array.prototype.slice;
            var isFunction = $.isFunction;
            /**
             * @param {Function} value
             * @return {?}
             */
            var isString = function (value) {
                return "string" == typeof value;
            };
            var handlers = {};
            var specialEvents = {};
            /** @type {boolean} */
            var focusinSupported = "onfocusin" in win;
            var focus = {
                focus: "focusin",
                blur: "focusout"
            };
            var hover = {
                mouseenter: "mouseover",
                mouseleave: "mouseout"
            };
            /** @type {string} */
            specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = "MouseEvents";
            $.event = {
                /** @type {function (Object, string, Function, string, string, boolean, ?): undefined} */
                add: add,
                /** @type {function (Object, string, Function, Function, Function): undefined} */
                remove: remove
            };
            /**
             * @param {Function} fn
             * @param {Function} context
             * @return {?}
             */
            $.proxy = function (fn, context) {
                /** @type {(Array.<?>|boolean)} */
                var args = 2 in arguments && __slice.call(arguments, 2);
                if (isFunction(fn)) {
                    /**
                     * @return {?}
                     */
                    var proxyFn = function () {
                        return fn.apply(context, args ? args.concat(__slice.call(arguments)) : arguments);
                    };
                    proxyFn._zid = zid(fn);
                    return proxyFn;
                }
                if (isString(context)) {
                    return args ? (args.unshift(fn[context], fn), $.proxy.apply(null, args)) : $.proxy(fn[context], fn);
                }
                throw new TypeError("expected function");
            };
            /**
             * @param {string} event
             * @param {Function} selector
             * @param {Function} data
             * @return {?}
             */
            $.fn.bind = function (event, selector, data) {
                return this.on(event, selector, data);
            };
            /**
             * @param {string} types
             * @param {Function} selector
             * @return {?}
             */
            $.fn.unbind = function (types, selector) {
                return this.off(types, selector);
            };
            /**
             * @param {string} qualifier
             * @param {Function} selector
             * @param {Function} data
             * @param {Function} callback
             * @return {?}
             */
            $.fn.one = function (qualifier, selector, data, callback) {
                return this.on(qualifier, selector, data, callback, 1);
            };
            /**
             * @return {?}
             */
            var returnTrue = function () {
                return true;
            };
            /**
             * @return {?}
             */
            var returnFalse = function () {
                return false;
            };
            /** @type {RegExp} */
            var isint = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/;
            var which = {
                preventDefault: "isDefaultPrevented",
                stopImmediatePropagation: "isImmediatePropagationStopped",
                stopPropagation: "isPropagationStopped"
            };
            /**
             * @param {Function} selector
             * @param {string} event
             * @param {Function} data
             * @return {?}
             */
            $.fn.delegate = function (selector, event, data) {
                return this.on(event, selector, data);
            };
            /**
             * @param {Function} selector
             * @param {string} types
             * @param {Object} fn
             * @return {?}
             */
            $.fn.undelegate = function (selector, types, fn) {
                return this.off(types, selector, fn);
            };
            /**
             * @param {string} event
             * @param {Function} callback
             * @return {?}
             */
            $.fn.live = function (event, callback) {
                $(document.body).delegate(this.selector, event, callback);
                return this;
            };
            /**
             * @param {Object} event
             * @param {Object} callback
             * @return {?}
             */
            $.fn.die = function (event, callback) {
                $(document.body).undelegate(this.selector, event, callback);
                return this;
            };
            /**
             * @param {string} event
             * @param {Function} selector
             * @param {Function} data
             * @param {Function} callback
             * @param {number} one
             * @return {?}
             */
            $.fn.on = function (event, selector, data, callback, one) {
                var autoRemove;
                var delegator;
                var jQuery = this;
                if (event && !isString(event)) {
                    return $.each(event, function (qualifier, options) {
                        jQuery.on(qualifier, selector, data, options, one);
                    }), jQuery;
                }
                if (!isString(selector)) {
                    if (!isFunction(callback)) {
                        if (!(false === callback)) {
                            /** @type {Function} */
                            callback = data;
                            /** @type {Function} */
                            data = selector;
                            selector = value;
                        }
                    }
                }
                if (callback === value || false === data) {
                    /** @type {Function} */
                    callback = data;
                    data = value;
                }
                if (false === callback) {
                    /** @type {function (): ?} */
                    callback = returnFalse;
                }
                return jQuery.each(function (dataAndEvents, element) {
                    if (one) {
                        /**
                         * @param {Event} e
                         * @return {?}
                         */
                        autoRemove = function (e) {
                            remove(element, e.type, callback);
                            return callback.apply(this, arguments);
                        };
                    }
                    if (selector) {
                        /**
                         * @param {Object} e
                         * @return {?}
                         */
                        delegator = function (e) {
                            var match = $(e.target).closest(selector, element).get(0);
                            if (match && match !== element) {
                                var context = $.extend(createProxy(e), {
                                    currentTarget: match,
                                    liveFired: element
                                });
                                return (autoRemove || callback).apply(match, [context].concat(__slice.call(arguments, 1)));
                            }
                        };
                    }
                    add(element, event, callback, data, selector, delegator || autoRemove);
                });
            };
            /**
             * @param {string} func
             * @param {Function} selector
             * @param {Function} fn
             * @return {?}
             */
            $.fn.off = function (func, selector, fn) {
                var _this = this;
                if (func && !isString(func)) {
                    return $.each(func, function (event, handler) {
                        _this.off(event, selector, handler);
                    }), _this;
                }
                if (!isString(selector)) {
                    if (!isFunction(fn)) {
                        if (!(false === fn)) {
                            /** @type {Function} */
                            fn = selector;
                            selector = value;
                        }
                    }
                }
                if (false === fn) {
                    /** @type {function (): ?} */
                    fn = returnFalse;
                }
                return _this.each(function () {
                    remove(this, func, fn, selector);
                });
            };
            /**
             * @param {string} event
             * @param {?} object
             * @return {?}
             */
            $.fn.trigger = function (event, object) {
                event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
                event._args = object;
                return this.each(function () {
                    if (event.type in focus && "function" == typeof this[event.type]) {
                        this[event.type]();
                    } else {
                        if ("dispatchEvent" in this) {
                            this.dispatchEvent(event);
                        } else {
                            $(this).triggerHandler(event, object);
                        }
                    }
                });
            };
            /**
             * @param {Function} event
             * @param {?} args
             * @return {?}
             */
            $.fn.triggerHandler = function (event, args) {
                var e;
                var result;
                this.each(function (dataAndEvents, element) {
                    e = createProxy(isString(event) ? $.Event(event) : event);
                    e._args = args;
                    /** @type {Object} */
                    e.target = element;
                    $.each(findHandlers(element, event.type || event), function (dataAndEvents, handler) {
                        result = handler.proxy(e);
                        if (e.isImmediatePropagationStopped()) {
                            return false;
                        }
                    });
                });
                return result;
            };
            "focusin focusout focus blur load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error".split(" ").forEach(function (name) {
                /**
                 * @param {Function} dest
                 * @return {?}
                 */
                $.fn[name] = function (dest) {
                    return 0 in arguments ? this.bind(name, dest) : this.trigger(name);
                };
            });
            /**
             * @param {Function} type
             * @param {Function} props
             * @return {?}
             */
            $.Event = function (type, props) {
                if (!isString(type)) {
                    /** @type {Function} */
                    props = type;
                    type = props.type;
                }
                /** @type {(Event|null)} */
                var event = document.createEvent(specialEvents[type] || "Events");
                /** @type {boolean} */
                var bubbles = true;
                if (props) {
                    var i;
                    for (i in props) {
                        if ("bubbles" == i) {
                            /** @type {boolean} */
                            bubbles = !!props[i];
                        } else {
                            event[i] = props[i];
                        }
                    }
                }
                event.initEvent(type, bubbles, true);
                return compatible(event);
            };
        })(jQuery);
        (function ($) {
            /**
             * @param {Object} settings
             * @param {Object} context
             * @param {string} eventName
             * @param {Array} data
             * @return {?}
             */
            function triggerGlobal(settings, context, eventName, data) {
                if (settings.global) {
                    return settings = context || doc, eventName = $.Event(eventName), $(settings).trigger(eventName, data), !eventName.isDefaultPrevented();
                }
            }
            /**
             * @param {Object} settings
             * @return {undefined}
             */
            function ajaxStart(settings) {
                if (settings.global) {
                    if (0 === $.active++) {
                        triggerGlobal(settings, null, "ajaxStart");
                    }
                }
            }
            /**
             * @param {?} xhr
             * @param {Object} settings
             * @return {?}
             */
            function ajaxBeforeSend(xhr, settings) {
                var context = settings.context;
                if (false === settings.beforeSend.call(context, xhr, settings) || false === triggerGlobal(settings, context, "ajaxBeforeSend", [xhr, settings])) {
                    return false;
                }
                triggerGlobal(settings, context, "ajaxSend", [xhr, settings]);
            }
            /**
             * @param {?} data
             * @param {?} xhr
             * @param {Object} settings
             * @param {?} deferred
             * @return {undefined}
             */
            function ajaxSuccess(data, xhr, settings, deferred) {
                var context = settings.context;
                settings.success.call(context, data, "success", xhr);
                if (deferred) {
                    deferred.resolveWith(context, [data, "success", xhr]);
                }
                triggerGlobal(settings, context, "ajaxSuccess", [xhr, settings, data]);
                ajaxComplete("success", xhr, settings);
            }
            /**
             * @param {Object} error
             * @param {string} type
             * @param {?} xhr
             * @param {Object} settings
             * @param {?} deferred
             * @return {undefined}
             */
            function ajaxError(error, type, xhr, settings, deferred) {
                var context = settings.context;
                settings.error.call(context, xhr, type, error);
                if (deferred) {
                    deferred.rejectWith(context, [xhr, type, error]);
                }
                triggerGlobal(settings, context, "ajaxError", [xhr, settings, error || type]);
                ajaxComplete(type, xhr, settings);
            }
            /**
             * @param {string} status
             * @param {?} xhr
             * @param {Object} settings
             * @return {undefined}
             */
            function ajaxComplete(status, xhr, settings) {
                var context = settings.context;
                settings.complete.call(context, xhr, status);
                triggerGlobal(settings, context, "ajaxComplete", [xhr, settings]);
                if (settings.global) {
                    if (!--$.active) {
                        triggerGlobal(settings, null, "ajaxStop");
                    }
                }
            }
            /**
             * @return {undefined}
             */
            function empty() {
            }
            /**
             * @param {Object} mime
             * @return {?}
             */
            function mimeToDataType(mime) {
                if (mime) {
                    mime = mime.split(";", 2)[0];
                }
                return mime && ("text/html" == mime ? "html" : "application/json" == mime ? "json" : rchecked.test(mime) ? "script" : exclude.test(mime) && "xml") || "text";
            }
            /**
             * @param {string} label
             * @param {string} str
             * @return {?}
             */
            function appendQuery(label, str) {
                return "" == str ? label : (label + "&" + str).replace(/[&?]{1,2}/, "?");
            }
            /**
             * @param {Object} options
             * @return {undefined}
             */
            function serializeData(options) {
                if (options.processData) {
                    if (options.data) {
                        if ("string" != $.type(options.data)) {
                            options.data = $.param(options.data, options.traditional);
                        }
                    }
                }
                if (!!options.data) {
                    if (!(options.type && ("GET" != options.type.toUpperCase() && "jsonp" != options.dataType))) {
                        options.url = appendQuery(options.url, options.data);
                        options.data = void 0;
                    }
                }
            }
            /**
             * @param {string} file
             * @param {Object} data
             * @param {string} callback
             * @param {string} positionError
             * @return {?}
             */
            function fail(file, data, callback, positionError) {
                if ($.isFunction(data)) {
                    /** @type {string} */
                    positionError = callback;
                    /** @type {Object} */
                    callback = data;
                    data = void 0;
                }
                if (!$.isFunction(callback)) {
                    /** @type {string} */
                    positionError = callback;
                    callback = void 0;
                }
                return {
                    url: file,
                    data: data,
                    success: callback,
                    dataType: positionError
                };
            }
            /**
             * @param {Object} params
             * @param {?} a
             * @param {boolean} traditional
             * @param {string} scope
             * @return {undefined}
             */
            function serialize(params, a, traditional, scope) {
                var $clone_type;
                var array = $.isArray(a);
                var hash = $.isPlainObject(a);
                $.each(a, function (key, obj) {
                    $clone_type = $.type(obj);
                    if (scope) {
                        key = traditional ? scope : scope + "[" + (hash || ("object" == $clone_type || "array" == $clone_type) ? key : "") + "]";
                    }
                    if (!scope && array) {
                        params.add(obj.name, obj.value);
                    } else {
                        if ("array" == $clone_type || !traditional && "object" == $clone_type) {
                            serialize(params, obj, traditional, key);
                        } else {
                            params.add(key, obj);
                        }
                    }
                });
            }
            /** @type {number} */
            var Zepto = +new Date;
            var doc = win.document;
            var key;
            var name;
            /** @type {RegExp} */
            var rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
            /** @type {RegExp} */
            var rchecked = /^(?:text|application)\/javascript/i;
            /** @type {RegExp} */
            var exclude = /^(?:text|application)\/xml/i;
            /** @type {RegExp} */
            var rbrace = /^\s*$/;
            var l = doc.createElement("a");
            l.href = win.location.href;
            /** @type {number} */
            $.active = 0;
            /**
             * @param {Object} options
             * @param {?} deferred
             * @return {?}
             */
            $.ajaxJSONP = function (options, deferred) {
                if (!("type" in options)) {
                    return $.ajax(options);
                }
                var _callbackName = options.jsonpCallback;
                var key = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || "Zepto" + Zepto++;
                var script = doc.createElement("script");
                var value = win[key];
                var responseData;
                /**
                 * @param {string} errorType
                 * @return {undefined}
                 */
                var abort = function (errorType) {
                    $(script).triggerHandler("error", errorType || "abort");
                };
                var xhr = {
                    /** @type {function (string): undefined} */
                    abort: abort
                };
                var tref;
                if (deferred) {
                    deferred.promise(xhr);
                }
                $(script).on("load error", function (error, errorType) {
                    clearTimeout(tref);
                    $(script).off().remove();
                    if ("error" != error.type && responseData) {
                        ajaxSuccess(responseData[0], xhr, options, deferred);
                    } else {
                        ajaxError(null, errorType || "error", xhr, options, deferred);
                    }
                    win[key] = value;
                    if (responseData) {
                        if ($.isFunction(value)) {
                            value(responseData[0]);
                        }
                    }
                    value = responseData = void 0;
                });
                if (false === ajaxBeforeSend(xhr, options)) {
                    return abort("abort"), xhr;
                }
                /**
                 * @return {undefined}
                 */
                win[key] = function () {
                    /** @type {Arguments} */
                    responseData = arguments;
                };
                script.src = options.url.replace(/\?(.+)=\?/, "?$1=" + key);
                doc.head.appendChild(script);
                if (0 < options.timeout) {
                    /** @type {number} */
                    tref = setTimeout(function () {
                        abort("timeout");
                    }, options.timeout);
                }
                return xhr;
            };
            $.ajaxSettings = {
                type: "GET",
                /** @type {function (): undefined} */
                beforeSend: empty,
                /** @type {function (): undefined} */
                success: empty,
                /** @type {function (): undefined} */
                error: empty,
                /** @type {function (): undefined} */
                complete: empty,
                context: null,
                global: true,
                /**
                 * @return {?}
                 */
                xhr: function () {
                    return new win.XMLHttpRequest;
                },
                accepts: {
                    script: "text/javascript, application/javascript, application/x-javascript",
                    json: "application/json",
                    xml: "application/xml, text/xml",
                    html: "text/html",
                    text: "text/plain"
                },
                crossDomain: false,
                timeout: 0,
                processData: true,
                cache: true,
                /** @type {function (): undefined} */
                dataFilter: empty
            };
            /**
             * @param {string} options
             * @return {?}
             */
            $.ajax = function (options) {
                var settings = $.extend({}, options || {});
                var deferred = $.Deferred && $.Deferred();
                for (key in $.ajaxSettings) {
                    if (void 0 === settings[key]) {
                        settings[key] = $.ajaxSettings[key];
                    }
                }
                ajaxStart(settings);
                if (!settings.crossDomain) {
                    var e = doc.createElement("a");
                    e.href = settings.url;
                    e.href = e.href;
                    /** @type {boolean} */
                    settings.crossDomain = l.protocol + "//" + l.host !== e.protocol + "//" + e.host;
                }
                if (!settings.url) {
                    settings.url = win.location.toString();
                }
                if (-1 < (e = settings.url.indexOf("#"))) {
                    settings.url = settings.url.slice(0, e);
                }
                serializeData(settings);
                var dataType = settings.dataType;
                if (e = /\?.+=\?/.test(settings.url)) {
                    /** @type {string} */
                    dataType = "jsonp";
                }
                if (!(false !== settings.cache && (options && true === options.cache || "script" != dataType && "jsonp" != dataType))) {
                    settings.url = appendQuery(settings.url, "_=" + Date.now());
                }
                if ("jsonp" == dataType) {
                    return e || (settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + "=?" : false === settings.jsonp ? "" : "callback=?")), $.ajaxJSONP(settings, deferred);
                }
                options = settings.accepts[dataType];
                var headers = {};
                /**
                 * @param {string} name
                 * @param {?} value
                 * @return {undefined}
                 */
                e = function (name, value) {
                    /** @type {Array} */
                    headers[name.toLowerCase()] = [name, value];
                };
                var z = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : win.location.protocol;
                var xhr = settings.xhr();
                var nativeSetHeader = xhr.setRequestHeader;
                var tref;
                if (deferred) {
                    deferred.promise(xhr);
                }
                if (!settings.crossDomain) {
                    e("X-Requested-With", "XMLHttpRequest");
                }
                e("Accept", options || "*/*");
                if (options = settings.mimeType || options) {
                    if (-1 < options.indexOf(",")) {
                        options = options.split(",", 2)[0];
                    }
                    if (xhr.overrideMimeType) {
                        xhr.overrideMimeType(options);
                    }
                }
                if (settings.contentType || false !== settings.contentType && (settings.data && "GET" != settings.type.toUpperCase())) {
                    e("Content-Type", settings.contentType || "application/x-www-form-urlencoded");
                }
                if (settings.headers) {
                    for (name in settings.headers) {
                        e(name, settings.headers[name]);
                    }
                }
                /** @type {function (string, ?): undefined} */
                xhr.setRequestHeader = e;
                /**
                 * @return {?}
                 */
                xhr.onreadystatechange = function () {
                    if (4 == xhr.readyState) {
                        /** @type {function (): undefined} */
                        xhr.onreadystatechange = empty;
                        clearTimeout(tref);
                        /** @type {boolean} */
                        var error = false;
                        if (200 <= xhr.status && 300 > xhr.status || (304 == xhr.status || 0 == xhr.status && "file:" == z)) {
                            dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader("content-type"));
                            if ("arraybuffer" == xhr.responseType || "blob" == xhr.responseType) {
                                var data = xhr.response
                            } else {
                                data = xhr.responseText;
                                try {
                                    data = settings.dataFilter == empty ? data : settings.dataFilter.call(settings.context, data, dataType);
                                    if ("script" == dataType) {
                                        (0, eval)(data);
                                    } else {
                                        if ("xml" == dataType) {
                                            data = xhr.responseXML;
                                        } else {
                                            if ("json" == dataType) {
                                                data = rbrace.test(data) ? null : $.parseJSON(data);
                                            }
                                        }
                                    }
                                } catch (err) {
                                    error = err;
                                }
                                if (error) {
                                    return ajaxError(error, "parsererror", xhr, settings, deferred);
                                }
                            }
                            ajaxSuccess(data, xhr, settings, deferred);
                        } else {
                            ajaxError(xhr.statusText || null, xhr.status ? "error" : "abort", xhr, settings, deferred);
                        }
                    }
                };
                if (false === ajaxBeforeSend(xhr, settings)) {
                    return xhr.abort(), ajaxError(null, "abort", xhr, settings, deferred), xhr;
                }
                xhr.open(settings.type, settings.url, "async" in settings ? settings.async : true, settings.username, settings.password);
                if (settings.xhrFields) {
                    for (name in settings.xhrFields) {
                        xhr[name] = settings.xhrFields[name];
                    }
                }
                for (name in headers) {
                    nativeSetHeader.apply(xhr, headers[name]);
                }
                if (0 < settings.timeout) {
                    /** @type {number} */
                    tref = setTimeout(function () {
                        /** @type {function (): undefined} */
                        xhr.onreadystatechange = empty;
                        xhr.abort();
                        ajaxError(null, "timeout", xhr, settings, deferred);
                    }, settings.timeout);
                }
                xhr.send(settings.data ? settings.data : null);
                return xhr;
            };
            /**
             * @return {?}
             */
            $.get = function () {
                return $.ajax(fail.apply(null, arguments));
            };
            /**
             * @return {?}
             */
            $.post = function () {
                var options = fail.apply(null, arguments);
                /** @type {string} */
                options.type = "POST";
                return $.ajax(options);
            };
            /**
             * @return {?}
             */
            $.getJSON = function () {
                var options = fail.apply(null, arguments);
                /** @type {string} */
                options.dataType = "json";
                return $.ajax(options);
            };
            /**
             * @param {string} options
             * @param {Object} args
             * @param {string} callback
             * @return {?}
             */
            $.fn.load = function (options, args, callback) {
                if (!this.length) {
                    return this;
                }
                var self = this;
                var match = options.split(/\s/);
                options = fail(options, args, callback);
                /** @type {function (string): undefined} */
                var success = options.success;
                if (1 < match.length) {
                    options.url = match[0];
                    var selector = match[1];
                }
                /**
                 * @param {string} response
                 * @return {undefined}
                 */
                options.success = function (response) {
                    self.html(selector ? $("<div>").html(response.replace(rscript, "")).find(selector) : response);
                    if (success) {
                        success.apply(self, arguments);
                    }
                };
                $.ajax(options);
                return this;
            };
            /** @type {function (string): string} */
            var forIn = encodeURIComponent;
            /**
             * @param {?} obj
             * @param {boolean} traditional
             * @return {?}
             */
            $.param = function (obj, traditional) {
                /** @type {Array} */
                var params = [];
                /**
                 * @param {?} object
                 * @param {Object} value
                 * @return {undefined}
                 */
                params.add = function (object, value) {
                    if ($.isFunction(value)) {
                        value = value();
                    }
                    if (null == value) {
                        /** @type {string} */
                        value = "";
                    }
                    this.push(forIn(object) + "=" + forIn(value));
                };
                serialize(params, obj, traditional);
                return params.join("&").replace(/%20/g, "+");
            };
        })(jQuery);
        (function ($) {
            /**
             * @return {?}
             */
            $.fn.serializeArray = function () {
                var ret;
                var type;
                /** @type {Array} */
                var result = [];
                /**
                 * @param {Array} obj
                 * @return {?}
                 */
                var iterator = function (obj) {
                    if (obj.forEach) {
                        return obj.forEach(iterator);
                    }
                    result.push({
                        name: ret,
                        value: obj
                    });
                };
                if (this[0]) {
                    $.each(this[0].elements, function (dataAndEvents, elem) {
                        type = elem.type;
                        if (ret = elem.name) {
                            if ("fieldset" != elem.nodeName.toLowerCase()) {
                                if (!elem.disabled) {
                                    if ("submit" != type) {
                                        if ("reset" != type) {
                                            if ("button" != type) {
                                                if ("file" != type) {
                                                    if ("radio" != type && "checkbox" != type || elem.checked) {
                                                        iterator($(elem).val());
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    });
                }
                return result;
            };
            /**
             * @return {?}
             */
            $.fn.serialize = function () {
                /** @type {Array} */
                var tagNameArr = [];
                this.serializeArray().forEach(function (elm) {
                    tagNameArr.push(encodeURIComponent(elm.name) + "=" + encodeURIComponent(elm.value));
                });
                return tagNameArr.join("&");
            };
            /**
             * @param {Function} dest
             * @return {?}
             */
            $.fn.submit = function (dest) {
                if (0 in arguments) {
                    this.bind("submit", dest);
                } else {
                    if (this.length) {
                        var event = $.Event("submit");
                        this.eq(0).trigger(event);
                        if (!event.isDefaultPrevented()) {
                            this.get(0).submit();
                        }
                    }
                }
                return this;
            };
        })(jQuery);
        (function () {
            try {
                getComputedStyle(void 0);
            } catch (h) {
                var nativeGetComputedStyle = getComputedStyle;
                /**
                 * @param {?} element
                 * @param {?} querySelector
                 * @return {?}
                 */
                win.getComputedStyle = function (element, querySelector) {
                    try {
                        return nativeGetComputedStyle(element, querySelector);
                    } catch (da) {
                        return null;
                    }
                };
            }
        })();
        return jQuery;
    });
    (function () {
        /**
         * @param {number} val
         * @return {?}
         */
        function loop(val) {
            return function (children, handler, child, params) {
                handler = call(handler, params, 4);
                var indices = !isArray(children) && _.keys(children);
                var valuesLen = (indices || children).length;
                /** @type {number} */
                var i = 0 < val ? 0 : valuesLen - 1;
                if (3 > arguments.length) {
                    child = children[indices ? indices[i] : i];
                    i += val;
                }
                var callback = handler;
                /** @type {Text} */
                var basis = child;
                for (; 0 <= i && i < valuesLen; i += val) {
                    var index = indices ? indices[i] : i;
                    basis = callback(basis, children[index], index, children);
                }
                return basis;
            };
        }
        /**
         * @param {number} step
         * @return {?}
         */
        function range(step) {
            return function (res, callback, thisObj) {
                callback = makeIterator(callback, thisObj);
                thisObj = value(res);
                /** @type {number} */
                var i = 0 < step ? 0 : thisObj - 1;
                for (; 0 <= i && i < thisObj; i += step) {
                    if (callback(res[i], i, res)) {
                        return i;
                    }
                }
                return -1;
            };
        }
        /**
         * @param {number} w
         * @param {?} $
         * @param {number} callback
         * @return {?}
         */
        function init(w, $, callback) {
            return function (array, item, i) {
                /** @type {number} */
                var n = 0;
                var end = value(array);
                if ("number" == typeof i) {
                    if (0 < w) {
                        /** @type {number} */
                        n = 0 <= i ? i : Math.max(i + end, n);
                    } else {
                        end = 0 <= i ? Math.min(i + 1, end) : i + end + 1;
                    }
                } else {
                    if (callback && (i && end)) {
                        return i = callback(array, item), array[i] === item ? i : -1;
                    }
                }
                if (item !== item) {
                    return i = $(slice.call(array, n, end), _.isNaN), 0 <= i ? i + n : -1;
                }
                /** @type {number} */
                i = 0 < w ? n : end - 1;
                for (; 0 <= i && i < end; i += w) {
                    if (array[i] === item) {
                        return i;
                    }
                }
                return -1;
            };
        }
        /**
         * @param {Object} obj
         * @param {Object} arr
         * @return {undefined}
         */
        function has(obj, arr) {
            /** @type {number} */
            var index = tokenized.length;
            var value = obj.constructor;
            value = _.isFunction(value) && value.prototype || ObjProto;
            /** @type {string} */
            var key = "constructor";
            if (_.has(obj, key)) {
                if (!_.contains(arr, key)) {
                    arr.push(key);
                }
            }
            for (; index--;) {
                /** @type {string} */
                key = tokenized[index];
                if (key in obj) {
                    if (obj[key] !== value[key]) {
                        if (!_.contains(arr, key)) {
                            arr.push(key);
                        }
                    }
                }
            }
        }
        var root = this;
        var previousUnderscore = root._;
        var ArrayProto = Array.prototype;
        var ObjProto = Object.prototype;
        /** @type {function (this:(Array.<T>|{length: number}), ...[T]): number} */
        var push = ArrayProto.push;
        /** @type {function (this:(Array.<T>|string|{length: number}), *=, *=): Array.<T>} */
        var slice = ArrayProto.slice;
        /** @type {function (this:*): string} */
        var toString = ObjProto.toString;
        /** @type {function (this:Object, *): boolean} */
        var hasOwnProperty = ObjProto.hasOwnProperty;
        /** @type {function (*): boolean} */
        var x = Array.isArray;
        /** @type {function (Object): Array.<string>} */
        var nativeKeys = Object.keys;
        /** @type {function (this:Function, (Object|null|undefined), ...[*]): Function} */
        var nativeBind = Function.prototype.bind;
        /** @type {function ((Object|null), (Object|null)=): Object} */
        var create = Object.create;
        /**
         * @return {undefined}
         */
        var F = function () {
        };
        /**
         * @param {?} obj
         * @return {?}
         */
        var _ = function (obj) {
            if (obj instanceof _) {
                return obj;
            }
            if (!(this instanceof _)) {
                return new _(obj);
            }
            this._wrapped = obj;
        };
        if ("undefined" !== typeof exports) {
            if ("undefined" !== typeof module) {
                if (module.exports) {
                    /** @type {function (?): ?} */
                    exports = module.exports = _;
                }
            }
            /** @type {function (?): ?} */
            exports._ = _;
        } else {
            /** @type {function (?): ?} */
            root._ = _;
        }
        /** @type {string} */
        _.VERSION = "1.8.3";
        /**
         * @param {Function} func
         * @param {number} str
         * @param {number} deepDataAndEvents
         * @return {?}
         */
        var call = function (func, str, deepDataAndEvents) {
            if (void 0 === str) {
                return func;
            }
            switch (null == deepDataAndEvents ? 3 : deepDataAndEvents) {
                case 1:
                    return function (accumulator) {
                        return func.call(str, accumulator);
                    };
                case 2:
                    return function (accumulator, index) {
                        return func.call(str, accumulator, index);
                    };
                case 3:
                    return function (accumulator, index, object) {
                        return func.call(str, accumulator, index, object);
                    };
                case 4:
                    return function (accumulator, index, object, collection) {
                        return func.call(str, accumulator, index, object, collection);
                    };
            }
            return function () {
                return func.apply(str, arguments);
            };
        };
        /**
         * @param {string} value
         * @param {?} thisObj
         * @param {number} deepDataAndEvents
         * @return {?}
         */
        var makeIterator = function (value, thisObj, deepDataAndEvents) {
            return null == value ? _.identity : _.isFunction(value) ? call(value, thisObj, deepDataAndEvents) : _.isObject(value) ? _.matcher(value) : _.property(value);
        };
        /**
         * @param {string} isXML
         * @param {?} thisObj
         * @return {?}
         */
        _.iteratee = function (isXML, thisObj) {
            return makeIterator(isXML, thisObj, Infinity);
        };
        /**
         * @param {Function} pred
         * @param {boolean} inplace
         * @return {?}
         */
        var filter = function (pred, inplace) {
            return function (cache) {
                /** @type {number} */
                var argLength = arguments.length;
                if (2 > argLength || null == cache) {
                    return cache;
                }
                /** @type {number} */
                var i = 1;
                for (; i < argLength; i++) {
                    var data = arguments[i];
                    var props = pred(data);
                    var length = props.length;
                    /** @type {number} */
                    var index = 0;
                    for (; index < length; index++) {
                        var prop = props[index];
                        if (!(inplace && void 0 !== cache[prop])) {
                            cache[prop] = data[prop];
                        }
                    }
                }
                return cache;
            };
        };
        /**
         * @param {Function} obj
         * @return {?}
         */
        var mixin = function (obj) {
            if (!_.isObject(obj)) {
                return {};
            }
            if (create) {
                return create(obj);
            }
            /** @type {Function} */
            F.prototype = obj;
            obj = new F;
            /** @type {null} */
            F.prototype = null;
            return obj;
        };
        /**
         * @param {Function} key
         * @return {?}
         */
        var parse = function (key) {
            return function ($cookies) {
                return null == $cookies ? void 0 : $cookies[key];
            };
        };
        /** @type {number} */
        var finish = Math.pow(2, 53) - 1;
        var value = parse("length");
        /**
         * @param {?} obj
         * @return {?}
         */
        var isArray = function (obj) {
            obj = value(obj);
            return "number" == typeof obj && (0 <= obj && obj <= finish);
        };
        /** @type {function (Function, Function, number): ?} */
        _.each = _.forEach = function (obj, callback, i) {
            callback = call(callback, i);
            var l;
            if (isArray(obj)) {
                /** @type {number} */
                i = 0;
                l = obj.length;
                for (; i < l; i++) {
                    callback(obj[i], i, obj);
                }
            } else {
                var items = _.keys(obj);
                /** @type {number} */
                i = 0;
                l = items.length;
                for (; i < l; i++) {
                    callback(obj[items[i]], items[i], obj);
                }
            }
            return obj;
        };
        /** @type {function (string, Function, Object): ?} */
        _.map = _.collect = function (obj, callback, thisObj) {
            callback = makeIterator(callback, thisObj);
            thisObj = !isArray(obj) && _.keys(obj);
            var length = (thisObj || obj).length;
            /** @type {Array} */
            var results = Array(length);
            /** @type {number} */
            var index = 0;
            for (; index < length; index++) {
                var value = thisObj ? thisObj[index] : index;
                results[index] = callback(obj[value], value, obj);
            }
            return results;
        };
        _.reduce = _.foldl = _.inject = loop(1);
        _.reduceRight = _.foldr = loop(-1);
        /** @type {function (Object, number, ?): ?} */
        _.find = _.detect = function (item, f, remove) {
            f = isArray(item) ? _.findIndex(item, f, remove) : _.findKey(item, f, remove);
            if (void 0 !== f && -1 !== f) {
                return item[f];
            }
        };
        /** @type {function (Function, Function, ?): ?} */
        _.filter = _.select = function (obj, callback, thisObj) {
            /** @type {Array} */
            var results = [];
            callback = makeIterator(callback, thisObj);
            _.each(obj, function (result, mongoObject, arg) {
                if (callback(result, mongoObject, arg)) {
                    results.push(result);
                }
            });
            return results;
        };
        /**
         * @param {Function} obj
         * @param {string} iterator
         * @param {?} context
         * @return {?}
         */
        _.reject = function (obj, iterator, context) {
            return _.filter(obj, _.negate(makeIterator(iterator)), context);
        };
        /** @type {function (string, Text, Object): ?} */
        _.every = _.all = function (obj, callback, thisObj) {
            callback = makeIterator(callback, thisObj);
            thisObj = !isArray(obj) && _.keys(obj);
            var valuesLen = (thisObj || obj).length;
            /** @type {number} */
            var i = 0;
            for (; i < valuesLen; i++) {
                var idx = thisObj ? thisObj[i] : i;
                if (!callback(obj[idx], idx, obj)) {
                    return false;
                }
            }
            return true;
        };
        /** @type {function (string, Text, Object): ?} */
        _.some = _.any = function (obj, iterator, context) {
            iterator = makeIterator(iterator, context);
            context = !isArray(obj) && _.keys(obj);
            var numrows = (context || obj).length;
            /** @type {number} */
            var k = 0;
            for (; k < numrows; k++) {
                var key = context ? context[k] : k;
                if (iterator(obj[key], key, obj)) {
                    return true;
                }
            }
            return false;
        };
        /** @type {function (?, Object, (number|string), boolean): ?} */
        _.contains = _.includes = _.include = function (val, item, id, msg) {
            if (!isArray(val)) {
                val = _.values(val);
            }
            if ("number" != typeof id || msg) {
                /** @type {number} */
                id = 0;
            }
            return 0 <= _.indexOf(val, item, id);
        };
        /**
         * @param {Object} obj
         * @param {string} method
         * @return {?}
         */
        _.invoke = function (obj, method) {
            /** @type {Array.<?>} */
            var args = slice.call(arguments, 2);
            var isFunc = _.isFunction(method);
            return _.map(obj, function (value) {
                var wrapper = isFunc ? method : value[method];
                return null == wrapper ? wrapper : wrapper.apply(value, args);
            });
        };
        /**
         * @param {string} obj
         * @param {?} key
         * @return {?}
         */
        _.pluck = function (obj, key) {
            return _.map(obj, _.property(key));
        };
        /**
         * @param {Function} obj
         * @param {Object} val
         * @return {?}
         */
        _.where = function (obj, val) {
            return _.filter(obj, _.matcher(val));
        };
        /**
         * @param {string} expr
         * @param {string} item
         * @return {?}
         */
        _.findWhere = function (expr, item) {
            return _.find(expr, _.matcher(item));
        };
        /**
         * @param {?} obj
         * @param {number} iterator
         * @param {number} thisObj
         * @return {?}
         */
        _.max = function (obj, iterator, thisObj) {
            /** @type {number} */
            var result = -Infinity;
            /** @type {number} */
            var compare = -Infinity;
            var temp;
            if (null == iterator && null != obj) {
                obj = isArray(obj) ? obj : _.values(obj);
                /** @type {number} */
                var i = 0;
                var l = obj.length;
                for (; i < l; i++) {
                    thisObj = obj[i];
                    if (thisObj > result) {
                        /** @type {number} */
                        result = thisObj;
                    }
                }
            } else {
                iterator = makeIterator(iterator, thisObj);
                _.each(obj, function (value, index, arr) {
                    temp = iterator(value, index, arr);
                    if (temp > compare || -Infinity === temp && -Infinity === result) {
                        /** @type {number} */
                        result = value;
                        compare = temp;
                    }
                });
            }
            return result;
        };
        /**
         * @param {?} a
         * @param {(number|string)} callback
         * @param {number} thisObj
         * @return {?}
         */
        _.min = function (a, callback, thisObj) {
            /** @type {number} */
            var result = Infinity;
            /** @type {number} */
            var min = Infinity;
            var value;
            if (null == callback && null != a) {
                a = isArray(a) ? a : _.values(a);
                /** @type {number} */
                var i = 0;
                var aLength = a.length;
                for (; i < aLength; i++) {
                    thisObj = a[i];
                    if (thisObj < result) {
                        /** @type {number} */
                        result = thisObj;
                    }
                }
            } else {
                callback = makeIterator(callback, thisObj);
                _.each(a, function (dom, key, arg) {
                    value = callback(dom, key, arg);
                    if (value < min || Infinity === value && Infinity === result) {
                        /** @type {number} */
                        result = dom;
                        min = value;
                    }
                });
            }
            return result;
        };
        /**
         * @param {?} obj
         * @return {?}
         */
        _.shuffle = function (obj) {
            obj = isArray(obj) ? obj : _.values(obj);
            var length = obj.length;
            /** @type {Array} */
            var result = Array(length);
            /** @type {number} */
            var i = 0;
            var j;
            for (; i < length; i++) {
                j = _.random(0, i);
                if (j !== i) {
                    result[i] = result[j];
                }
                result[j] = obj[i];
            }
            return result;
        };
        /**
         * @param {?} obj
         * @param {number} n
         * @param {boolean} guard
         * @return {?}
         */
        _.sample = function (obj, n, guard) {
            return null == n || guard ? (isArray(obj) || (obj = _.values(obj)), obj[_.random(obj.length - 1)]) : _.shuffle(obj).slice(0, Math.max(0, n));
        };
        /**
         * @param {Object} obj
         * @param {Text} iterator
         * @param {?} thisObj
         * @return {?}
         */
        _.sortBy = function (obj, iterator, thisObj) {
            iterator = makeIterator(iterator, thisObj);
            return _.pluck(_.map(obj, function (value, index, i) {
                return {
                    value: value,
                    index: index,
                    criteria: iterator(value, index, i)
                };
            }).sort(function (left, right) {
                var a = left.criteria;
                var b = right.criteria;
                if (a !== b) {
                    if (a > b || void 0 === a) {
                        return 1;
                    }
                    if (a < b || void 0 === b) {
                        return -1;
                    }
                }
                return left.index - right.index;
            }), "value");
        };
        /**
         * @param {Function} behavior
         * @return {?}
         */
        var group = function (behavior) {
            return function (arg, callback, thisObj) {
                var result = {};
                callback = makeIterator(callback, thisObj);
                _.each(arg, function (key, value) {
                    value = callback(key, value, arg);
                    behavior(result, key, value);
                });
                return result;
            };
        };
        _.groupBy = group(function (result, value, key) {
            if (_.has(result, key)) {
                result[key].push(value);
            } else {
                /** @type {Array} */
                result[key] = [value];
            }
        });
        _.indexBy = group(function (qs, val, i) {
            qs[i] = val;
        });
        _.countBy = group(function (memo, dataAndEvents, key) {
            if (_.has(memo, key)) {
                memo[key]++;
            } else {
                /** @type {number} */
                memo[key] = 1;
            }
        });
        /**
         * @param {string} obj
         * @return {?}
         */
        _.toArray = function (obj) {
            return obj ? _.isArray(obj) ? slice.call(obj) : isArray(obj) ? _.map(obj, _.identity) : _.values(obj) : [];
        };
        /**
         * @param {string} obj
         * @return {?}
         */
        _.size = function (obj) {
            return null == obj ? 0 : isArray(obj) ? obj.length : _.keys(obj).length;
        };
        /**
         * @param {Function} which
         * @param {Text} iterator
         * @param {?} thisObj
         * @return {?}
         */
        _.partition = function (which, iterator, thisObj) {
            iterator = makeIterator(iterator, thisObj);
            /** @type {Array} */
            var trues = [];
            /** @type {Array} */
            var falses = [];
            _.each(which, function (value, index, list) {
                (iterator(value, index, list) ? trues : falses).push(value);
            });
            return [trues, falses];
        };
        /** @type {function (string, number, boolean): ?} */
        _.first = _.head = _.take = function (array, n, guard) {
            if (null != array) {
                return null == n || guard ? array[0] : _.initial(array, array.length - n);
            }
        };
        /**
         * @param {string} array
         * @param {number} t
         * @param {boolean} r
         * @return {?}
         */
        _.initial = function (array, t, r) {
            return slice.call(array, 0, Math.max(0, array.length - (null == t || r ? 1 : t)));
        };
        /**
         * @param {string} array
         * @param {number} n
         * @param {boolean} guard
         * @return {?}
         */
        _.last = function (array, n, guard) {
            if (null != array) {
                return null == n || guard ? array[array.length - 1] : _.rest(array, Math.max(0, array.length - n));
            }
        };
        /** @type {function (string, number, boolean): ?} */
        _.rest = _.tail = _.drop = function (array, t, r) {
            return slice.call(array, null == t || r ? 1 : t);
        };
        /**
         * @param {Function} array
         * @return {?}
         */
        _.compact = function (array) {
            return _.filter(array, _.identity);
        };
        /**
         * @param {Object} obj
         * @param {boolean} shallow
         * @param {boolean} recurring
         * @param {number} desiredNonCommentArgIndex
         * @return {?}
         */
        var flatten = function (obj, shallow, recurring, desiredNonCommentArgIndex) {
            /** @type {Array} */
            var result = [];
            /** @type {number} */
            var ri = 0;
            desiredNonCommentArgIndex = desiredNonCommentArgIndex || 0;
            var val = value(obj);
            for (; desiredNonCommentArgIndex < val; desiredNonCommentArgIndex++) {
                var iterable = obj[desiredNonCommentArgIndex];
                if (isArray(iterable) && (_.isArray(iterable) || _.isArguments(iterable))) {
                    if (!shallow) {
                        iterable = flatten(iterable, shallow, recurring);
                    }
                    /** @type {number} */
                    var i = 0;
                    var len = iterable.length;
                    result.length += len;
                    for (; i < len;) {
                        result[ri++] = iterable[i++];
                    }
                } else {
                    if (!recurring) {
                        result[ri++] = iterable;
                    }
                }
            }
            return result;
        };
        /**
         * @param {Object} array
         * @param {boolean} shallow
         * @return {?}
         */
        _.flatten = function (array, shallow) {
            return flatten(array, shallow, false);
        };
        /**
         * @param {?} array
         * @return {?}
         */
        _.without = function (array) {
            return _.difference(array, slice.call(arguments, 1));
        };
        /** @type {function (Array, string, string, Object): ?} */
        _.uniq = _.unique = function (array, isSorted, callback, arr) {
            if (!_.isBoolean(isSorted)) {
                /** @type {string} */
                arr = callback;
                /** @type {string} */
                callback = isSorted;
                /** @type {boolean} */
                isSorted = false;
            }
            if (null != callback) {
                callback = makeIterator(callback, arr);
            }
            /** @type {Array} */
            arr = [];
            /** @type {Array} */
            var current = [];
            /** @type {number} */
            var i = 0;
            var l = value(array);
            for (; i < l; i++) {
                var item = array[i];
                var key = callback ? callback(item, i, array) : item;
                if (isSorted) {
                    if (!(i && current === key)) {
                        arr.push(item);
                    }
                    current = key;
                } else {
                    if (callback) {
                        if (!_.contains(current, key)) {
                            current.push(key);
                            arr.push(item);
                        }
                    } else {
                        if (!_.contains(arr, item)) {
                            arr.push(item);
                        }
                    }
                }
            }
            return arr;
        };
        /**
         * @return {?}
         */
        _.union = function () {
            return _.uniq(flatten(arguments, true, true));
        };
        /**
         * @param {?} array
         * @return {?}
         */
        _.intersection = function (array) {
            /** @type {Array} */
            var result = [];
            /** @type {number} */
            var l = arguments.length;
            /** @type {number} */
            var index = 0;
            var sz = value(array);
            for (; index < sz; index++) {
                var item = array[index];
                if (!_.contains(result, item)) {
                    /** @type {number} */
                    var i = 1;
                    for (; i < l && _.contains(arguments[i], item); i++) {
                    }
                    if (i === l) {
                        result.push(item);
                    }
                }
            }
            return result;
        };
        /**
         * @param {?} array
         * @return {?}
         */
        _.difference = function (array) {
            var rest = flatten(arguments, true, true, 1);
            return _.filter(array, function (item) {
                return !_.contains(rest, item);
            });
        };
        /**
         * @return {?}
         */
        _.zip = function () {
            return _.unzip(arguments);
        };
        /**
         * @param {Function} obj
         * @return {?}
         */
        _.unzip = function (obj) {
            var indents = obj && _.max(obj, value).length || 0;
            /** @type {Array} */
            var result = Array(indents);
            /** @type {number} */
            var key = 0;
            for (; key < indents; key++) {
                result[key] = _.pluck(obj, key);
            }
            return result;
        };
        /**
         * @param {Array} o
         * @param {Array} map
         * @return {?}
         */
        _.object = function (o, map) {
            var result = {};
            /** @type {number} */
            var k = 0;
            var val = value(o);
            for (; k < val; k++) {
                if (map) {
                    result[o[k]] = map[k];
                } else {
                    result[o[k][0]] = o[k][1];
                }
            }
            return result;
        };
        _.findIndex = range(1);
        _.findLastIndex = range(-1);
        /**
         * @param {Array} obj
         * @param {Text} basis
         * @param {Text} callback
         * @param {number} low
         * @return {?}
         */
        _.sortedIndex = function (obj, basis, callback, low) {
            callback = makeIterator(callback, low, 1);
            basis = callback(basis);
            /** @type {number} */
            low = 0;
            var high = value(obj);
            for (; low < high;) {
                /** @type {number} */
                var mid = Math.floor((low + high) / 2);
                if (callback(obj[mid]) < basis) {
                    /** @type {number} */
                    low = mid + 1;
                } else {
                    /** @type {number} */
                    high = mid;
                }
            }
            return low;
        };
        _.indexOf = init(1, _.findIndex, _.sortedIndex);
        _.lastIndexOf = init(-1, _.findLastIndex);
        /**
         * @param {number} start
         * @param {number} end
         * @param {number} step
         * @return {?}
         */
        _.range = function (start, end, step) {
            if (null == end) {
                end = start || 0;
                /** @type {number} */
                start = 0;
            }
            step = step || 1;
            /** @type {number} */
            end = Math.max(Math.ceil((end - start) / step), 0);
            /** @type {Array} */
            var result = Array(end);
            /** @type {number} */
            var i = 0;
            for (; i < end; i++, start += step) {
                /** @type {number} */
                result[i] = start;
            }
            return result;
        };
        /**
         * @param {Function} method
         * @param {Function} object
         * @param {Function} obj
         * @param {Function} dataAndEvents
         * @param {Array} e
         * @return {?}
         */
        var fire = function (method, object, obj, dataAndEvents, e) {
            if (!(dataAndEvents instanceof object)) {
                return method.apply(obj, e);
            }
            object = mixin(method.prototype);
            method = method.apply(object, e);
            return _.isObject(method) ? method : object;
        };
        /**
         * @param {string} event
         * @param {Function=} owner
         * @return {function (...[?]): ?}
         */
        _.bind = function (event, owner) {
            if (nativeBind && event.bind === nativeBind) {
                return nativeBind.apply(event, slice.call(arguments, 1));
            }
            if (!_.isFunction(event)) {
                throw new TypeError("Bind must be called on a function");
            }
            /** @type {Array.<?>} */
            var args = slice.call(arguments, 2);
            /**
             * @return {?}
             */
            var e = function () {
                return fire(event, e, owner, this, args.concat(slice.call(arguments)));
            };
            return e;
        };
        /**
         * @param {Function} args
         * @return {?}
         */
        _.partial = function (args) {
            /** @type {Array.<?>} */
            var resolveValues = slice.call(arguments, 1);
            /**
             * @return {?}
             */
            var e = function () {
                /** @type {number} */
                var x = 0;
                /** @type {number} */
                var length = resolveValues.length;
                /** @type {Array} */
                var result = Array(length);
                /** @type {number} */
                var i = 0;
                for (; i < length; i++) {
                    result[i] = resolveValues[i] === _ ? arguments[x++] : resolveValues[i];
                }
                for (; x < arguments.length;) {
                    result.push(arguments[x++]);
                }
                return fire(args, e, this, this, result);
            };
            return e;
        };
        /**
         * @param {Function} dest
         * @return {?}
         */
        _.bindAll = function (dest) {
            var i;
            /** @type {number} */
            var argLength = arguments.length;
            if (1 >= argLength) {
                throw Error("bindAll must be passed function names");
            }
            /** @type {number} */
            i = 1;
            for (; i < argLength; i++) {
                var f = arguments[i];
                dest[f] = _.bind(dest[f], dest);
            }
            return dest;
        };
        /**
         * @param {Function} matcherFunction
         * @param {Function} func
         * @return {?}
         */
        _.memoize = function (matcherFunction, func) {
            /**
             * @param {Function} structure
             * @return {?}
             */
            var memoized = function (structure) {
                var cache = memoized.cache;
                /** @type {string} */
                var key = "" + (func ? func.apply(this, arguments) : structure);
                if (!_.has(cache, key)) {
                    cache[key] = matcherFunction.apply(this, arguments);
                }
                return cache[key];
            };
            memoized.cache = {};
            return memoized;
        };
        /**
         * @param {Function} func
         * @param {number} wait
         * @return {?}
         */
        _.delay = function (func, wait) {
            /** @type {Array.<?>} */
            var args = slice.call(arguments, 2);
            return setTimeout(function () {
                return func.apply(null, args);
            }, wait);
        };
        _.defer = _.partial(_.delay, _, 1);
        /**
         * @param {Function} func
         * @param {number} wait
         * @param {Object} options
         * @return {?}
         */
        _.throttle = function (func, wait, options) {
            var context;
            var args;
            var result;
            /** @type {null} */
            var timeout = null;
            /** @type {number} */
            var previous = 0;
            if (!options) {
                options = {};
            }
            /**
             * @return {undefined}
             */
            var later = function () {
                /** @type {number} */
                previous = false === options.leading ? 0 : _.now();
                /** @type {null} */
                timeout = null;
                result = func.apply(context, args);
                if (!timeout) {
                    /** @type {null} */
                    context = args = null;
                }
            };
            return function () {
                /** @type {number} */
                var now = _.now();
                if (!previous) {
                    if (!(false !== options.leading)) {
                        /** @type {number} */
                        previous = now;
                    }
                }
                /** @type {number} */
                var remaining = wait - (now - previous);
                context = this;
                /** @type {Arguments} */
                args = arguments;
                if (0 >= remaining || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        /** @type {null} */
                        timeout = null;
                    }
                    /** @type {number} */
                    previous = now;
                    result = func.apply(context, args);
                    if (!timeout) {
                        /** @type {null} */
                        context = args = null;
                    }
                } else {
                    if (!timeout) {
                        if (!(false === options.trailing)) {
                            /** @type {number} */
                            timeout = setTimeout(later, remaining);
                        }
                    }
                }
                return result;
            };
        };
        /**
         * @param {Function} func
         * @param {number} wait
         * @param {boolean} immediate
         * @return {?}
         */
        _.debounce = function (func, wait, immediate) {
            var timeout;
            var args;
            var context;
            var step;
            var result;
            /**
             * @return {undefined}
             */
            var delayed = function () {
                /** @type {number} */
                var last = _.now() - step;
                if (last < wait && 0 <= last) {
                    /** @type {number} */
                    timeout = setTimeout(delayed, wait - last);
                } else {
                    /** @type {null} */
                    timeout = null;
                    if (!immediate) {
                        result = func.apply(context, args);
                        if (!timeout) {
                            /** @type {null} */
                            context = args = null;
                        }
                    }
                }
            };
            return function () {
                context = this;
                /** @type {Arguments} */
                args = arguments;
                /** @type {number} */
                step = _.now();
                var callNow = immediate && !timeout;
                if (!timeout) {
                    /** @type {number} */
                    timeout = setTimeout(delayed, wait);
                }
                if (callNow) {
                    result = func.apply(context, args);
                    /** @type {null} */
                    context = args = null;
                }
                return result;
            };
        };
        /**
         * @param {?} func
         * @param {Function} wrapper
         * @return {?}
         */
        _.wrap = function (func, wrapper) {
            return _.partial(wrapper, func);
        };
        /**
         * @param {Function} matcherFunction
         * @return {?}
         */
        _.negate = function (matcherFunction) {
            return function () {
                return !matcherFunction.apply(this, arguments);
            };
        };
        /**
         * @return {?}
         */
        _.compose = function () {
            /** @type {Arguments} */
            var functions = arguments;
            /** @type {number} */
            var i = functions.length - 1;
            return function () {
                /** @type {number} */
                var k = i;
                var result = functions[i].apply(this, arguments);
                for (; k--;) {
                    result = functions[k].call(this, result);
                }
                return result;
            };
        };
        /**
         * @param {?} times
         * @param {Function} matcherFunction
         * @return {?}
         */
        _.after = function (times, matcherFunction) {
            return function () {
                if (1 > --times) {
                    return matcherFunction.apply(this, arguments);
                }
            };
        };
        /**
         * @param {?} object
         * @param {(Function|number)} matcherFunction
         * @return {?}
         */
        _.before = function (object, matcherFunction) {
            var returnValue;
            return function () {
                if (0 < --object) {
                    returnValue = matcherFunction.apply(this, arguments);
                }
                if (1 >= object) {
                    /** @type {null} */
                    matcherFunction = null;
                }
                return returnValue;
            };
        };
        _.once = _.partial(_.before, 2);
        /** @type {boolean} */
        var U = !{
            toString: null
        }.propertyIsEnumerable("toString");
        /** @type {Array.<string>} */
        var tokenized = "valueOf isPrototypeOf toString propertyIsEnumerable hasOwnProperty toLocaleString".split(" ");
        /**
         * @param {Object} obj
         * @return {?}
         */
        _.keys = function (obj) {
            if (!_.isObject(obj)) {
                return [];
            }
            if (nativeKeys) {
                return nativeKeys(obj);
            }
            /** @type {Array} */
            var ret = [];
            var key;
            for (key in obj) {
                if (_.has(obj, key)) {
                    ret.push(key);
                }
            }
            if (U) {
                has(obj, ret);
            }
            return ret;
        };
        /**
         * @param {Object} obj
         * @return {?}
         */
        _.allKeys = function (obj) {
            if (!_.isObject(obj)) {
                return [];
            }
            /** @type {Array} */
            var ret = [];
            var prop;
            for (prop in obj) {
                ret.push(prop);
            }
            if (U) {
                has(obj, ret);
            }
            return ret;
        };
        /**
         * @param {?} obj
         * @return {?}
         */
        _.values = function (obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            /** @type {Array} */
            var result = Array(length);
            /** @type {number} */
            var i = 0;
            for (; i < length; i++) {
                result[i] = obj[keys[i]];
            }
            return result;
        };
        /**
         * @param {Object} obj
         * @param {Text} callback
         * @param {?} thisObj
         * @return {?}
         */
        _.mapObject = function (obj, callback, thisObj) {
            callback = makeIterator(callback, thisObj);
            thisObj = _.keys(obj);
            var valuesLen = thisObj.length;
            var result = {};
            var key;
            /** @type {number} */
            var i = 0;
            for (; i < valuesLen; i++) {
                key = thisObj[i];
                result[key] = callback(obj[key], key, obj);
            }
            return result;
        };
        /**
         * @param {Object} obj
         * @return {?}
         */
        _.pairs = function (obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            /** @type {Array} */
            var result = Array(length);
            /** @type {number} */
            var i = 0;
            for (; i < length; i++) {
                /** @type {Array} */
                result[i] = [keys[i], obj[keys[i]]];
            }
            return result;
        };
        /**
         * @param {Function} obj
         * @return {?}
         */
        _.invert = function (obj) {
            var result = {};
            var values = _.keys(obj);
            /** @type {number} */
            var i = 0;
            var valuesLen = values.length;
            for (; i < valuesLen; i++) {
                result[obj[values[i]]] = values[i];
            }
            return result;
        };
        /** @type {function (Object): ?} */
        _.functions = _.methods = function (obj) {
            /** @type {Array} */
            var keys = [];
            var key;
            for (key in obj) {
                if (_.isFunction(obj[key])) {
                    keys.push(key);
                }
            }
            return keys.sort();
        };
        _.extend = filter(_.allKeys);
        _.extendOwn = _.assign = filter(_.keys);
        /**
         * @param {Object} obj
         * @param {(number|string)} callback
         * @param {?} thisObj
         * @return {?}
         */
        _.findKey = function (obj, callback, thisObj) {
            callback = makeIterator(callback, thisObj);
            thisObj = _.keys(obj);
            var key;
            /** @type {number} */
            var i = 0;
            var valuesLen = thisObj.length;
            for (; i < valuesLen; i++) {
                if (key = thisObj[i], callback(obj[key], key, obj)) {
                    return key;
                }
            }
        };
        /**
         * @param {Function} obj
         * @param {Function} object
         * @param {number} data
         * @return {?}
         */
        _.pick = function (obj, object, data) {
            var result = {};
            /** @type {Function} */
            var o = obj;
            if (null == o) {
                return result;
            }
            if (_.isFunction(object)) {
                var keys = _.allKeys(o);
                var d = call(object, data);
            } else {
                keys = flatten(arguments, false, false, 1);
                /**
                 * @param {?} opts
                 * @param {?} s
                 * @param {Object} value
                 * @return {?}
                 */
                d = function (opts, s, value) {
                    return s in value;
                };
                o = Object(o);
            }
            /** @type {number} */
            var i = 0;
            var il = keys.length;
            for (; i < il; i++) {
                var key = keys[i];
                var value = o[key];
                if (d(value, key, o)) {
                    result[key] = value;
                }
            }
            return result;
        };
        /**
         * @param {Function} isSorted
         * @param {Function} keys
         * @param {number} obj
         * @return {?}
         */
        _.omit = function (isSorted, keys, obj) {
            if (_.isFunction(keys)) {
                keys = _.negate(keys);
            } else {
                var rest = _.map(flatten(arguments, false, false, 1), String);
                /**
                 * @param {?} object
                 * @param {Object} obj
                 * @return {?}
                 */
                keys = function (object, obj) {
                    return !_.contains(rest, obj);
                };
            }
            return _.pick(isSorted, keys, obj);
        };
        _.defaults = filter(_.allKeys, true);
        /**
         * @param {Function} obj
         * @param {?} attributes
         * @return {?}
         */
        _.create = function (obj, attributes) {
            obj = mixin(obj);
            if (attributes) {
                _.extendOwn(obj, attributes);
            }
            return obj;
        };
        /**
         * @param {Object} obj
         * @return {?}
         */
        _.clone = function (obj) {
            return _.isObject(obj) ? _.isArray(obj) ? obj.slice() : _.extend({}, obj) : obj;
        };
        /**
         * @param {?} obj
         * @param {?} interceptor
         * @return {?}
         */
        _.tap = function (obj, interceptor) {
            interceptor(obj);
            return obj;
        };
        /**
         * @param {?} object
         * @param {string} obj
         * @return {?}
         */
        _.isMatch = function (object, obj) {
            var keys = _.keys(obj);
            var il = keys.length;
            if (null == object) {
                return !il;
            }
            object = Object(object);
            /** @type {number} */
            var i = 0;
            for (; i < il; i++) {
                var key = keys[i];
                if (obj[key] !== object[key] || !(key in object)) {
                    return false;
                }
            }
            return true;
        };
        /**
         * @param {?} a
         * @param {?} b
         * @param {Array} stack
         * @param {Array} bStack
         * @return {?}
         */
        var eq = function (a, b, stack, bStack) {
            if (a === b) {
                return 0 !== a || 1 / a === 1 / b;
            }
            if (null == a || null == b) {
                return a === b;
            }
            if (a instanceof _) {
                a = a._wrapped;
            }
            if (b instanceof _) {
                b = b._wrapped;
            }
            /** @type {string} */
            var ka = toString.call(a);
            if (ka !== toString.call(b)) {
                return false;
            }
            switch (ka) {
                case "[object RegExp]":
                    ;
                case "[object String]":
                    return "" + a === "" + b;
                case "[object Number]":
                    return +a !== +a ? +b !== +b : 0 === +a ? 1 / +a === 1 / b : +a === +b;
                case "[object Date]":
                    ;
                case "[object Boolean]":
                    return +a === +b;
            }
            /** @type {boolean} */
            ka = "[object Array]" === ka;
            if (!ka) {
                if ("object" != typeof a || "object" != typeof b) {
                    return false;
                }
                var i = a.constructor;
                var key = b.constructor;
                if (i !== key && (!(_.isFunction(i) && (i instanceof i && (_.isFunction(key) && key instanceof key))) && ("constructor" in a && "constructor" in b))) {
                    return false;
                }
            }
            stack = stack || [];
            bStack = bStack || [];
            i = stack.length;
            for (; i--;) {
                if (stack[i] === a) {
                    return bStack[i] === b;
                }
            }
            stack.push(a);
            bStack.push(b);
            if (ka) {
                i = a.length;
                if (i !== b.length) {
                    return false;
                }
                for (; i--;) {
                    if (!eq(a[i], b[i], stack, bStack)) {
                        return false;
                    }
                }
            } else {
                ka = _.keys(a);
                i = ka.length;
                if (_.keys(b).length !== i) {
                    return false;
                }
                for (; i--;) {
                    if (key = ka[i], !_.has(b, key) || !eq(a[key], b[key], stack, bStack)) {
                        return false;
                    }
                }
            }
            stack.pop();
            bStack.pop();
            return true;
        };
        /**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        _.isEqual = function (a, b) {
            return eq(a, b);
        };
        /**
         * @param {?} obj
         * @return {?}
         */
        _.isEmpty = function (obj) {
            return null == obj ? true : isArray(obj) && (_.isArray(obj) || (_.isString(obj) || _.isArguments(obj))) ? 0 === obj.length : 0 === _.keys(obj).length;
        };
        /**
         * @param {Object} obj
         * @return {?}
         */
        _.isElement = function (obj) {
            return !(!obj || 1 !== obj.nodeType);
        };
        /** @type {function (*): boolean} */
        _.isArray = x || function (obj) {
            return "[object Array]" === toString.call(obj);
        };
        /**
         * @param {Function} obj
         * @return {?}
         */
        _.isObject = function (obj) {
            /** @type {string} */
            var type = typeof obj;
            return "function" === type || "object" === type && !!obj;
        };
        _.each("Arguments Function String Number Date RegExp Error".split(" "), function (name) {
            /**
             * @param {?} checkSet
             * @return {?}
             */
            _["is" + name] = function (checkSet) {
                return toString.call(checkSet) === "[object " + name + "]";
            };
        });
        if (!_.isArguments(arguments)) {
            /**
             * @param {Object} obj
             * @return {?}
             */
            _.isArguments = function (obj) {
                return _.has(obj, "callee");
            };
        }
        if ("function" != typeof /./) {
            if ("object" != typeof Int8Array) {
                /**
                 * @param {Function} value
                 * @return {?}
                 */
                _.isFunction = function (value) {
                    return "function" == typeof value || false;
                };
            }
        }
        /**
         * @param {?} obj
         * @return {?}
         */
        _.isFinite = function (obj) {
            return isFinite(obj) && !isNaN(parseFloat(obj));
        };
        /**
         * @param {number} i
         * @return {?}
         */
        _.isNaN = function (i) {
            return _.isNumber(i) && i !== +i;
        };
        /**
         * @param {boolean} obj
         * @return {?}
         */
        _.isBoolean = function (obj) {
            return true === obj || (false === obj || "[object Boolean]" === toString.call(obj));
        };
        /**
         * @param {string} value
         * @return {?}
         */
        _.isNull = function (value) {
            return null === value;
        };
        /**
         * @param {?} val
         * @return {?}
         */
        _.isUndefined = function (val) {
            return void 0 === val;
        };
        /**
         * @param {Object} obj
         * @param {string} key
         * @return {?}
         */
        _.has = function (obj, key) {
            return null != obj && hasOwnProperty.call(obj, key);
        };
        /**
         * @return {?}
         */
        _.noConflict = function () {
            root._ = previousUnderscore;
            return this;
        };
        /**
         * @param {?} value
         * @return {?}
         */
        _.identity = function (value) {
            return value;
        };
        /**
         * @param {?} value
         * @return {?}
         */
        _.constant = function (value) {
            return function () {
                return value;
            };
        };
        /**
         * @return {undefined}
         */
        _.noop = function () {
        };
        /** @type {function (Function): ?} */
        _.property = parse;
        /**
         * @param {Object} buf
         * @return {?}
         */
        _.propertyOf = function (buf) {
            return null == buf ? function () {
            } : function (off) {
                return buf[off];
            };
        };
        /** @type {function (string): ?} */
        _.matcher = _.matches = function (xs) {
            xs = _.extendOwn({}, xs);
            return function (child) {
                return _.isMatch(child, xs);
            };
        };
        /**
         * @param {number} n
         * @param {?} callback
         * @param {number} i
         * @return {?}
         */
        _.times = function (n, callback, i) {
            /** @type {Array} */
            var result = Array(Math.max(0, n));
            callback = call(callback, i, 1);
            /** @type {number} */
            i = 0;
            for (; i < n; i++) {
                result[i] = callback(i);
            }
            return result;
        };
        /**
         * @param {number} min
         * @param {number} max
         * @return {?}
         */
        _.random = function (min, max) {
            if (null == max) {
                /** @type {number} */
                max = min;
                /** @type {number} */
                min = 0;
            }
            return min + Math.floor(Math.random() * (max - min + 1));
        };
        /** @type {function (): number} */
        _.now = Date.now || function () {
            return (new Date).getTime();
        };
        x = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
        };
        filter = _.invert(x);
        /**
         * @param {Object} str
         * @return {?}
         */
        parse = function (str) {
            /**
             * @param {string} key
             * @return {?}
             */
            var replace = function (key) {
                return str[key];
            };
            /** @type {string} */
            var keyword1 = "(?:" + _.keys(str).join("|") + ")";
            /** @type {RegExp} */
            var hChars = RegExp(keyword1);
            /** @type {RegExp} */
            var r20 = RegExp(keyword1, "g");
            return function (s) {
                /** @type {string} */
                s = null == s ? "" : "" + s;
                return hChars.test(s) ? s.replace(r20, replace) : s;
            };
        };
        _.escape = parse(x);
        _.unescape = parse(filter);
        /**
         * @param {Object} object
         * @param {?} property
         * @param {?} j
         * @return {?}
         */
        _.result = function (object, property, j) {
            property = null == object ? void 0 : object[property];
            if (void 0 === property) {
                property = j;
            }
            return _.isFunction(property) ? property.call(object) : property;
        };
        /** @type {number} */
        var idCounter = 0;
        /**
         * @param {?} prefix
         * @return {?}
         */
        _.uniqueId = function (prefix) {
            /** @type {string} */
            var id = ++idCounter + "";
            return prefix ? prefix + id : id;
        };
        _.templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g
        };
        /** @type {RegExp} */
        var noMatch = /(.)^/;
        var escapes = {
            "'": "'",
            "\\": "\\",
            "\r": "r",
            "\n": "n",
            "\u2028": "u2028",
            "\u2029": "u2029"
        };
        /** @type {RegExp} */
        var r20 = /\\|'|\r|\n|\u2028|\u2029/g;
        /**
         * @param {?} match
         * @return {?}
         */
        var escapeStringChar = function (match) {
            return "\\" + escapes[match];
        };
        /**
         * @param {string} text
         * @param {Object} settings
         * @param {Object} template
         * @return {?}
         */
        _.template = function (text, settings, template) {
            if (!settings) {
                if (template) {
                    /** @type {Object} */
                    settings = template;
                }
            }
            settings = _.defaults({}, settings, _.templateSettings);
            /** @type {RegExp} */
            template = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join("|") + "|$", "g");
            /** @type {number} */
            var index = 0;
            /** @type {string} */
            var source = "__p+='";
            text.replace(template, function (match, dataAndEvents, deepDataAndEvents, ignoreMethodDoesntExist, offset) {
                source += text.slice(index, offset).replace(r20, escapeStringChar);
                index = offset + match.length;
                if (dataAndEvents) {
                    source += "'+\n((__t=(" + dataAndEvents + "))==null?'':_.escape(__t))+\n'";
                } else {
                    if (deepDataAndEvents) {
                        source += "'+\n((__t=(" + deepDataAndEvents + "))==null?'':__t)+\n'";
                    } else {
                        if (ignoreMethodDoesntExist) {
                            source += "';\n" + ignoreMethodDoesntExist + "\n__p+='";
                        }
                    }
                }
                return match;
            });
            source += "';\n";
            if (!settings.variable) {
                /** @type {string} */
                source = "with(obj||{}){\n" + source + "}\n";
            }
            /** @type {string} */
            source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";
            try {
                /** @type {Function} */
                var render = new Function(settings.variable || "obj", "_", source);
            } catch (details) {
                throw details.source = source, details;
            }
            /**
             * @param {?} data
             * @return {?}
             */
            template = function (data) {
                return render.call(this, data, _);
            };
            /** @type {string} */
            template.source = "function(" + (settings.variable || "obj") + "){\n" + source + "}";
            return template;
        };
        /**
         * @param {?} value
         * @return {?}
         */
        _.chain = function (value) {
            value = _(value);
            /** @type {boolean} */
            value._chain = true;
            return value;
        };
        /**
         * @param {?} dataAndEvents
         * @param {?} obj
         * @return {?}
         */
        var result = function (dataAndEvents, obj) {
            return dataAndEvents._chain ? _(obj).chain() : obj;
        };
        /**
         * @param {Object} obj
         * @return {undefined}
         */
        _.mixin = function (obj) {
            _.each(_.functions(obj), function (name) {
                var wrapper = _[name] = obj[name];
                /**
                 * @return {?}
                 */
                _.prototype[name] = function () {
                    /** @type {Array} */
                    var args = [this._wrapped];
                    push.apply(args, arguments);
                    return result(this, wrapper.apply(_, args));
                };
            });
        };
        _.mixin(_);
        _.each("pop push reverse shift sort splice unshift".split(" "), function (name) {
            var method = ArrayProto[name];
            /**
             * @return {?}
             */
            _.prototype[name] = function () {
                var wrapped = this._wrapped;
                method.apply(wrapped, arguments);
                if (!("shift" !== name && "splice" !== name)) {
                    if (!(0 !== wrapped.length)) {
                        delete wrapped[0];
                    }
                }
                return result(this, wrapped);
            };
        });
        _.each(["concat", "join", "slice"], function (name) {
            var method = ArrayProto[name];
            /**
             * @return {?}
             */
            _.prototype[name] = function () {
                return result(this, method.apply(this._wrapped, arguments));
            };
        });
        /**
         * @return {?}
         */
        _.prototype.value = function () {
            return this._wrapped;
        };
        /** @type {function (): ?} */
        _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
        /**
         * @return {?}
         */
        _.prototype.toString = function () {
            return "" + this._wrapped;
        };
        if ("function" === typeof define) {
            if (define.amd) {
                define("underscore", [], function () {
                    return _;
                });
            }
        }
    }).call(this);
    (function (factory) {
        var root = "object" == typeof self && (self.self === self && self) || "object" == typeof global && (global.global === global && global);
        if ("function" === typeof define && define.amd) {
            options.define(["underscore", "jquery", "exports"], function (_, $, Backbone) {
                root.Backbone = factory(root, Backbone, _, $);
            });
        } else {
            if ("undefined" !== typeof exports) {
                var _ = require("underscore");
                try {
                    var Events = require("jquery");
                } catch (M) {
                }
                factory(root, exports, _, Events);
            } else {
                root.Backbone = factory(root, {}, root._, jQuery);
            }
        }
    })(function (root, Backbone, _, Events) {
        var previousBackbone = root.Backbone;
        /** @type {function (this:(Array.<T>|string|{length: number}), *=, *=): Array.<T>} */
        var func = Array.prototype.slice;
        /** @type {string} */
        Backbone.VERSION = "1.3.3";
        /** @type {Object} */
        Backbone.$ = Events;
        /**
         * @return {?}
         */
        Backbone.noConflict = function () {
            root.Backbone = previousBackbone;
            return this;
        };
        /** @type {boolean} */
        Backbone.emulateHTTP = false;
        /** @type {boolean} */
        Backbone.emulateJSON = false;
        /**
         * @param {?} keepData
         * @param {string} method
         * @param {string} key
         * @return {?}
         */
        var wrap = function (keepData, method, key) {
            switch (keepData) {
                case 1:
                    return function () {
                        return _[method](this[key]);
                    };
                case 2:
                    return function (iterator) {
                        return _[method](this[key], iterator);
                    };
                case 3:
                    return function (doc, context) {
                        return _[method](this[key], check(doc, this), context);
                    };
                case 4:
                    return function (doc, context, d) {
                        return _[method](this[key], check(doc, this), context, d);
                    };
                default:
                    return function () {
                        /** @type {Array.<?>} */
                        var args = func.call(arguments);
                        args.unshift(this[key]);
                        return _[method].apply(_, args);
                    };
            }
        };
        /**
         * @param {Function} child
         * @param {Function} which
         * @param {string} models
         * @return {undefined}
         */
        var Collection = function (child, which, models) {
            _.each(which, function (key, method) {
                if (_[method]) {
                    child.prototype[method] = wrap(key, method, models);
                }
            });
        };
        /**
         * @param {string} from
         * @param {?} socket
         * @return {?}
         */
        var check = function (from, socket) {
            return _.isFunction(from) ? from : _.isObject(from) && !socket._isModel(from) ? contains(from) : _.isString(from) ? function (cl) {
                return cl.get(from);
            } : from;
        };
        /**
         * @param {string} value
         * @return {?}
         */
        var contains = function (value) {
            var iterator = _.matches(value);
            return function (x) {
                return iterator(x.attributes);
            };
        };
        Events = Backbone.Events = {};
        /** @type {RegExp} */
        var eventSplitter = /\s+/;
        /**
         * @param {Function} callback
         * @param {?} obj
         * @param {string} key
         * @param {Object} value
         * @param {Object} args
         * @return {?}
         */
        var parse = function (callback, obj, key, value, args) {
            /** @type {number} */
            var i = 0;
            var codeSegments;
            if (key && "object" === typeof key) {
                if (void 0 !== value) {
                    if ("context" in args) {
                        if (void 0 === args.context) {
                            /** @type {Object} */
                            args.context = value;
                        }
                    }
                }
                codeSegments = _.keys(key);
                for (; i < codeSegments.length; i++) {
                    obj = parse(callback, obj, codeSegments[i], key[codeSegments[i]], args);
                }
            } else {
                if (key && eventSplitter.test(key)) {
                    codeSegments = key.split(eventSplitter);
                    for (; i < codeSegments.length; i++) {
                        obj = callback(obj, codeSegments[i], value, args);
                    }
                } else {
                    obj = callback(obj, key, value, args);
                }
            }
            return obj;
        };
        /**
         * @param {string} event
         * @param {Function} selector
         * @param {Function} head
         * @return {?}
         */
        Events.on = function (event, selector, head) {
            return on(this, event, selector, head);
        };
        /**
         * @param {Object} self
         * @param {string} node
         * @param {Function} types
         * @param {Object} context
         * @param {Object} one
         * @return {?}
         */
        var on = function (self, node, types, context, one) {
            self._events = parse(next, self._events || {}, node, types, {
                context: context,
                ctx: self,
                listening: one
            });
            if (one) {
                /** @type {Object} */
                (self._listeners || (self._listeners = {}))[one.id] = one;
            }
            return self;
        };
        /**
         * @param {Object} obj
         * @param {string} name
         * @param {Function} handler
         * @return {?}
         */
        Events.listenTo = function (obj, name, handler) {
            if (!obj) {
                return this;
            }
            var id = obj._listenId || (obj._listenId = _.uniqueId("l"));
            var objects = this._listeningTo || (this._listeningTo = {});
            var s = objects[id];
            if (!s) {
                s = this._listenId || (this._listenId = _.uniqueId("l"));
                s = objects[id] = {
                    obj: obj,
                    objId: id,
                    id: s,
                    listeningTo: objects,
                    count: 0
                };
            }
            on(obj, name, handler, this, s);
            return this;
        };
        /**
         * @param {undefined} current
         * @param {Array} event
         * @param {Function} callback
         * @param {Object} result
         * @return {?}
         */
        var next = function (current, event, callback, result) {
            if (callback) {
                event = current[event] || (current[event] = []);
                var ctx = result.context;
                var doc = result.ctx;
                if (result = result.listening) {
                    result.count++;
                }
                event.push({
                    /** @type {Function} */
                    callback: callback,
                    context: ctx,
                    ctx: ctx || doc,
                    listening: result
                });
            }
            return current;
        };
        /**
         * @param {string} types
         * @param {Function} selector
         * @param {Object} fn
         * @return {?}
         */
        Events.off = function (types, selector, fn) {
            if (!this._events) {
                return this;
            }
            this._events = parse(run, this._events, types, selector, {
                context: fn,
                listeners: this._listeners
            });
            return this;
        };
        /**
         * @param {Array} events
         * @param {string} event
         * @param {Function} until
         * @return {?}
         */
        Events.stopListening = function (events, event, until) {
            var hash = this._listeningTo;
            if (!hash) {
                return this;
            }
            events = events ? [events._listenId] : _.keys(hash);
            /** @type {number} */
            var i = 0;
            for (; i < events.length; i++) {
                var scope = hash[events[i]];
                if (!scope) {
                    break;
                }
                scope.obj.off(event, until, this);
            }
            return this;
        };
        /**
         * @param {Object} result
         * @param {Object} type
         * @param {Object} callback
         * @param {Object} config
         * @return {?}
         */
        var run = function (result, type, callback, config) {
            if (result) {
                /** @type {number} */
                var i = 0;
                var context = config.context;
                config = config.listeners;
                if (type || (callback || context)) {
                    var codeSegments = type ? [type] : _.keys(result);
                    for (; i < codeSegments.length; i++) {
                        type = codeSegments[i];
                        var handlers = result[type];
                        if (!handlers) {
                            break;
                        }
                        /** @type {Array} */
                        var items = [];
                        /** @type {number} */
                        var h = 0;
                        for (; h < handlers.length; h++) {
                            var handler = handlers[h];
                            if (callback && (callback !== handler.callback && callback !== handler.callback._callback) || context && context !== handler.context) {
                                items.push(handler);
                            } else {
                                if (handler = handler.listening) {
                                    if (0 === --handler.count) {
                                        delete config[handler.id];
                                        delete handler.listeningTo[handler.objId];
                                    }
                                }
                            }
                        }
                        if (items.length) {
                            /** @type {Array} */
                            result[type] = items;
                        } else {
                            delete result[type];
                        }
                    }
                    return result;
                }
                result = _.keys(config);
                for (; i < result.length; i++) {
                    handler = config[result[i]];
                    delete config[handler.id];
                    delete handler.listeningTo[handler.objId];
                }
            }
        };
        /**
         * @param {Function} type
         * @param {Object} selector
         * @param {?} data
         * @return {?}
         */
        Events.once = function (type, selector, data) {
            var qualifier = parse(once, {}, type, selector, _.bind(this.off, this));
            if ("string" === typeof type) {
                if (null == data) {
                    selector = void 0;
                }
            }
            return this.on(qualifier, selector, data);
        };
        /**
         * @param {Function} res
         * @param {Text} obj
         * @param {Object} val
         * @return {?}
         */
        Events.listenToOnce = function (res, obj, val) {
            obj = parse(once, {}, obj, val, _.bind(this.stopListening, this, res));
            return this.listenTo(res, obj);
        };
        /**
         * @param {Array} fn
         * @param {number} type
         * @param {Function} func
         * @param {?} callback
         * @return {?}
         */
        var once = function (fn, type, func, callback) {
            if (func) {
                var self = fn[type] = _.once(function () {
                    callback(type, self);
                    func.apply(this, arguments);
                });
                /** @type {Function} */
                self._callback = func;
            }
            return fn;
        };
        /**
         * @param {string} name
         * @return {?}
         */
        Events.trigger = function (name) {
            if (!this._events) {
                return this;
            }
            /** @type {number} */
            var l = Math.max(0, arguments.length - 1);
            /** @type {Array} */
            var args = Array(l);
            /** @type {number} */
            var i = 0;
            for (; i < l; i++) {
                args[i] = arguments[i + 1];
            }
            parse(select, this._events, name, void 0, args);
            return this;
        };
        /**
         * @param {Object} results
         * @param {string} index
         * @param {(Array|string)} result
         * @param {Array} params
         * @return {?}
         */
        var select = function (results, index, result, params) {
            if (results) {
                result = results[index];
                var files = results.all;
                if (result) {
                    if (files) {
                        files = files.slice();
                    }
                }
                if (result) {
                    callback(result, params);
                }
                if (files) {
                    callback(files, [index].concat(params));
                }
            }
            return results;
        };
        /**
         * @param {Array} list
         * @param {Array} args
         * @return {undefined}
         */
        var callback = function (list, args) {
            var ev;
            /** @type {number} */
            var j = -1;
            var length = list.length;
            var a1 = args[0];
            var pageX = args[1];
            var next = args[2];
            switch (args.length) {
                case 0:
                    for (; ++j < length;) {
                        (ev = list[j]).callback.call(ev.ctx);
                    }
                    break;
                case 1:
                    for (; ++j < length;) {
                        (ev = list[j]).callback.call(ev.ctx, a1);
                    }
                    break;
                case 2:
                    for (; ++j < length;) {
                        (ev = list[j]).callback.call(ev.ctx, a1, pageX);
                    }
                    break;
                case 3:
                    for (; ++j < length;) {
                        (ev = list[j]).callback.call(ev.ctx, a1, pageX, next);
                    }
                    break;
                default:
                    for (; ++j < length;) {
                        (ev = list[j]).callback.apply(ev.ctx, args);
                    }
                    ;
            }
        };
        /** @type {function (string, Function, Function): ?} */
        Events.bind = Events.on;
        /** @type {function (string, Function, Object): ?} */
        Events.unbind = Events.off;
        _.extend(Backbone, Events);
        /** @type {function (Object, Object): undefined} */
        var Model = Backbone.Model = function (attributes, options) {
            var attrs = attributes || {};
            if (!options) {
                options = {};
            }
            this.cid = _.uniqueId(this.cidPrefix);
            this.attributes = {};
            if (options.collection) {
                this.collection = options.collection;
            }
            if (options.parse) {
                attrs = this.parse(attrs, options) || {};
            }
            var defaults = _.result(this, "defaults");
            attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
            this.set(attrs, options);
            this.changed = {};
            this.initialize.apply(this, arguments);
        };
        _.extend(Model.prototype, Events, {
            changed: null,
            validationError: null,
            idAttribute: "id",
            cidPrefix: "c",
            /**
             * @return {undefined}
             */
            initialize: function () {
            },
            /**
             * @param {Object} options
             * @return {?}
             */
            toJSON: function (options) {
                return _.clone(this.attributes);
            },
            /**
             * @return {?}
             */
            sync: function () {
                return Backbone.sync.apply(this, arguments);
            },
            /**
             * @param {string} name
             * @return {?}
             */
            get: function (name) {
                return this.attributes[name];
            },
            /**
             * @param {string} attr
             * @return {?}
             */
            escape: function (attr) {
                return _.escape(this.get(attr));
            },
            /**
             * @param {Object} obj
             * @return {?}
             */
            has: function (obj) {
                return null != this.get(obj);
            },
            /**
             * @param {string} xs
             * @return {?}
             */
            matches: function (xs) {
                return !!_.iteratee(xs, this)(this.attributes);
            },
            /**
             * @param {?} key
             * @param {string} val
             * @param {Object} options
             * @return {?}
             */
            set: function (key, val, options) {
                if (null == key) {
                    return this;
                }
                if ("object" === typeof key) {
                    var attrs = key;
                    /** @type {string} */
                    options = val;
                } else {
                    /** @type {string} */
                    (attrs = {})[key] = val;
                }
                if (!options) {
                    options = {};
                }
                if (!this._validate(attrs, options)) {
                    return false;
                }
                var unset = options.unset;
                key = options.silent;
                /** @type {Array} */
                var changes = [];
                var changing = this._changing;
                /** @type {boolean} */
                this._changing = true;
                if (!changing) {
                    this._previousAttributes = _.clone(this.attributes);
                    this.changed = {};
                }
                var current = this.attributes;
                var res = this.changed;
                var old = this._previousAttributes;
                var attr;
                for (attr in attrs) {
                    val = attrs[attr];
                    if (!_.isEqual(current[attr], val)) {
                        changes.push(attr);
                    }
                    if (_.isEqual(old[attr], val)) {
                        delete res[attr];
                    } else {
                        /** @type {string} */
                        res[attr] = val;
                    }
                    if (unset) {
                        delete current[attr];
                    } else {
                        /** @type {string} */
                        current[attr] = val;
                    }
                }
                if (this.idAttribute in attrs) {
                    this.id = this.get(this.idAttribute);
                }
                if (!key) {
                    if (changes.length) {
                        /** @type {Object} */
                        this._pending = options;
                    }
                    /** @type {number} */
                    val = 0;
                    for (; val < changes.length; val++) {
                        this.trigger("change:" + changes[val], this, current[changes[val]], options);
                    }
                }
                if (changing) {
                    return this;
                }
                if (!key) {
                    for (; this._pending;) {
                        options = this._pending;
                        /** @type {boolean} */
                        this._pending = false;
                        this.trigger("change", this, options);
                    }
                }
                /** @type {boolean} */
                this._changing = this._pending = false;
                return this;
            },
            /**
             * @param {string} attr
             * @param {Object} options
             * @return {?}
             */
            unset: function (attr, options) {
                return this.set(attr, void 0, _.extend({}, options, {
                    unset: true
                }));
            },
            /**
             * @param {Object} options
             * @return {?}
             */
            clear: function (options) {
                var attrs = {};
                var key;
                for (key in this.attributes) {
                    attrs[key] = void 0;
                }
                return this.set(attrs, _.extend({}, options, {
                    unset: true
                }));
            },
            /**
             * @param {string} attr
             * @return {?}
             */
            hasChanged: function (attr) {
                return null == attr ? !_.isEmpty(this.changed) : _.has(this.changed, attr);
            },
            /**
             * @param {Object} diff
             * @return {?}
             */
            changedAttributes: function (diff) {
                if (!diff) {
                    return this.hasChanged() ? _.clone(this.changed) : false;
                }
                var old = this._changing ? this._previousAttributes : this.attributes;
                var ret = {};
                var attr;
                for (attr in diff) {
                    var val = diff[attr];
                    if (!_.isEqual(old[attr], val)) {
                        ret[attr] = val;
                    }
                }
                return _.size(ret) ? ret : false;
            },
            /**
             * @param {string} attr
             * @return {?}
             */
            previous: function (attr) {
                return null != attr && this._previousAttributes ? this._previousAttributes[attr] : null;
            },
            /**
             * @return {?}
             */
            previousAttributes: function () {
                return _.clone(this._previousAttributes);
            },
            /**
             * @param {Object} options
             * @return {?}
             */
            fetch: function (options) {
                options = _.extend({
                    parse: true
                }, options);
                var model = this;
                /** @type {function (string): ?} */
                var callback = options.success;
                /**
                 * @param {string} data
                 * @return {?}
                 */
                options.success = function (data) {
                    var serverAttrs = options.parse ? model.parse(data, options) : data;
                    if (!model.set(serverAttrs, options)) {
                        return false;
                    }
                    if (callback) {
                        callback.call(options.context, model, data, options);
                    }
                    model.trigger("sync", model, data, options);
                };
                wrapError(this, options);
                return this.sync("read", this, options);
            },
            /**
             * @param {string} data
             * @param {Object} value
             * @param {Object} options
             * @return {?}
             */
            save: function (data, value, options) {
                if (null == data || "object" === typeof data) {
                    /** @type {string} */
                    var attrs = data;
                    /** @type {Object} */
                    options = value;
                } else {
                    /** @type {Object} */
                    (attrs = {})[data] = value;
                }
                options = _.extend({
                    validate: true,
                    parse: true
                }, options);
                var wait = options.wait;
                if (attrs && !wait) {
                    if (!this.set(attrs, options)) {
                        return false;
                    }
                } else {
                    if (!this._validate(attrs, options)) {
                        return false;
                    }
                }
                var model = this;
                /** @type {function (Node): ?} */
                var callback = options.success;
                var attributes = this.attributes;
                /**
                 * @param {Node} data
                 * @return {?}
                 */
                options.success = function (data) {
                    model.attributes = attributes;
                    var a = options.parse ? model.parse(data, options) : data;
                    if (wait) {
                        a = _.extend({}, attrs, a);
                    }
                    if (a && !model.set(a, options)) {
                        return false;
                    }
                    if (callback) {
                        callback.call(options.context, model, data, options);
                    }
                    model.trigger("sync", model, data, options);
                };
                wrapError(this, options);
                if (attrs) {
                    if (wait) {
                        this.attributes = _.extend({}, attributes, attrs);
                    }
                }
                /** @type {string} */
                data = this.isNew() ? "create" : options.patch ? "patch" : "update";
                if (!("patch" !== data)) {
                    if (!options.attrs) {
                        options.attrs = attrs;
                    }
                }
                data = this.sync(data, this, options);
                this.attributes = attributes;
                return data;
            },
            /**
             * @param {Object} options
             * @return {?}
             */
            destroy: function (options) {
                options = options ? _.clone(options) : {};
                var model = this;
                /** @type {function (string): undefined} */
                var callback = options.success;
                var wait = options.wait;
                /**
                 * @return {undefined}
                 */
                var destroy = function () {
                    model.stopListening();
                    model.trigger("destroy", model, model.collection, options);
                };
                /**
                 * @param {string} resp
                 * @return {undefined}
                 */
                options.success = function (resp) {
                    if (wait) {
                        destroy();
                    }
                    if (callback) {
                        callback.call(options.context, model, resp, options);
                    }
                    if (!model.isNew()) {
                        model.trigger("sync", model, resp, options);
                    }
                };
                /** @type {boolean} */
                var xhr = false;
                if (this.isNew()) {
                    _.defer(options.success);
                } else {
                    wrapError(this, options);
                    xhr = this.sync("delete", this, options);
                }
                if (!wait) {
                    destroy();
                }
                return xhr;
            },
            /**
             * @return {?}
             */
            url: function () {
                var string = _.result(this, "urlRoot") || (_.result(this.collection, "url") || urlError());
                if (this.isNew()) {
                    return string;
                }
                var h = this.get(this.idAttribute);
                return string.replace(/[^\/]$/, "$&/") + encodeURIComponent(h);
            },
            /**
             * @param {Node} models
             * @param {Object} namespace
             * @return {?}
             */
            parse: function (models, namespace) {
                return models;
            },
            /**
             * @return {?}
             */
            clone: function () {
                return new this.constructor(this.attributes);
            },
            /**
             * @return {?}
             */
            isNew: function () {
                return !this.has(this.idAttribute);
            },
            /**
             * @param {Object} protoProps
             * @return {?}
             */
            isValid: function (protoProps) {
                return this._validate({}, _.extend({}, protoProps, {
                    validate: true
                }));
            },
            /**
             * @param {(Object|string)} attrs
             * @param {Object} options
             * @return {?}
             */
            _validate: function (attrs, options) {
                if (!options.validate || !this.validate) {
                    return true;
                }
                attrs = _.extend({}, this.attributes, attrs);
                attrs = this.validationError = this.validate(attrs, options) || null;
                if (!attrs) {
                    return true;
                }
                this.trigger("invalid", this, attrs, _.extend(options, {
                    validationError: attrs
                }));
                return false;
            }
        });
        Collection(Model, {
            keys: 1,
            values: 1,
            pairs: 1,
            invert: 1,
            pick: 0,
            omit: 0,
            chain: 1,
            isEmpty: 1
        }, "attributes");
        /** @type {function (?, Object): undefined} */
        var Router = Backbone.Collection = function (models, options) {
            if (!options) {
                options = {};
            }
            if (options.model) {
                this.model = options.model;
            }
            if (void 0 !== options.comparator) {
                this.comparator = options.comparator;
            }
            this._reset();
            this.initialize.apply(this, arguments);
            if (models) {
                this.reset(models, _.extend({
                    silent: true
                }, options));
            }
        };
        var defaults = {
            add: true,
            remove: true,
            merge: true
        };
        var addOptions = {
            add: true,
            remove: false
        };
        /**
         * @param {(Array|number)} items
         * @param {Array} a
         * @param {number} offset
         * @return {undefined}
         */
        var slice = function (items, a, offset) {
            /** @type {number} */
            offset = Math.min(Math.max(offset, 0), items.length);
            /** @type {Array} */
            var result = Array(items.length - offset);
            var j = a.length;
            var i;
            /** @type {number} */
            i = 0;
            for (; i < result.length; i++) {
                result[i] = items[i + offset];
            }
            /** @type {number} */
            i = 0;
            for (; i < j; i++) {
                items[i + offset] = a[i];
            }
            /** @type {number} */
            i = 0;
            for (; i < result.length; i++) {
                items[i + j + offset] = result[i];
            }
        };
        _.extend(Router.prototype, Events, {
            /** @type {function (Object, Object): undefined} */
            model: Model,
            /**
             * @return {undefined}
             */
            initialize: function () {
            },
            /**
             * @param {Object} options
             * @return {?}
             */
            toJSON: function (options) {
                return this.map(function (model) {
                    return model.toJSON(options);
                });
            },
            /**
             * @return {?}
             */
            sync: function () {
                return Backbone.sync.apply(this, arguments);
            },
            /**
             * @param {?} attr
             * @param {string} options
             * @return {?}
             */
            add: function (attr, options) {
                return this.set(attr, _.extend({
                    merge: false
                }, options, addOptions));
            },
            /**
             * @param {?} models
             * @param {Object} options
             * @return {?}
             */
            remove: function (models, options) {
                options = _.extend({}, options);
                /** @type {boolean} */
                var singular = !_.isArray(models);
                models = singular ? [models] : models.slice();
                models = this._removeModels(models, options);
                if (!options.silent) {
                    if (models.length) {
                        options.changes = {
                            added: [],
                            merged: [],
                            removed: models
                        };
                        this.trigger("update", this, options);
                    }
                }
                return singular ? models[0] : models;
            },
            /**
             * @param {string} models
             * @param {Object} options
             * @return {?}
             */
            set: function (models, options) {
                if (null != models) {
                    options = _.extend({}, defaults, options);
                    if (options.parse) {
                        if (!this._isModel(models)) {
                            models = this.parse(models, options) || [];
                        }
                    }
                    /** @type {boolean} */
                    var singular = !_.isArray(models);
                    models = singular ? [models] : models.slice();
                    var index = options.at;
                    if (null != index) {
                        /** @type {number} */
                        index = +index;
                    }
                    if (index > this.length) {
                        index = this.length;
                    }
                    if (0 > index) {
                        index += this.length + 1;
                    }
                    /** @type {Array} */
                    var list = [];
                    /** @type {Array} */
                    var add = [];
                    /** @type {Array} */
                    var added = [];
                    /** @type {Array} */
                    var removed = [];
                    var modelMap = {};
                    var async = options.add;
                    var merge = options.merge;
                    var remove = options.remove;
                    /** @type {boolean} */
                    var q = false;
                    var sortable = this.comparator && (null == index && false !== options.sort);
                    var sortAttr = _.isString(this.comparator) ? this.comparator : null;
                    var i;
                    /** @type {number} */
                    i = 0;
                    for (; i < models.length; i++) {
                        var model = models[i];
                        var existing = this.get(model);
                        if (existing) {
                            if (merge) {
                                if (model !== existing) {
                                    model = this._isModel(model) ? model.attributes : model;
                                    if (options.parse) {
                                        model = existing.parse(model, options);
                                    }
                                    existing.set(model, options);
                                    added.push(existing);
                                    if (sortable) {
                                        if (!q) {
                                            q = existing.hasChanged(sortAttr);
                                        }
                                    }
                                }
                            }
                            if (!modelMap[existing.cid]) {
                                /** @type {boolean} */
                                modelMap[existing.cid] = true;
                                list.push(existing);
                            }
                            models[i] = existing;
                        } else {
                            if (async) {
                                if (model = models[i] = this._prepareModel(model, options)) {
                                    add.push(model);
                                    this._addReference(model, options);
                                    /** @type {boolean} */
                                    modelMap[model.cid] = true;
                                    list.push(model);
                                }
                            }
                        }
                    }
                    if (remove) {
                        /** @type {number} */
                        i = 0;
                        for (; i < this.length; i++) {
                            model = this.models[i];
                            if (!modelMap[model.cid]) {
                                removed.push(model);
                            }
                        }
                        if (removed.length) {
                            this._removeModels(removed, options);
                        }
                    }
                    /** @type {boolean} */
                    modelMap = false;
                    if (list.length && (!sortable && (async && remove))) {
                        modelMap = this.length !== list.length || _.some(this.models, function (listener, i) {
                            return listener !== list[i];
                        });
                        /** @type {number} */
                        this.models.length = 0;
                        slice(this.models, list, 0);
                        /** @type {number} */
                        this.length = this.models.length;
                    } else {
                        if (add.length) {
                            if (sortable) {
                                /** @type {boolean} */
                                q = true;
                            }
                            slice(this.models, add, null == index ? this.length : index);
                            this.length = this.models.length;
                        }
                    }
                    if (q) {
                        this.sort({
                            silent: true
                        });
                    }
                    if (!options.silent) {
                        /** @type {number} */
                        i = 0;
                        for (; i < add.length; i++) {
                            if (null != index) {
                                options.index = index + i;
                            }
                            model = add[i];
                            model.trigger("add", model, this, options);
                        }
                        if (q || modelMap) {
                            this.trigger("sort", this, options);
                        }
                        if (add.length || (removed.length || added.length)) {
                            options.changes = {
                                added: add,
                                removed: removed,
                                merged: added
                            };
                            this.trigger("update", this, options);
                        }
                    }
                    return singular ? models[0] : models;
                }
            },
            /**
             * @param {?} models
             * @param {Object} options
             * @return {?}
             */
            reset: function (models, options) {
                options = options ? _.clone(options) : {};
                /** @type {number} */
                var i = 0;
                for (; i < this.models.length; i++) {
                    this._removeReference(this.models[i], options);
                }
                options.previousModels = this.models;
                this._reset();
                models = this.add(models, _.extend({
                    silent: true
                }, options));
                if (!options.silent) {
                    this.trigger("reset", this, options);
                }
                return models;
            },
            /**
             * @param {?} obj
             * @param {Object} options
             * @return {?}
             */
            push: function (obj, options) {
                return this.add(obj, _.extend({
                    at: this.length
                }, options));
            },
            /**
             * @param {string} options
             * @return {?}
             */
            pop: function (options) {
                var model = this.at(this.length - 1);
                return this.remove(model, options);
            },
            /**
             * @param {?} model
             * @param {Function} options
             * @return {?}
             */
            unshift: function (model, options) {
                return this.add(model, _.extend({
                    at: 0
                }, options));
            },
            /**
             * @param {string} options
             * @return {?}
             */
            shift: function (options) {
                var model = this.at(0);
                return this.remove(model, options);
            },
            /**
             * @return {?}
             */
            slice: function () {
                return func.apply(this.models, arguments);
            },
            /**
             * @param {string} name
             * @return {?}
             */
            get: function (name) {
                if (null != name) {
                    return this._byId[name] || (this._byId[this.modelId(name.attributes || name)] || name.cid && this._byId[name.cid]);
                }
            },
            /**
             * @param {Object} obj
             * @return {?}
             */
            has: function (obj) {
                return null != this.get(obj);
            },
            /**
             * @param {string} index
             * @return {?}
             */
            at: function (index) {
                if (0 > index) {
                    index += this.length;
                }
                return this.models[index];
            },
            /**
             * @param {Function} obj
             * @param {boolean} first
             * @return {?}
             */
            where: function (obj, first) {
                return this[first ? "find" : "filter"](obj);
            },
            /**
             * @param {Function} walkers
             * @return {?}
             */
            findWhere: function (walkers) {
                return this.where(walkers, true);
            },
            /**
             * @param {Object} options
             * @return {?}
             */
            sort: function (options) {
                var v = this.comparator;
                if (!v) {
                    throw Error("Cannot sort a set without a comparator");
                }
                if (!options) {
                    options = {};
                }
                var pad = v.length;
                if (_.isFunction(v)) {
                    v = _.bind(v, this);
                }
                if (1 === pad || _.isString(v)) {
                    this.models = this.sortBy(v);
                } else {
                    this.models.sort(v);
                }
                if (!options.silent) {
                    this.trigger("sort", this, options);
                }
                return this;
            },
            /**
             * @param {string} property
             * @return {?}
             */
            pluck: function (property) {
                return this.map(property + "");
            },
            /**
             * @param {Object} options
             * @return {?}
             */
            fetch: function (options) {
                options = _.extend({
                    parse: true
                }, options);
                /** @type {function (string): undefined} */
                var callback = options.success;
                var collection = this;
                /**
                 * @param {string} resp
                 * @return {undefined}
                 */
                options.success = function (resp) {
                    collection[options.reset ? "reset" : "set"](resp, options);
                    if (callback) {
                        callback.call(options.context, collection, resp, options);
                    }
                    collection.trigger("sync", collection, resp, options);
                };
                wrapError(this, options);
                return this.sync("read", this, options);
            },
            /**
             * @param {Object} model
             * @param {Object} options
             * @return {?}
             */
            create: function (model, options) {
                options = options ? _.clone(options) : {};
                var wait = options.wait;
                model = this._prepareModel(model, options);
                if (!model) {
                    return false;
                }
                if (!wait) {
                    this.add(model, options);
                }
                var collection = this;
                /** @type {function (?, string, Object): undefined} */
                var callback = options.success;
                /**
                 * @param {?} model
                 * @param {string} data
                 * @param {Object} options
                 * @return {undefined}
                 */
                options.success = function (model, data, options) {
                    if (wait) {
                        collection.add(model, options);
                    }
                    if (callback) {
                        callback.call(options.context, model, data, options);
                    }
                };
                model.save(null, options);
                return model;
            },
            /**
             * @param {Node} models
             * @param {Object} namespace
             * @return {?}
             */
            parse: function (models, namespace) {
                return models;
            },
            /**
             * @return {?}
             */
            clone: function () {
                return new this.constructor(this.models, {
                    model: this.model,
                    comparator: this.comparator
                });
            },
            /**
             * @param {?} item
             * @return {?}
             */
            modelId: function (item) {
                return item[this.model.prototype.idAttribute || "id"];
            },
            /**
             * @return {undefined}
             */
            _reset: function () {
                /** @type {number} */
                this.length = 0;
                /** @type {Array} */
                this.models = [];
                this._byId = {};
            },
            /**
             * @param {?} model
             * @param {?} options
             * @return {?}
             */
            _prepareModel: function (model, options) {
                if (this._isModel(model)) {
                    return model.collection || (model.collection = this), model;
                }
                options = options ? _.clone(options) : {};
                options.collection = this;
                model = new this.model(model, options);
                if (!model.validationError) {
                    return model;
                }
                this.trigger("invalid", this, model.validationError, options);
                return false;
            },
            /**
             * @param {Array} models
             * @param {Object} options
             * @return {?}
             */
            _removeModels: function (models, options) {
                /** @type {Array} */
                var add = [];
                /** @type {number} */
                var i = 0;
                for (; i < models.length; i++) {
                    var model = this.get(models[i]);
                    if (model) {
                        var index = this.indexOf(model);
                        this.models.splice(index, 1);
                        this.length--;
                        delete this._byId[model.cid];
                        var obj = this.modelId(model.attributes);
                        if (null != obj) {
                            delete this._byId[obj];
                        }
                        if (!options.silent) {
                            options.index = index;
                            model.trigger("remove", model, this, options);
                        }
                        add.push(model);
                        this._removeReference(model, options);
                    }
                }
                return add;
            },
            /**
             * @param {string} object
             * @return {?}
             */
            _isModel: function (object) {
                return object instanceof Model;
            },
            /**
             * @param {Object} model
             * @param {Object} id
             * @return {undefined}
             */
            _addReference: function (model, id) {
                /** @type {Object} */
                this._byId[model.cid] = model;
                id = this.modelId(model.attributes);
                if (null != id) {
                    /** @type {Object} */
                    this._byId[id] = model;
                }
                model.on("all", this._onModelEvent, this);
            },
            /**
             * @param {Object} model
             * @param {Object} extended
             * @return {undefined}
             */
            _removeReference: function (model, extended) {
                delete this._byId[model.cid];
                extended = this.modelId(model.attributes);
                if (null != extended) {
                    delete this._byId[extended];
                }
                if (this === model.collection) {
                    delete model.collection;
                }
                model.off("all", this._onModelEvent, this);
            },
            /**
             * @param {string} mode
             * @param {Object} model
             * @param {Object} collection
             * @param {string} options
             * @return {undefined}
             */
            _onModelEvent: function (mode, model, collection, options) {
                if (model) {
                    if (("add" === mode || "remove" === mode) && collection !== this) {
                        return;
                    }
                    if ("destroy" === mode) {
                        this.remove(model, options);
                    }
                    if ("change" === mode) {
                        var newId = this.modelId(model.previousAttributes());
                        var id = this.modelId(model.attributes);
                        if (newId !== id) {
                            if (null != newId) {
                                delete this._byId[newId];
                            }
                            if (null != id) {
                                /** @type {Object} */
                                this._byId[id] = model;
                            }
                        }
                    }
                }
                this.trigger.apply(this, arguments);
            }
        });
        Collection(Router, {
            forEach: 3,
            each: 3,
            map: 3,
            collect: 3,
            reduce: 0,
            foldl: 0,
            inject: 0,
            reduceRight: 0,
            foldr: 0,
            find: 3,
            detect: 3,
            filter: 3,
            select: 3,
            reject: 3,
            every: 3,
            all: 3,
            some: 3,
            any: 3,
            include: 3,
            includes: 3,
            contains: 3,
            invoke: 0,
            max: 3,
            min: 3,
            toArray: 1,
            size: 1,
            first: 3,
            head: 3,
            take: 3,
            initial: 3,
            rest: 3,
            tail: 3,
            drop: 3,
            last: 3,
            without: 0,
            difference: 0,
            indexOf: 3,
            shuffle: 1,
            lastIndexOf: 3,
            isEmpty: 1,
            chain: 1,
            sample: 3,
            partition: 3,
            groupBy: 3,
            countBy: 3,
            sortBy: 3,
            indexBy: 3,
            findIndex: 3,
            findLastIndex: 3
        }, "models");
        /** @type {function (Function): undefined} */
        Collection = Backbone.View = function (options) {
            this.cid = _.uniqueId("view");
            _.extend(this, _.pick(options, keys));
            this._ensureElement();
            this.initialize.apply(this, arguments);
        };
        /** @type {RegExp} */
        var delegateEventSplitter = /^(\S+)\s*(.*)$/;
        /** @type {Array.<string>} */
        var keys = "model collection el id attributes className tagName events".split(" ");
        _.extend(Collection.prototype, Events, {
            tagName: "div",
            /**
             * @param {string} selector
             * @return {?}
             */
            $: function (selector) {
                return this.$el.find(selector);
            },
            /**
             * @return {undefined}
             */
            initialize: function () {
            },
            /**
             * @return {?}
             */
            render: function () {
                return this;
            },
            /**
             * @return {?}
             */
            remove: function () {
                this._removeElement();
                this.stopListening();
                return this;
            },
            /**
             * @return {undefined}
             */
            _removeElement: function () {
                this.$el.remove();
            },
            /**
             * @param {Object} value
             * @return {?}
             */
            setElement: function (value) {
                this.undelegateEvents();
                this._setElement(value);
                this.delegateEvents();
                return this;
            },
            /**
             * @param {Object} element
             * @return {undefined}
             */
            _setElement: function (element) {
                this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
                this.el = this.$el[0];
            },
            /**
             * @param {Object} events
             * @return {?}
             */
            delegateEvents: function (events) {
                if (!events) {
                    events = _.result(this, "events");
                }
                if (!events) {
                    return this;
                }
                this.undelegateEvents();
                var key;
                for (key in events) {
                    var v = events[key];
                    if (!_.isFunction(v)) {
                        v = this[v];
                    }
                    if (v) {
                        /** @type {(Array.<string>|null)} */
                        var match = key.match(delegateEventSplitter);
                        this.delegate(match[1], match[2], _.bind(v, this));
                    }
                }
                return this;
            },
            /**
             * @param {string} methods
             * @param {?} selector
             * @param {Function} data
             * @return {?}
             */
            delegate: function (methods, selector, data) {
                this.$el.on(methods + ".delegateEvents" + this.cid, selector, data);
                return this;
            },
            /**
             * @return {?}
             */
            undelegateEvents: function () {
                if (this.$el) {
                    this.$el.off(".delegateEvents" + this.cid);
                }
                return this;
            },
            /**
             * @param {string} callback
             * @param {Function} selector
             * @param {Object} fn
             * @return {?}
             */
            undelegate: function (callback, selector, fn) {
                this.$el.off(callback + ".delegateEvents" + this.cid, selector, fn);
                return this;
            },
            /**
             * @param {?} name
             * @return {?}
             */
            _createElement: function (name) {
                return document.createElement(name);
            },
            /**
             * @return {undefined}
             */
            _ensureElement: function () {
                if (this.el) {
                    this.setElement(_.result(this, "el"));
                } else {
                    var attrs = _.extend({}, _.result(this, "attributes"));
                    if (this.id) {
                        attrs.id = _.result(this, "id");
                    }
                    if (this.className) {
                        attrs["class"] = _.result(this, "className");
                    }
                    this.setElement(this._createElement(_.result(this, "tagName")));
                    this._setAttributes(attrs);
                }
            },
            /**
             * @param {string} name
             * @return {undefined}
             */
            _setAttributes: function (name) {
                this.$el.attr(name);
            }
        });
        /**
         * @param {string} action
         * @param {Object} model
         * @param {Object} options
         * @return {?}
         */
        Backbone.sync = function (action, model, options) {
            var method = methodMap[action];
            _.defaults(options || (options = {}), {
                emulateHTTP: Backbone.emulateHTTP,
                emulateJSON: Backbone.emulateJSON
            });
            var params = {
                type: method,
                dataType: "json"
            };
            if (!options.url) {
                params.url = _.result(model, "url") || urlError();
            }
            if (!(null != options.data)) {
                if (!!model) {
                    if (!("create" !== action && ("update" !== action && "patch" !== action))) {
                        /** @type {string} */
                        params.contentType = "application/json";
                        /** @type {string} */
                        params.data = JSON.stringify(options.attrs || model.toJSON(options));
                    }
                }
            }
            if (options.emulateJSON) {
                /** @type {string} */
                params.contentType = "application/x-www-form-urlencoded";
                /** @type {({model: ??}|{})} */
                params.data = params.data ? {
                    model: params.data
                } : {};
            }
            if (options.emulateHTTP && ("PUT" === method || ("DELETE" === method || "PATCH" === method))) {
                /** @type {string} */
                params.type = "POST";
                if (options.emulateJSON) {
                    params.data._method = method;
                }
                var beforeSend = options.beforeSend;
                /**
                 * @param {Object} xhr
                 * @return {?}
                 */
                options.beforeSend = function (xhr) {
                    xhr.setRequestHeader("X-HTTP-Method-Override", method);
                    if (beforeSend) {
                        return beforeSend.apply(this, arguments);
                    }
                };
            }
            if (!("GET" === params.type)) {
                if (!options.emulateJSON) {
                    /** @type {boolean} */
                    params.processData = false;
                }
            }
            /** @type {function (string, ?, ?): undefined} */
            var fn = options.error;
            /**
             * @param {string} event
             * @param {?} index
             * @param {?} href
             * @return {undefined}
             */
            options.error = function (event, index, href) {
                options.textStatus = index;
                options.errorThrown = href;
                if (fn) {
                    fn.call(options.context, event, index, href);
                }
            };
            action = options.xhr = Backbone.ajax(_.extend(params, options));
            model.trigger("request", model, action, options);
            return action;
        };
        var methodMap = {
            create: "POST",
            update: "PUT",
            patch: "PATCH",
            "delete": "DELETE",
            read: "GET"
        };
        /**
         * @return {?}
         */
        Backbone.ajax = function () {
            return Backbone.$.ajax.apply(Backbone.$, arguments);
        };
        /** @type {function (Object): undefined} */
        var EA = Backbone.Router = function (options) {
            if (!options) {
                options = {};
            }
            if (options.routes) {
                this.routes = options.routes;
            }
            this._bindRoutes();
            this.initialize.apply(this, arguments);
        };
        /** @type {RegExp} */
        var rreturn = /\((.*?)\)/g;
        /** @type {RegExp} */
        var rSlash = /(\(\?)?:\w+/g;
        /** @type {RegExp} */
        var splatParam = /\*\w+/g;
        /** @type {RegExp} */
        var rclass = /[\-{}\[\]+?.,\\\^$|#\s]/g;
        _.extend(EA.prototype, Events, {
            /**
             * @return {undefined}
             */
            initialize: function () {
            },
            /**
             * @param {string} route
             * @param {string} data
             * @param {(Function|string)} callback
             * @return {?}
             */
            route: function (route, data, callback) {
                if (!_.isRegExp(route)) {
                    route = this._routeToRegExp(route);
                }
                if (_.isFunction(data)) {
                    /** @type {string} */
                    callback = data;
                    /** @type {string} */
                    data = "";
                }
                if (!callback) {
                    callback = this[data];
                }
                var self = this;
                Backbone.history.route(route, function (args) {
                    args = self._extractParameters(route, args);
                    if (false !== self.execute(callback, args, data)) {
                        self.trigger.apply(self, ["route:" + data].concat(args));
                        self.trigger("route", data, args);
                        Backbone.history.trigger("route", self, data, args);
                    }
                });
                return this;
            },
            /**
             * @param {Function} callback
             * @param {Array} args
             * @param {string} packet
             * @return {undefined}
             */
            execute: function (callback, args, packet) {
                if (callback) {
                    callback.apply(this, args);
                }
            },
            /**
             * @param {string} fragment
             * @param {Object} options
             * @return {?}
             */
            navigate: function (fragment, options) {
                Backbone.history.navigate(fragment, options);
                return this;
            },
            /**
             * @return {undefined}
             */
            _bindRoutes: function () {
                if (this.routes) {
                    this.routes = _.result(this, "routes");
                    var route;
                    var routes = _.keys(this.routes);
                    for (; null != (route = routes.pop());) {
                        this.route(route, this.routes[route]);
                    }
                }
            },
            /**
             * @param {string} route
             * @return {?}
             */
            _routeToRegExp: function (route) {
                route = route.replace(rclass, "\\$&").replace(rreturn, "(?:$1)?").replace(rSlash, function (match, optional) {
                    return optional ? match : "([^/?]+)";
                }).replace(splatParam, "([^?]*?)");
                return new RegExp("^" + route + "(?:\\?([\\s\\S]*))?$");
            },
            /**
             * @param {string} route
             * @param {Array} fragment
             * @return {?}
             */
            _extractParameters: function (route, fragment) {
                var scripts = route.exec(fragment).slice(1);
                return _.map(scripts, function (param, dataAndEvents) {
                    return dataAndEvents === scripts.length - 1 ? param || null : param ? decodeURIComponent(param) : null;
                });
            }
        });
        /** @type {function (): undefined} */
        var History = Backbone.History = function () {
            /** @type {Array} */
            this.handlers = [];
            this.checkUrl = _.bind(this.checkUrl, this);
            if ("undefined" !== typeof self) {
                /** @type {Location} */
                this.location = self.location;
                /** @type {History} */
                this.history = self.history;
            }
        };
        /** @type {RegExp} */
        var routeStripper = /^[#\/]|\s+$/g;
        /** @type {RegExp} */
        var r20 = /^\/+|\/+$/g;
        /** @type {RegExp} */
        var pathStripper = /#.*$/;
        /** @type {boolean} */
        History.started = false;
        _.extend(History.prototype, Events, {
            interval: 50,
            /**
             * @return {?}
             */
            atRoot: function () {
                return this.location.pathname.replace(/[^\/]$/, "$&/") === this.root && !this.getSearch();
            },
            /**
             * @return {?}
             */
            matchRoot: function () {
                return this.decodeFragment(this.location.pathname).slice(0, this.root.length - 1) + "/" === this.root;
            },
            /**
             * @param {string} messageFormat
             * @return {?}
             */
            decodeFragment: function (messageFormat) {
                return decodeURI(messageFormat.replace(/%25/g, "%2525"));
            },
            /**
             * @return {?}
             */
            getSearch: function () {
                var namespaceMatch = this.location.href.replace(/#.*/, "").match(/\?.+/);
                return namespaceMatch ? namespaceMatch[0] : "";
            },
            /**
             * @param {Object} sUrl
             * @return {?}
             */
            getHash: function (sUrl) {
                return (sUrl = (sUrl || this).location.href.match(/#(.*)$/)) ? sUrl[1] : "";
            },
            /**
             * @return {?}
             */
            getPath: function () {
                var buffer = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
                return "/" === buffer.charAt(0) ? buffer.slice(1) : buffer;
            },
            /**
             * @param {string} fragment
             * @return {?}
             */
            getFragment: function (fragment) {
                if (null == fragment) {
                    fragment = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash();
                }
                return fragment.replace(routeStripper, "");
            },
            /**
             * @param {string} target
             * @return {?}
             */
            start: function (target) {
                if (History.started) {
                    throw Error("Backbone.history has already been started");
                }
                /** @type {boolean} */
                History.started = true;
                this.options = _.extend({
                    root: "/"
                }, this.options, target);
                this.root = this.options.root;
                /** @type {boolean} */
                this._wantsHashChange = false !== this.options.hashChange;
                /** @type {boolean} */
                this._hasHashChange = "onhashchange" in self && (void 0 === document.documentMode || 7 < document.documentMode);
                /** @type {boolean} */
                this._useHashChange = this._wantsHashChange && this._hasHashChange;
                /** @type {boolean} */
                this._wantsPushState = !!this.options.pushState;
                /** @type {boolean} */
                this._hasPushState = !(!this.history || !this.history.pushState);
                /** @type {boolean} */
                this._usePushState = this._wantsPushState && this._hasPushState;
                this.fragment = this.getFragment();
                /** @type {string} */
                this.root = ("/" + this.root + "/").replace(r20, "/");
                if (this._wantsHashChange && this._wantsPushState) {
                    if (this._hasPushState || this.atRoot()) {
                        if (this._hasPushState) {
                            if (this.atRoot()) {
                                this.navigate(this.getHash(), {
                                    replace: true
                                });
                            }
                        }
                    } else {
                        return target = this.root.slice(0, -1) || "/", this.location.replace(target + "#" + this.getPath()), true;
                    }
                }
                if (!this._hasHashChange) {
                    if (!!this._wantsHashChange) {
                        if (!this._usePushState) {
                            /** @type {Element} */
                            this.iframe = document.createElement("iframe");
                            /** @type {string} */
                            this.iframe.src = "javascript:0";
                            /** @type {string} */
                            this.iframe.style.display = "none";
                            /** @type {number} */
                            this.iframe.tabIndex = -1;
                            /** @type {(HTMLElement|null)} */
                            target = document.body;
                            target = target.insertBefore(this.iframe, target.firstChild).contentWindow;
                            target.document.open();
                            target.document.close();
                            /** @type {string} */
                            target.location.hash = "#" + this.fragment;
                        }
                    }
                }
                /** @type {function (this:Window, string, (EventListener|function ((Event|null)): (boolean|undefined)|null), boolean): undefined} */
                target = self.addEventListener || function (type, evt) {
                    return attachEvent("on" + type, evt);
                };
                if (this._usePushState) {
                    target("popstate", this.checkUrl, false);
                } else {
                    if (this._useHashChange && !this.iframe) {
                        target("hashchange", this.checkUrl, false);
                    } else {
                        if (this._wantsHashChange) {
                            /** @type {number} */
                            this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
                        }
                    }
                }
                if (!this.options.silent) {
                    return this.loadUrl();
                }
            },
            /**
             * @return {undefined}
             */
            stop: function () {
                /** @type {function (this:Window, string, (EventListener|function ((Event|null)): (boolean|undefined)|null), boolean): undefined} */
                var cancelAnimationFrame = self.removeEventListener || function (ev, evt) {
                    return detachEvent("on" + ev, evt);
                };
                if (this._usePushState) {
                    cancelAnimationFrame("popstate", this.checkUrl, false);
                } else {
                    if (this._useHashChange) {
                        if (!this.iframe) {
                            cancelAnimationFrame("hashchange", this.checkUrl, false);
                        }
                    }
                }
                if (this.iframe) {
                    document.body.removeChild(this.iframe);
                    /** @type {null} */
                    this.iframe = null;
                }
                if (this._checkUrlInterval) {
                    clearInterval(this._checkUrlInterval);
                }
                /** @type {boolean} */
                History.started = false;
            },
            /**
             * @param {(Function|string)} route
             * @param {Function} callback
             * @return {undefined}
             */
            route: function (route, callback) {
                this.handlers.unshift({
                    route: route,
                    /** @type {Function} */
                    callback: callback
                });
            },
            /**
             * @param {string} current
             * @return {?}
             */
            checkUrl: function (current) {
                current = this.getFragment();
                if (current === this.fragment) {
                    if (this.iframe) {
                        current = this.getHash(this.iframe.contentWindow);
                    }
                }
                if (current === this.fragment) {
                    return false;
                }
                if (this.iframe) {
                    this.navigate(current);
                }
                this.loadUrl();
            },
            /**
             * @param {(number|string)} fragment
             * @return {?}
             */
            loadUrl: function (fragment) {
                if (!this.matchRoot()) {
                    return false;
                }
                fragment = this.fragment = this.getFragment(fragment);
                return _.some(this.handlers, function (handler) {
                    if (handler.route.test(fragment)) {
                        return handler.callback(fragment), true;
                    }
                });
            },
            /**
             * @param {string} fragment
             * @param {Object} options
             * @return {?}
             */
            navigate: function (fragment, options) {
                if (!History.started) {
                    return false;
                }
                if (!(options && true !== options)) {
                    options = {
                        trigger: !!options
                    };
                }
                fragment = this.getFragment(fragment || "");
                var context = this.root;
                if ("" === fragment || "?" === fragment.charAt(0)) {
                    context = context.slice(0, -1) || "/";
                }
                context += fragment;
                fragment = this.decodeFragment(fragment.replace(pathStripper, ""));
                if (this.fragment !== fragment) {
                    /** @type {string} */
                    this.fragment = fragment;
                    if (this._usePushState) {
                        this.history[options.replace ? "replaceState" : "pushState"]({}, document.title, context);
                    } else {
                        if (this._wantsHashChange) {
                            this._updateHash(this.location, fragment, options.replace);
                            if (this.iframe) {
                                if (fragment !== this.getHash(this.iframe.contentWindow)) {
                                    context = this.iframe.contentWindow;
                                    if (!options.replace) {
                                        context.document.open();
                                        context.document.close();
                                    }
                                    this._updateHash(context.location, fragment, options.replace);
                                }
                            }
                        } else {
                            return this.location.assign(context);
                        }
                    }
                    if (options.trigger) {
                        return this.loadUrl(fragment);
                    }
                }
            },
            /**
             * @param {string} location
             * @param {string} fragment
             * @param {(number|string)} href
             * @return {undefined}
             */
            _updateHash: function (location, fragment, href) {
                if (href) {
                    href = location.href.replace(/(javascript:|#).*$/, "");
                    location.replace(href + "#" + fragment);
                } else {
                    /** @type {string} */
                    location.hash = "#" + fragment;
                }
            }
        });
        Backbone.history = new History;
        /** @type {function (?, Object): ?} */
        Model.extend = Router.extend = EA.extend = Collection.extend = History.extend = function (opt_attributes, staticProps) {
            var parent = this;
            var child = opt_attributes && _.has(opt_attributes, "constructor") ? opt_attributes.constructor : function () {
                return parent.apply(this, arguments);
            };
            _.extend(child, parent, staticProps);
            child.prototype = _.create(parent.prototype, opt_attributes);
            child.prototype.constructor = child;
            child.__super__ = parent.prototype;
            return child;
        };
        /**
         * @return {?}
         */
        var urlError = function () {
            throw Error('A "url" property or function must be specified');
        };
        /**
         * @param {?} model
         * @param {Object} options
         * @return {undefined}
         */
        var wrapError = function (model, options) {
            /** @type {function (string): undefined} */
            var callback = options.error;
            /**
             * @param {string} xhr
             * @return {undefined}
             */
            options.error = function (xhr) {
                if (callback) {
                    callback.call(options.context, model, xhr, options);
                }
                model.trigger("error", model, xhr, options);
            };
        };
        return Backbone;
    });
    var _ = self._.noConflict();
    var Backbone = self.Backbone.noConflict();
    var $ = jQuery;
    var options = {};
    options.core = options.core || {};
    /** @type {boolean} */
    options.core.LOGGING_ENABLED = true;
    /**
     * @return {undefined}
     */
    options.core.log = function () {
        if (options.core.LOGGING_ENABLED && ("undefined" !== typeof console && (!_.isNull(console) && "function" === typeof console.log))) {
            /** @type {Array} */
            var applyArgs = ["[Klaviyo / Onsite]"].concat([].slice.call(arguments));
            console.log.apply(console, applyArgs);
        }
    };
    /**
     * @param {string} queryString
     * @return {?}
     */
    options.core.parseQueryString = function (queryString) {
        var args = {};
        /** @type {RegExp} */
        var r20 = /\+/g;
        /** @type {RegExp} */
        var re = /([^&=]+)=?([^&]*)/g;
        var m;
        for (; m = re.exec(queryString);) {
            /** @type {string} */
            args[decodeURIComponent(m[1].replace(r20, " "))] = decodeURIComponent(m[2].replace(r20, " "));
        }
        return args;
    };
    /**
     * @param {?} cssText
     * @return {undefined}
     */
    options.core.insertCSS = function (cssText) {
        /** @type {Element} */
        var st = document.createElement("style");
        $("head").get(0).appendChild(st);
        if (st.styleSheet) {
            st.styleSheet.cssText = cssText;
        } else {
            st.appendChild(document.createTextNode(cssText));
        }
    };
    /**
     * @param {string} name
     * @return {?}
     */
    options.core.getCookie = function (name) {
        return (name = document.cookie.match(new RegExp(name + "=([^;]+)"))) ? name[1] : null;
    };
    options.core.templates = {
        _cache: {},
        /**
         * @param {?} path
         * @param {string} data
         * @return {undefined}
         */
        register: function (path, data) {
            this._cache[path] = _.template(data);
        },
        /**
         * @param {string} name
         * @param {Object} context
         * @return {?}
         */
        render: function (name, context) {
            return this._cache[name](context || {});
        }
    };
    options.platforms = options.platforms || {};
    options.platforms.shopify = options.platforms.shopify || {};
    /** @type {string} */
    options.platforms.shopify.ADD_TO_CART_FORM_ID = 'form[action$="/cart/add"]';
    /** @type {string} */
    options.platforms.shopify.ADD_TO_CART_BUTTON_ID = options.platforms.shopify.ADD_TO_CART_FORM_ID + ' button[type="submit"]';
    /**
     * @param {string} optionsString
     * @return {?}
     */
    options.platforms.shopify.isProductPage = function (optionsString) {
        if (!optionsString) {
            /** @type {string} */
            optionsString = self.location.toString();
        }
        return !!optionsString.match(/\/products\//);
    };
    /**
     * @param {string} value
     * @param {?} obj
     * @return {?}
     */
    options.platforms.shopify.isCollectionsPage = function (value, obj) {
        if (!value) {
            /** @type {string} */
            value = self.location.toString();
        }
        if (Array.isArray(obj) && 0 < obj.length) {
            /** @type {number} */
            var i = 0;
            for (; i < obj.length; i++) {
                if (value.match(obj[i])) {
                    return true;
                }
            }
            return !!value.match(/\/collections\//);
        }
    };
    /**
     * @param {Element} resp
     * @param {Object} a
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.shopify.isVariantOutOfStock = function (resp, a, reversed) {
    // 检查变体元字段中的预售标记
    // console.log(resp);
    if (resp.tags.includes("Pre-order")) {
        return true; // 视为缺货
    }
        return options.platforms.shopify.isVariantOutOfInventory(a, reversed) && (options.platforms.shopify.isVariantUnavailableBasedOnInventoryManagementPolicy(a, reversed) && (options.platforms.shopify.isVariantUnavailableBasedOnPreorderPolicy(a, reversed) && (options.platforms.shopify.isVariantUnavailableBasedOnSellThroughPolicy(a, reversed) && options.platforms.shopify.isVariantIncludedBasedOnTags(resp, reversed.include_on_tags, reversed.exclude_on_tags))));
    };
    /**
     * @param {Object} result
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.shopify.isVariantOutOfInventory = function (result, reversed) {
        return _.isNull(result.inventory_quantity) || _.isUndefined(result.inventory_quantity) ? !result.available : result.inventory_quantity < reversed.inventory_quantity_threshold;
    };
    /**
     * @param {Object} v02
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.shopify.isVariantUnavailableBasedOnInventoryManagementPolicy = function (v02, reversed) {
        return reversed.is_allow_for_unmanaged_inventory ? true : !!v02.inventory_management;
    };
    /**
     * @param {Object} o
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.shopify.isVariantUnavailableBasedOnPreorderPolicy = function (o, reversed) {
        return reversed.is_allow_for_preorder ? true : !o.available;
    };
    /**
     * @param {Object} v02
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.shopify.isVariantUnavailableBasedOnSellThroughPolicy = function (v02, reversed) {
        return reversed.display_on_policy_continue || "continue" != v02.inventory_policy ? true : false;
    };
    /**
     * @param {Element} a
     * @param {Array} second
     * @param {Array} attributes
     * @return {?}
     */
    options.platforms.shopify.isVariantIncludedBasedOnTags = function (a, second, attributes) {
        return attributes.length && (a.tags.length && _.intersection(a.tags, attributes).length) || second.length && (!_.intersection(a.tags, second).length || !a.tags.length) ? false : true;
    };
    /**
     * @return {?}
     */
    options.platforms.shopify.findSelectedVariantId = function () {
        /** @type {string} */
        var queryString = self.location.search.substring(1);
        return (queryString = options.core.parseQueryString(queryString).variant) ? queryString : $('[name="id"]').val();
    };
    /**
     * @param {string} v
     * @return {?}
     */
    options.platforms.shopify.isValidVariant = function (v) {
        return "number" != typeof parseInt(v) ? false : true;
    };
    /**
     * @param {?} object
     * @return {?}
     */
    options.platforms.shopify.productDetailsUrl = function (object) {
        return _.isUndefined(object.product_handle) ? "//" + (self.location.hostname.toString() + self.location.pathname.toString().replace(/\/$/, "")) + ".js" : "//" + self.location.hostname.toString() + "/products/" + object.product_handle + ".js";
    };
    /**
     * @param {string} v11
     * @return {?}
     */
    options.platforms.shopify.format_product_json = function (v11) {
        return v11;
    };
    options.platforms.bigcommerce = options.platforms.bigcommerce || {};
    /** @type {string} */
    options.platforms.bigcommerce.ADD_TO_CART_FORM_ID = 'form[action$="//' + self.location.hostname + '/cart.php"]';
    /** @type {string} */
    options.platforms.bigcommerce.ADD_TO_CART_BUTTON_ID = options.platforms.bigcommerce.ADD_TO_CART_FORM_ID + ' input[type="submit"]';
    /** @type {Array} */
    options.platforms.bigcommerce.INVENTORY_TRACKING_TYPES = ["simple", "product", "variant", "sku"];
    /** @type {string} */
    options.platforms.bigcommerce.OPTION_NAME_ELEMENT = 'input[name^="attribute"]';
    /** @type {string} */
    options.platforms.bigcommerce.DROPDOWN_NAME_ELEMENT = 'select[name^="attribute"] option';
    /** @type {string} */
    options.platforms.bigcommerce.PRODUCT_ID_ELEMENT = 'input[name="product_id"]';
    /**
     * @param {?} dataAndEvents
     * @return {?}
     */
    options.platforms.bigcommerce.isProductPage = function (dataAndEvents) {
        try {
            return page_type = document.querySelector("meta[property='og:type']").getAttribute("content"), "product" == page_type;
        } catch (e) {
            return false;
        }
    };
    /**
     * @param {Array} recurring
     * @param {?} dataAndEvents
     * @return {?}
     */
    options.platforms.bigcommerce.isCollectionsPage = function (recurring, dataAndEvents) {
        return false;
    };
    /**
     * @param {Element} b
     * @param {Object} a
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.bigcommerce.isVariantOutOfStock = function (b, a, reversed) {
        return options.platforms.bigcommerce.isVariantTrackableBasedOnInventoryManagementPolicy(b) && (options.platforms.bigcommerce.isVariantOutOfInventory(a, reversed) && (options.platforms.bigcommerce.isVariantAvailable(a, reversed) && options.platforms.bigcommerce.isVariantIncludedBasedOnTags(b, reversed.include_on_tags, reversed.exclude_on_tags)));
    };
    /**
     * @param {Object} result
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.bigcommerce.isVariantOutOfInventory = function (result, reversed) {
        return _.isNull(result.inventory_quantity) || _.isUndefined(result.inventory_quantity) ? !result.available : result.inventory_quantity < reversed.inventory_quantity_threshold;
    };
    /**
     * @param {Element} v12
     * @return {?}
     */
    options.platforms.bigcommerce.isVariantTrackableBasedOnInventoryManagementPolicy = function (v12) {
        return options.platforms.bigcommerce.INVENTORY_TRACKING_TYPES.includes(v12.inventory_policy);
    };
    /**
     * @param {Object} o
     * @param {?} reversed
     * @return {?}
     */
    options.platforms.bigcommerce.isVariantAvailable = function (o, reversed) {
        return o.available;
    };
    /**
     * @param {Element} a
     * @param {Array} second
     * @param {Array} attributes
     * @return {?}
     */
    options.platforms.bigcommerce.isVariantIncludedBasedOnTags = function (a, second, attributes) {
        return attributes.length && (a.tags.length && _.intersection(a.tags, attributes).length) || second.length && (!_.intersection(a.tags, second).length || !a.tags.length) ? false : true;
    };
    /**
     * @return {?}
     */
    options.platforms.bigcommerce.findSelectedVariantId = function () {
        /** @type {Array} */
        var tagNameArr = [];
        var elems = _.map([options.platforms.bigcommerce.ADD_TO_CART_FORM_ID + " " + options.platforms.bigcommerce.OPTION_NAME_ELEMENT, options.platforms.bigcommerce.ADD_TO_CART_FORM_ID + " " + options.platforms.bigcommerce.DROPDOWN_NAME_ELEMENT], function (dataAndEvents) {
            return dataAndEvents + ":checked";
        }).join();
        elems = $(elems);
        /** @type {null} */
        options.platforms.bigcommerce.selected_variant_id = null;
        if (!_.isEmpty(elems)) {
            return _.each(elems, function (element, dataAndEvents) {
                element = $(element);
                if (element.is("option")) {
                    tagNameArr.push(element.parent().attr("name") + "=" + element.val());
                } else {
                    tagNameArr.push(element.attr("name") + "=" + element.val());
                }
            }), product_id = options.platforms.bigcommerce.productId(), variant_option_url = "//" + self.location.hostname + "/remote/v1/product-attributes/" + product_id, parameters = "action=add&qty[]=1&product_id=" + product_id + "&" + tagNameArr.join("&"), parameters = encodeURI(parameters), csrf_token = options.core.getCookie("SF-CSRF-TOKEN"), $.ajax({
                url: variant_option_url,
                type: "POST",
                headers: {
                    "x-sf-csrf-token": csrf_token ? csrf_token : ""
                },
                dataType: "json",
                data: parameters,
                /**
                 * @param {Event} status
                 * @return {undefined}
                 */
                success: function (status) {
                    try {
                        if (status.data.purchasable) {
                            options.platforms.bigcommerce.selected_variant_id = status.data.v3_variant_id;
                        }
                    } catch (p) {
                    }
                }
            }), null;
        }
    };
    /**
     * @param {string} attr
     * @return {?}
     */
    options.platforms.bigcommerce.isValidVariant = function (attr) {
        return true;
    };
    /**
     * @return {?}
     */
    options.platforms.bigcommerce.productId = function () {
        /** @type {string} */
        product_id_element = options.platforms.bigcommerce.ADD_TO_CART_FORM_ID + " " + options.platforms.bigcommerce.PRODUCT_ID_ELEMENT;
        return $(product_id_element).val();
    };
    /**
     * @param {?} object
     * @return {?}
     */
    options.platforms.bigcommerce.productDetailsUrl = function (object) {
        product_id = options.platforms.bigcommerce.productId();
        return "https://fast.a.klaviyo.com/api/v1/catalog/bigcommerce/product-variants?a=" + object.account_id + "&p=" + product_id;
    };
    /**
     * @param {string} item
     * @return {?}
     */
    options.platforms.bigcommerce.format_product_json = function (item) {
        item = item.data;

        var self = {
            id: item.product_id,
            title: item.product_title,
            inventory_policy: item.inventory_tracking,
            variants: []
        };
        _.each(item.variants, function (item, dataAndEvents) {
            variant_title = _.isEmpty(item.title) ? item.sku : item.title;
            self.variants.push({
                id: item.external_id,
                title: variant_title,
                available: item.availability,
                inventory_quantity: item.inventory_quantity,
                is_allow_for_preorder: item.availability
            });
        });
        return self;
    };
    options.components = options.components || {};
    options.components.back_in_stock = options.components.back_in_stock || {};
    /** @type {string} */
    options.components.back_in_stock.BASE_CSS = 'body, html { background: transparent;-webkit-font-smoothing: antialiased;height: 100%;}html {font-family: sans-serif;font-size: 14px;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);}body {margin: 0;font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;font-size: 14px;line-height: 1.5;color: #222;overflow: hidden;-moz-transition: background-color 0.15s linear;-webkit-transition: background-color 0.15s linear;-o-transition: background-color 0.15s linear;transition: background-color 0.15s cubic-bezier(0.785, 0.135, 0.150, 0.860);}body.fadein {background: rgba(0, 0, 0, 0.65);}a {background-color: transparent;}a:active,a:hover {outline: 0;}h1 {font-size: 2em;margin: 0.67em 0;}h3 { font-size: 24px;}h4 {  font-size: 18px;  margin-top: 10px;  margin-bottom: 10px;}h3, h4 {  font-family: inherit;  font-weight: 500;  line-height: 1.1;  color: inherit;}button,input,optgroup,select,textarea {color: inherit;font: inherit;margin: 0;font-family: inherit;font-size: inherit;line-height: inherit;}button {overflow: visible;}button,select {text-transform: none;}button {-webkit-appearance: button;cursor: pointer;}button[disabled] {opacity: 0.6;}button::-moz-focus-inner,input::-moz-focus-inner {border: 0;padding: 0;}input {line-height: normal;}input[type="number"]::-webkit-inner-spin-button,input[type="number"]::-webkit-outer-spin-button {height: auto;}* {-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;}*:before,*:after {-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;}#container {position: relative;background: white;padding: 12px 18px 40px 18px;}.fade {opacity: 0;-webkit-transition: opacity 0.15s linear;-o-transition: opacity 0.15s linear;transition: opacity 0.15s linear;}.fade.in {opacity: 1;}.modal {  overflow-x: hidden;  overflow-y: auto;  position: fixed;  top: 0;  right: 0;  bottom: 0;  left: 0;  z-index: 999;  -webkit-overflow-scrolling: touch;  outline: 0;}.modal-title {  margin: 0;  font-size: 24px;  line-height: 1.5;}.clearfix:before,.clearfix:after {  content: " ";  display: table;}.clearfix:after {  clear: both;}.form-control {  display: block;  width: 100%;  height: 34px;  padding: 6px 12px;  font-size: 14px;  line-height: 1.5;  color: #222;  background-color: #fff;  background-image: none;  border: 1px solid #ccc;  border-radius: 2px;  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;}.input-lg {  font-size: 14px;  height: 46px;  padding: 10px 16px;  line-height: 1.3333333;}.submit-container {  margin-top: 20px;}.form-group {  margin-bottom: 15px;}.btn {  display: inline-block;  padding: 8px 12px;  margin-bottom: 0;  font-size: 14px;  font-weight: bold;  line-height: 1.5;  text-align: center;  white-space: nowrap;  vertical-align: middle;  -ms-touch-action: manipulation;  touch-action: manipulation;  cursor: pointer;  -webkit-user-select: none;  -moz-user-select: none;  -ms-user-select: none;  user-select: none;  background-image: none;  border: 1px solid transparent;  border-radius: 2px;}.btn-success {  width: 100%;  color: #fff;  background-color: #439fdb;  border-color: #439fdb;}.btn-lg {  line-height: 24px;  font-size: 15px;  padding: 14px;  line-height: 1.3333333;}.close {  -webkit-appearance: none;  padding: 0;  cursor: pointer;  background: 0 0;  border: 0;  position: absolute;  top: 7px;  right: 15px;  font-size: 30px;  font-weight: 700;  line-height: 1;  color: #ccc;  text-shadow: 0 1px 0 #fff;}.alert {  padding: 6px 11px;  font-size: 13px;  margin: 15px 0;  border: 1px solid transparent;  border-radius: 2px;}.alert-success {  color: #1B9500;  background-color: #d3efcd;  border-color: #d3efcd;}.alert-success a {   color: #1B9500;}.alert-danger {  color: #C72E2F;  background-color: #fcd6d7;  border-color: #fcd6d7;}.pull-right {  float: right;}.text-right {  text-align: right;}.small-print {  font-size: 14px;  line-height: 1.5;}.small-print a {  color: inherit;  text-decoration: underline;}.powered-by {  opacity: 0.8;}.product-title {  margin-bottom: 20px;}.accepts_marketing {  opacity: 0.835;  font-size: 13px;}.accepts_marketing input {  margin-right: 10px;}.completed_message, .error_message {  display: none;}.complete .completed_message {  display: block;}#klaviyo-bis-modal.in {  position: relative;  z-index: 999;  height: 100%;  overflow: hidden;  overflow-y: auto;  -webkit-overflow-scrolling: touch;}@media only screen and (min-width:500px) {  #klaviyo-bis-modal {    max-width: 460px;    margin: auto;  }  #container {    border-radius: 3px;    padding: 30px 40px;  }}@media only screen and (min-width:992px) {  #container {    margin-top: 100px;  }}';
    options.components = options.components || {};
    options.components.back_in_stock = options.components.back_in_stock || {};
    options.components.back_in_stock.DEFAULT_SETTINGS = {
        trigger: {
            replace_sold_out: false,
            replace_anchor: false,
            alternate_anchor: null,
            product_page_text: "Notify Me When Available",
            product_page_class: "btn",
            product_page_text_align: "center",
            product_page_margin: "0px",
            product_page_width: "auto",
            collection_page_class: "btn",
            collection_page_text_align: "center",
            collection_page_width: "200px",
            collection_page_text: "Notify Me When Available",
            collection_page_padding: "inherit"
        },
        modal: {
            headline: "{product_name}",
            body_content: "Enter your email address and we'll let you know when it's back.",
            email_field_label: "Email",
            is_quantity_field_enabled: false,
            quantity_field_label: "Quantity Required",
            button_label: "Notify me when available",
            newsletter_subscribe_label: "Add me to your email list.",
            subscription_success_label: "You're in! We'll let you know when it's back.",
            footer_content: "",
            close_label: "Close",
            is_powered_by_link: false,
            styles: options.components.back_in_stock.BASE_CSS,
            additional_styles: "",
            z_index: 999999,
            drop_background_color: "#000",
            background_color: "#fff",
            font_family: '"Helvetica Neue", Helvetica, Arial, sans-serif;',
            headers_font_family: '"Helvetica Neue", Helvetica, Arial, sans-serif;',
            text_color: "#222",
            button_text_color: "#fff",
            button_background_color: "#439fdb",
            close_button_color: "#ccc",
            error_background_color: "#fcd6d7",
            error_text_color: "#C72E2F",
            success_background_color: "#d3efcd",
            success_text_color: "#1B9500",
            subscribe_checked: true
        }
    };
    options.components.back_in_stock.Settings = Backbone.Model.extend({
        defaults: {
            exclude_on_tags: "",
            include_on_tags: "",
            display_on_policy_continue: false,
            inventory_quantity_threshold: 1,
            is_allow_for_preorder: true,
            is_allow_for_unmanaged_inventory: true,
            variant_id_element: null,
            variant_id_attribute: null
        }
    });
    options.components.back_in_stock.Main = Backbone.Model.extend();
    options.components.back_in_stock.MainView = Backbone.View.extend({
        events: {
            change: "variantChange",
            "click .klaviyo-bis-trigger": "handleBISTriggerClick"
        },
        /**
         * @return {?}
         */
        settings: function () {
            return this.model.get("settings");
        },
        /**
         * @param {Text} index
         * @return {undefined}
         */
        initialize: function (index) {
            index = this.settings().get("platform");
            var password = this.settings().get("is_quick_view");
            this.platform_implementation = options.platforms[index];
            this.model.set("is_quick_view", password);
            this.model.set("collection_urls", this.settings().get("collection_urls"));
            if (this.platform_implementation.isProductPage()) {
                this.model.set("is_on_collections_page", false);
                this.createProductPageTrigger();
            } else {
                if (this.platform_implementation.isCollectionsPage(null, this.model.get("collection_urls"))) {
                    this.model.set("is_on_collections_page", true);
                    this.createCollectionPageTriggers();
                } else {
                    this.model.set("is_on_other_page", true);
                    return;
                }
            }
            this.model.set("is_on_other_page", false);
        },
        /**
         * @param {Event} callback
         * @param {Function} $sanitize
         * @return {undefined}
         */
        getProductJSON: function (callback, $sanitize) {
            var self = this;
            $.getJSON(callback, function (y, which, dataAndEvents) {
                y = self.platform_implementation.format_product_json(y);
                which = y.variants;
                /** @type {Array} */
                var result = [];
                var data = {};
                var obj = {};
                self.model.set("product", y);
                _.each(which, function (model, dataAndEvents) {
                    if (self.isVariantOutOfStock(model)) {
                        result.push(model);
                    }
                    /** @type {Element} */
                    data[model.id] = model;
                    /** @type {Element} */
                    obj[model.title] = model;
                });
                self.model.set({
                    variants: which,
                    unavailable_variants: result,
                    variants_by_id: data,
                    variants_by_title: obj
                });
                options.core.log("Variants: ", which.length, "Unavailable Variants: ", result.length);
                $sanitize();
            });
        },
        /**
         * @return {undefined}
         */
        createProductPageTrigger: function () {
            var self = this;
            var onComplete = self.$(".klaviyo-bis-trigger");
            var which = {
                account_id: self.settings().get("account")
            };
            which = self.platform_implementation.productDetailsUrl(which);
            self.getProductJSON(which, function () {
                if (self.model.get("unavailable_variants").length) {
                    self.prepareTriggerElement(onComplete);
                    if (!onComplete.length) {
                        self.trigger.renderProductPageTrigger();

                        ///cccc change render buttom under the price div ss
                        var $priceDiv = self.$('div[data-block-id="price"]').eq(0);
                        if ($priceDiv.length) {
                            $priceDiv.after(self.trigger.$el);
                        } else {
                            self.$(self.platform_implementation.ADD_TO_CART_FORM_ID).eq(0).append(self.trigger.$el);
                        }
                      ///cccc change render buttom under the price div ee
                        // var $el = $(self.platform_implementation.ADD_TO_CART_BUTTON_ID).eq(0);
                        // var comment = self.trigger.model.get("alternate_anchor");
                        // /** @type {string} */
                        // var html = "#" + comment;
                        // if (!_.isNull(comment) && $(html).length) {
                        //     $el = $(html).eq(0);
                        //     $el.append(self.trigger.$el);
                        //     self.sold_out_button = $el;
                        // } else {
                        //     if (true !== self.trigger.model.get("replace_anchor") && true !== self.trigger.model.get("replace_sold_out") || !$el.length) {
                        //         self.$(self.platform_implementation.ADD_TO_CART_FORM_ID).eq(0).append(self.trigger.$el);
                        //     } else {
                        //         self.sold_out_button = $el;
                        //         self.sold_out_button.parent().append(self.trigger.$el);
                        //     }
                        // }
                    }
                    self.createModal();
                    self.variantChange();
                }
            });
        },
        /**
         * @return {undefined}
         */
        createCollectionPageTriggers: function () {
            var module = this;
            var list = this.$(".klaviyo-bis-trigger");
            var which = this.$(".klaviyo-product-container");
            if (which.length) {
                module.prepareTriggerElement(list);
                if (!list.length) {
                    module.trigger.prepareCollectionPageHelpers();
                    module.trigger.renderCollectionPageTrigger();
                    _.each(which, function (i) {
                        i = $(i).data("klaviyo-handle");
                        var html = module.trigger.$el.clone();
                        var output = $('.klaviyo-product-container[data-klaviyo-handle="' + i + '"] .klaviyo-button-container');
                        var $cont = output.parent().parent();
                        html.data("klaviyo-handle", i);
                        output.append(html);
                        if ("static" == $cont.css("position")) {
                            $cont.css("position", "relative");
                        }
                    });
                    module.createModal();
                }
            }
        },
        /**
         * @param {string} el
         * @return {undefined}
         */
        prepareTriggerElement: function (el) {
            var _self = this.settings();
            var data = {};
            _.defaults(data, _self.get("trigger"), options.components.back_in_stock.DEFAULT_SETTINGS.trigger);
            this.trigger = el.length ? new options.components.back_in_stock.TriggerView({
                el: el,
                model: new options.components.back_in_stock.Trigger(data)
            }) : new options.components.back_in_stock.TriggerView({
                el: $("<a/>"),
                model: new options.components.back_in_stock.Trigger(data)
            });
        },
        /**
         * @return {undefined}
         */
        createModal: function () {
            var Ext = this.settings();
            var attributes = {};
            parent_body_font_family = $("body").css("font-family");
            parent_body_font_color = $("body").css("color");
            parent_headers_font_family = $("h1,h2,h3").eq(0).css("font-family");
            parent_button = $(".klaviyo-bis-trigger").eq(0);
            parent_button_text_color = parent_button.css("color");
            parent_button_background_color = parent_button.css("background-color");
            if (!_.isUndefined(parent_body_font_family)) {
                options.components.back_in_stock.DEFAULT_SETTINGS.modal.font_family = parent_body_font_family;
            }
            if (!_.isUndefined(parent_body_font_color)) {
                options.components.back_in_stock.DEFAULT_SETTINGS.modal.text_color = parent_body_font_color;
            }
            if (!_.isUndefined(parent_headers_font_family)) {
                options.components.back_in_stock.DEFAULT_SETTINGS.modal.headers_font_family = parent_headers_font_family;
            }
            if (!_.isUndefined(parent_button_text_color)) {
                options.components.back_in_stock.DEFAULT_SETTINGS.modal.button_text_color = parent_button_text_color;
            }
            if (!_.isUndefined(parent_button_background_color)) {
                options.components.back_in_stock.DEFAULT_SETTINGS.modal.button_background_color = parent_button_background_color;
            }
            _.defaults(attributes, Ext.get("modal"), options.components.back_in_stock.DEFAULT_SETTINGS.modal);
            _.extend(attributes, {
                account: Ext.get("account"),
                list: Ext.get("list"),
                platform: Ext.get("platform"),
                api_hostname: Ext.get("api_hostname"),
                is_quick_view: Ext.get("is_quick_view"),
                collection_urls: Ext.get("collection_urls")
            });
            this.modal = new options.components.back_in_stock.ModalView({
                el: $("<iframe />"),
                model: new options.components.back_in_stock.Modal(attributes)
            });
            this.modal.render();
            this.$el.append(this.modal.$el);
        },
        /**
         * @param {string} v
         * @return {undefined}
         */
        variantChange: function (v) {
            if (!this.model.get("is_on_other_page") && (!this.model.get("is_on_collections_page") && this.trigger instanceof Backbone.View)) {
                v = 1 == this.model.get("variants").length ? this.model.get("variants")[0].id : this.platform_implementation.findSelectedVariantId();
                if (!this.platform_implementation.isValidVariant(v)) {
                    var a = this.settings();
                    var sel = a.get("variant_id_element");
                    a = a.get("variant_id_attribute");
                    if (sel) {
                        if (a) {
                            v = $(document).find(sel).attr(a);
                        }
                    }
                }
                if (_.isNull(v)) {
                    var selected_variant_id = this;
                    /** @type {number} */
                    i = 0;
                    for (; 3 > i; i++) {
                        _.delay(function () {
                            return selected_variant_id.setVariantAndShowUI(selected_variant_id.platform_implementation.selected_variant_id);
                        }, 1E3);
                    }
                } else {
                    this.setVariantAndShowUI(v);
                }
            }
        },
        /**
         * @param {string} size
         * @return {undefined}
         */
        setVariantAndShowUI: function (size) {
            nicetri = this;
            if (_.isUndefined(size) || _.isNull(size)) {
                console.log(-1);
                this.trigger.hide();
                if (!_.isUndefined(this.sold_out_button)) {
                    this.sold_out_button.show();
                }
            } else {
                this.model.get("product");
                var attributes = this.model.get("variants_by_id")[size] || this.model.get("variants")[0];
                if (!size || isNaN(size)) {
                    size = attributes && attributes.id;
                }
                options.core.log("Selected Variant: " + size);
                this.model.set("selected_variant_id", size);
                this.modal.setSelectedVariantId(size);
                console.log(0);
                if (!attributes) {
                    console.log(1);
                    this.trigger.hide();
                }
                if (this.isVariantOutOfStock(attributes)) {
                    if (!_.isUndefined(this.sold_out_button)) {
                        console.log(1.2);

                        if (!(!this.trigger.model.get("replace_anchor") && !this.trigger.model.get("replace_sold_out"))) {
                            this.sold_out_button.hide();
                            console.log(2);
                          
                        }
                    }
                    this.trigger.show();
                } else {
                    this.trigger.hide();
                    console.log(3);
                    if (!_.isUndefined(this.sold_out_button)) {
                        this.sold_out_button.show();
                    }
                }
            }
        },
        /**
         * @param {Object} resp
         * @return {?}
         */
        isVariantOutOfStock: function (resp) {
            var reversed = this.settings();
            reversed = {
                inventory_quantity_threshold: reversed.get("inventory_quantity_threshold"),
                is_allow_for_preorder: reversed.get("is_allow_for_preorder"),
                is_allow_for_unmanaged_inventory: reversed.get("is_allow_for_unmanaged_inventory"),
                display_on_policy_continue: reversed.get("display_on_policy_continue"),
                exclude_on_tags: this.cleanTags(reversed.get("exclude_on_tags")),
                include_on_tags: this.cleanTags(reversed.get("include_on_tags")),
                is_quick_view: reversed.get("is_quick_view"),
                collection_urls: reversed.get("collection_urls")
            };
            return this.platform_implementation.isVariantOutOfStock(this.model.get("product"), resp, reversed);
        },
        /**
         * @param {string} pair
         * @return {?}
         */
        cleanTags: function (pair) {
            try {
                var mod = pair.split(",").filter(String);
            } catch (h) {
                console.log("Tags not read because invalid format.  Please supply strings for included and excluded tags. If there are multiple values, please delimit with commas.");
                /** @type {Array} */
                mod = [];
            }
            return mod.map(function (buf) {
                return buf.trim();
            });
        },
        /**
         * @param {Event} event
         * @return {undefined}
         */
        handleBISTriggerClick: function (event) {
            if (event) {
                if (event.preventDefault()) {
                    event.stopPropagation();
                }
            }
            var module = this;
            if (this.model.get("is_on_collections_page")) {
                var product_handle = $(event.currentTarget).data("klaviyo-handle");
                var source = $($(event.currentTarget).data("klaviyo-quickview-variant")).val();
                event = module.platform_implementation.productDetailsUrl({
                    product_handle: product_handle
                });
                var is_quick_view = this.model.get("is_quick_view");
                module.getProductJSON(event, function () {
                    if (!_.isUndefined(source) && _.isUndefined(this.modal) || is_quick_view) {
                        module.createModal();
                    }
                    module.showModal(source);
                });
            } else {
                module.showModal();
            }
        },
        /**
         * @param {string} id
         * @return {undefined}
         */
        showModal: function (id) {
            var pdataCur = this.model.get("product");
            id = this.model.get("selected_variant_id") || (id || this.model.get("unavailable_variants")[0].id);
            id = this.model.get("variants_by_id")[id];
            var firstLength = this.model.get("variants").length;
            var taskComplete = this.model.get("unavailable_variants");
            this.modal.renderForm(pdataCur, id, firstLength, taskComplete);
            this.modal.show();
        }
    });
    /**
     * @param {Object} obj
     * @param {string} attributes
     * @return {?}
     */
    options.components.back_in_stock.create = function (obj, attributes) {
        obj = new options.components.back_in_stock.Settings(obj);
        obj.set(attributes);
        return new options.components.back_in_stock.MainView({
            el: document.body,
            model: new options.components.back_in_stock.Main({
                settings: obj
            })
        });
    };
    options.components = options.components || {};
    options.components.back_in_stock = options.components.back_in_stock || {};
    options.components.back_in_stock.Trigger = Backbone.Model.extend({});
    options.components.back_in_stock.TriggerView = Backbone.View.extend({
        /**
         * @param {?} contentHTML
         * @return {undefined}
         */
        initialize: function (contentHTML) {
        },
        /**
         * @return {undefined}
         */
        prepareCollectionPageHelpers: function () {
            var el = $(".klaviyo-product-container");
            var sel = $(".klaviyo-button-container");
            var style = {
                display: "inline-block",
                position: "absolute !important",
                top: "50%",
                left: "50%",
                opacity: "0",
                "text-align": this.model.get("collection_page_text_align"),
                width: this.model.get("collection_page_width")
            };
            klaviyo_button_width = style.width.match(/\d+/);
            /** @type {string} */
            style["margin-left"] = "-" + Math.round(klaviyo_button_width / 2) + "px";
            el.css({
                overflow: "visible !important",
                position: "initial !important"
            });
            sel.css(style);
            el.parent().mouseover(function () {
                $(this).find(sel).css("opacity", "1");
            }).mouseout(function () {
                $(this).find(sel).css("opacity", "0");
            });
        },
        /**
         * @return {undefined}
         */
        renderCollectionPageTrigger: function () {
            var model = this.model;
            this.$el.attr("class", model.get("collection_page_class")).addClass("klaviyo-bis-trigger").attr("href", "#").text(model.get("collection_page_text")).css("padding", model.get("collection_page_padding")).css("text-align", model.get("collection_page_text_align"));
        },
        /**
         * @return {undefined}
         */
        renderProductPageTrigger: function () {
            var model = this.model;
            this.$el.attr("class", model.get("product_page_class")).addClass("klaviyo-bis-trigger").attr("href", "#").text(model.get("product_page_text")).css("text-align", model.get("product_page_text_align")).css("margin", model.get("product_page_margin")).css("width", model.get("product_page_width"));
        },
        /**
         * @return {undefined}
         */
        show: function () {
            this.$el.show();
        },
        /**
         * @return {undefined}
         */
        hide: function () {
            this.$el.hide();
        }
    });
    options.components = options.components || {};
    options.components.back_in_stock = options.components.back_in_stock || {};
    _.each({
        "back_in_stock_document.html": '<!doctype html>\x3c!--[if lt IE 7]> <html class="ie6"> <![endif]--\x3e\x3c!--[if IE 7]> <html class="ie7"> <![endif]--\x3e\x3c!--[if IE 8]> <html class="ie8"> <![endif]--\x3e\x3c!--[if gt IE 8]>\x3c!--\x3e <html> \x3c!--<![endif]--\x3e<head><meta name="viewport" content="width=device-width"><style><%= styles %>#container {background: <%= theme.background_color %>;}body {font-family: <%= theme.font_family %>;color: <%= theme.text_color %>;}body.fadein {background: rgba( <%= theme.fade_color_rgb %>, 0.65);}h3 {font-family: <%= theme.headers_font_family %>;}.btn {color: <%= theme.button_text_color %>;background-color: <%= theme.button_background_color %>;border-color: <%= theme.button_background_color %>;}.close {color: <%= theme.close_button_color %>;}.alert-danger {border-color: <%= theme.failure_background_color %>;background-color: <%= theme.failure_background_color %>;color: <%= theme.failure_text_color %>;}.alert-success {background-color: <%= theme.success_background_color %>;border-color: <%= theme.success_background_color %>;color: <%= theme.success_text_color %>;}.alert-success a {color: <%= theme.success_text_color %>;}</style><% if (additional_styles) { %><style><%= additional_styles %></style><% } %></head><body class="klaviyo-bis-close"><div id="klaviyo-bis-modal"><div class="" id="container"><button type="button" class="close klaviyo-bis-close" data-dismiss="modal">&times;</button><h3 class="modal-title"><%= headline %></h3><p><%= body_content %></p><form action="#" class="form-horizontal clearfix"><div class="form-group"><div id="variant_select" class="col-sm-12"><input type="hidden" id="product" value="<%= product.id %>" /></input><select id="variants" class="selectpicker form-control input-lg"><% _.each(unavailable_variants, function (variant) { %><option value="<%= variant.id %>"><%= variant.title %></option><% }) %></select></div></div><div class="form-group"><div class="col-sm-12"><input type="email" id="email" placeholder="<%= email_field_label %>" class="form-control input-lg" value="" /></input></div><div id="newsletter_subscription"><p><input type="checkbox" id="subscribe_for_newsletter" <%= newsletter_subscribe_checked %>><label for="subscribe_for_newsletter" style="margin-left:10px;"><%= newsletter_subscribe_label %></label></p></div></div><div class="control-group clearfix submit-container"><button type="submit" class="btn btn-success btn-lg col-xs-12"><%= button_label %></button></div><div id="error_message" class="error_message alert alert-danger"></div><div id="completed_message" class="completed_message alert alert-success"><%= subscription_success_label %> <a href="#" class="klaviyo-bis-close"><%= close_label %></a></div></form><p class="small-print"><%= footer_content %></p><% if (is_powered_by_link) { %><p class="small-print powered-by text-right">Powered by <a href="https://www.klaviyo.com" target="_blank">Klaviyo</a></p><% } %></div></div>'
    }, function (inplace, path) {
        options.core.templates.register(path, inplace);
    });
    options.components.back_in_stock.Modal = Backbone.Model.extend();
    options.components.back_in_stock.ModalView = Backbone.View.extend({
        /**
         * @param {?} contentHTML
         * @return {undefined}
         */
        initialize: function (contentHTML) {
        },
        /**
         * @return {?}
         */
        iframeDocument: function () {
            var elem = this.$el[0];
            return elem.contentDocument || elem.contentWindow.document;
        },
        /**
         * @param {string} options
         * @return {undefined}
         */
        setSelectedVariantId: function (options) {
            this.model.set("selected_variant_id", options);
        },
        /**
         * @param {string} rows
         * @param {?} delta
         * @return {undefined}
         */
        render: function (rows, delta) {
            this.$el.attr({
                id: "klaviyo-bis-iframe",
                frameBorder: 0,
                src: "about:blank",
                allowTransparency: false
            }).css({
                position: "fixed",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                border: "0",
                overflow: "hidden",
                "z-index": this.model.get("z_index"),
                background: "none"
            }).hide();
        },
        /**
         * @param {Object} data
         * @param {Object} oid
         * @param {(number|string)} length
         * @param {(Object|string)} fn
         * @return {undefined}
         */
        renderForm: function (data, oid, length, fn) {
            var poster = this;
            fn = options.core.templates.render("back_in_stock_document.html", {
                variant: oid,
                product: data,
                unavailable_variants: fn,
                headline: this.model.get("headline").replace("{product_name}", data.title),
                body_content: this.model.get("body_content").replace("{product_name}", data.title),
                email_field_label: this.model.get("email_field_label"),
                email: "",
                newsletter_subscribe_label: this.model.get("newsletter_subscribe_label"),
                newsletter_subscribe_checked: this.model.get("subscribe_checked") ? "checked" : "",
                is_quantity_field_enabled: this.model.get("is_quantity_field_enabled"),
                quantity_required_label: this.model.get("quantity_field_label"),
                button_label: this.model.get("button_label"),
                footer_content: this.model.get("footer_content").replace("{product_name}", data.title),
                close_label: this.model.get("close_label"),
                is_powered_by_link: this.model.get("is_powered_by_link"),
                subscription_success_label: this.model.get("subscription_success_label").replace("{product_name}", data.title),
                styles: this.model.get("styles"),
                additional_styles: this.model.get("additional_styles"),
                theme: {
                    drop_background_color: this.model.get("drop_background_color"),
                    background_color: this.model.get("background_color"),
                    font_family: this.model.get("font_family"),
                    headers_font_family: this.model.get("headers_font_family"),
                    text_color: this.model.get("text_color"),
                    button_text_color: this.model.get("button_text_color"),
                    button_background_color: this.model.get("button_background_color"),
                    close_button_color: this.model.get("close_button_color"),
                    error_background_color: this.model.get("error_background_color"),
                    error_text_color: this.model.get("error_text_color"),
                    success_background_color: this.model.get("success_background_color"),
                    success_text_color: this.model.get("success_text_color")
                }
            });
            data = this.iframeDocument();
            data.open();
            data.write(fn);
            data.close();
            /**
             * @param {Event} event
             * @return {undefined}
             */
            fn = function (event) {
                if ($(event.target).hasClass("klaviyo-bis-close")) {
                    event.preventDefault();
                    poster.hide();
                }
            };
            $(data).find("body").on("click", _.bind(fn, this)).on("touchend", _.bind(fn, this)).find("form").on("submit", _.bind(this.validateAndSubmitForm, this));
            if (1 === length) {
                $(data).find("#variant_select").hide();
            } else {
                $(data).find('#variant_select option[value="' + oid.id + '"]').prop("selected", true);
            }
            if (!this.model.get("list")) {
                $(data).find("#newsletter_subscription").hide();
            }
        },
        /**
         * @param {Object} e
         * @return {undefined}
         */
        validateAndSubmitForm: function (e) {
            e.preventDefault();
            var that = this;
            var link = $(e.currentTarget);
            var layer = this.iframeDocument();
            e = $(layer).find("#email").val();
            var l = $(layer).find("#subscribe_for_newsletter").prop("checked") && "none" !== $(layer).find("#newsletter_subscription")[0].style.display;
            if (/@/.test(e)) {
                link.find("button").attr("disabled", true);
                this.hideErrorMessage();
                this.hideSuccessMessage();
                link = this.model.get("account");
                var r = this.model.get("list");
                var type = this.model.get("platform");
                layer = $(layer).find("#variants").val();
                $.ajax({
                    type: "POST",
                    url: "//" + this.model.get("api_hostname") + "/client/back-in-stock-subscriptions/?company_id=" + link,
                    headers: {
                        revision: "2024-02-15",
                        "Content-Type": "application/json",
                        "X-Klaviyo-Onsite": "1"
                    },
                    dataType: "json",
                    data: JSON.stringify({
                        data: {
                            type: "back-in-stock-subscription",
                            attributes: {
                                profile: {
                                    data: {
                                        type: "profile",
                                        attributes: {
                                            email: e
                                        }
                                    }
                                },
                                channels: ["EMAIL"]
                            },
                            relationships: {
                                variant: {
                                    data: {
                                        type: "catalog-variant",
                                        id: "$" + type + ":::$default:::" + layer
                                    }
                                }
                            }
                        }
                    }),
                    /**
                     * @param {string} textStatus
                     * @return {?}
                     */
                    success: function (textStatus) {
                        return that.onSubmitSuccess();
                    },
                    /**
                     * @param {string} textStatus
                     * @param {string} t
                     * @param {Function} data
                     * @return {?}
                     */
                    error: function (textStatus, t, data) {
                        return that.onSubmitFailure(data);
                    }
                });
                if (r) {
                    if (l) {
                        $.ajax({
                            type: "POST",
                            url: "//" + that.model.get("api_hostname") + "/client/subscriptions/?company_id=" + link,
                            headers: {
                                revision: "2024-02-15",
                                "Content-Type": "application/json",
                                "X-Klaviyo-Onsite": "1"
                            },
                            dataType: "json",
                            data: JSON.stringify({
                                data: {
                                    type: "subscription",
                                    attributes: {
                                        profile: {
                                            data: {
                                                type: "profile",
                                                attributes: {
                                                    email: e
                                                }
                                            }
                                        }
                                    },
                                    relationships: {
                                        list: {
                                            data: {
                                                type: "list",
                                                id: r
                                            }
                                        }
                                    }
                                }
                            }),
                            /**
                             * @param {string} textStatus
                             * @return {?}
                             */
                            success: function (textStatus) {
                                return that.onSubmitSuccess();
                            },
                            /**
                             * @param {string} textStatus
                             * @param {string} t
                             * @param {Function} data
                             * @return {?}
                             */
                            error: function (textStatus, t, data) {
                                return that.onSubmitFailure(data);
                            }
                        });
                    }
                }
            }
        },
        /**
         * @return {undefined}
         */
        onSubmitSuccess: function () {
            $(this.iframeDocument()).find("form").find("button").hide();
            this.showSuccessMessage();
        },
        /**
         * @param {Function} head
         * @return {undefined}
         */
        onSubmitFailure: function (head) {
            $(this.iframeDocument()).find("form").find("button").removeAttr("disabled");
            this.showErrorMessage(head);
        },
        /**
         * @return {undefined}
         */
        showSuccessMessage: function () {
            $(this.iframeDocument()).find("#completed_message").show();
            _.delay(_.bind(this.hide, this), 3E5);
        },
        /**
         * @return {undefined}
         */
        hideSuccessMessage: function () {
            $(this.iframeDocument()).find("#completed_message").hide();
        },
        /**
         * @param {Function} message
         * @return {undefined}
         */
        showErrorMessage: function (message) {
            $(this.iframeDocument()).find("#error_message").text(message).show();
        },
        /**
         * @return {undefined}
         */
        hideErrorMessage: function () {
            $(this.iframeDocument()).find("#error_message").hide();
        },
        /**
         * @return {undefined}
         */
        show: function () {
            this.$el.show();
            $(this.iframeDocument()).find("body").addClass("fadein").find('[name="email"]').focus();
        },
        /**
         * @return {undefined}
         */
        hide: function () {
            this.$el.hide();
            this.hideSuccessMessage();
            $(this.iframeDocument()).find("body").addClass("fadein");
        }
    });
    options.components = options.components || {};
    var collection = {
        /** @type {function (Object, string): ?} */
        backinstock: options.components.back_in_stock.create
    };
    options.components.Router = {
        _settings: {
            api_hostname: "a.klaviyo.com",
            logging: true,
            account: null,
            list: null,
            platform: null
        },
        _components: {},
        /**
         * @param {Object} parent
         * @return {undefined}
         */
        init: function (parent) {
            _.extend(this._settings, parent);
        },
        /**
         * @param {?} _args
         * @return {undefined}
         */
        logging: function (_args) {
            /** @type {boolean} */
            options.core.LOGGING_ENABLED = !!_args;
        },
        /**
         * @param {?} name
         * @param {?} options
         * @return {undefined}
         */
        enable: function (name, options) {
            if (!this._components[name]) {
                if (collection[name]) {
                    this._components[name] = collection[name](this._settings, options);
                }
            }
        }
    };
    var tasks = self.klaviyoBIS;
    if (!tasks || !tasks._initialized) {
        if (!_.isArray(tasks)) {
            /** @type {Array} */
            self.klaviyoBIS = [];
            /** @type {Array} */
            tasks = self.klaviyoBIS;
        }
        _.each(["init", "logging", "enable"], function (index) {
            /**
             * @return {?}
             */
            tasks[index] = function () {
                /** @type {Array.<?>} */
                var paths = [].slice.call(arguments);
                return tasks.push([index].concat(paths));
            };
        });
        try {
            self._klOnsite = self._klOnsite || [];
            self.klaviyo = new Proxy({}, {
                /**
                 * @param {string} name
                 * @param {string} key
                 * @return {?}
                 */
                get: function (name, key) {
                    return function (dataAndEvents) {
                        /** @type {Array} */
                        var args = [];
                        /** @type {number} */
                        var i = 0;
                        for (; i < arguments.length; ++i) {
                            args[i - 0] = arguments[i];
                        }
                        if ("push" === key) {
                            self._klOnsite.push.apply(self._klOnsite, $jscomp.arrayFromIterable(args));
                        } else {
                            if ("init" === key || ("enable" === key || "logging" === key)) {
                                self.klaviyoBIS[key].apply(null, args);
                            } else {
                                var lookupIterator = "function" === typeof args[args.length - 1] ? args.pop() : void 0;
                                return new Promise(function ($sanitize) {
                                    self._klOnsite.push([key].concat($jscomp.arrayFromIterable(args), [function (value) {
                                        if (lookupIterator) {
                                            lookupIterator(value);
                                        }
                                        $sanitize(value);
                                    }]));
                                });
                            }
                        }
                    };
                }
            });
        } catch (c) {
            self.klaviyo = {};
            /**
             * @param {Array} dataAndEvents
             * @return {?}
             */
            self.klaviyo.init = function (dataAndEvents) {
                /** @type {Array} */
                var newArgs = [];
                /** @type {number} */
                var i = 0;
                for (; i < arguments.length; ++i) {
                    newArgs[i - 0] = arguments[i];
                }
                return self.klaviyoBIS.init.apply(null, newArgs);
            };
            /**
             * @param {?} className
             * @return {?}
             */
            self.klaviyo.enable = function (className) {
                /** @type {Array} */
                var newArgs = [];
                /** @type {number} */
                var i = 0;
                for (; i < arguments.length; ++i) {
                    newArgs[i - 0] = arguments[i];
                }
                return self.klaviyoBIS.enable.apply(null, newArgs);
            };
            /**
             * @param {?} _args
             * @return {?}
             */
            self.klaviyo.logging = function (_args) {
                /** @type {Array} */
                var newArgs = [];
                /** @type {number} */
                var i = 0;
                for (; i < arguments.length; ++i) {
                    newArgs[i - 0] = arguments[i];
                }
                return self.klaviyoBIS.logging.apply(null, newArgs);
            };
        }
        jQuery(function (log) {
            options.core.log("Initializing.");
            /**
             * @param {?} obj
             * @return {?}
             */
            log = function (obj) {
                options.core.log("Executing: " + obj[0]);
                if (_.isArray(obj) && (obj && options.components.Router[obj[0]])) {
                    return options.components.Router[obj[0]].apply(options.components.Router, obj.slice(1));
                }
            };
            for (; tasks.length;) {
                log(tasks.shift());
            }
            /** @type {Function} */
            tasks.push = log;
            /** @type {boolean} */
            tasks._initialized = true;
        });
    }
})(window);
